/* eslint-disable i18n/no-russian-character */
const ruPages = {
    accessFeatures: {
        title: "Доступы",
        edit: "Редактировать доступ",
        create: "Создать доступ",
        delete: "Удалить доступ",
        insertRolesOrUsers: "Выберите роли или пользователей",
        success: {
            save: 'Доступ "%s" успешно сохранен',
        },
        menu: {
            title: "Меню",
        },
        access: {
            title: "Доступы",
            noData: "нет доступов",
        },
        categories: {
            title: "Категории",
            fields: {
                id: "ID",
                title: "Название",
                name: "Системное имя",
            },
        },
        users: {
            title: "Пользователи",
        },
        roles: {
            title: "Роли",
            fields: {
                accessFeatures: "Доступы",
            },
        },
        innerName: "Внутреннее наименование",
    },
    analytics: {
        totalPrice: "Сумма",
        cnt: "шт.",
        rub: "руб.",
        tradePointTitle: "Кофейня",
        ratingTitle: "Рейтинг по выборке",
        analyticsIndicator: "Индикатор сравнения",
        filter: {
            date: {
                title: "Дата",
            },
            dateStart: "Начало периода",
            dateEnd: "Конец периода",
            previousDateStart: "Начало предыдущего периода",
            previousDateEnd: "Конец предыдущего периода",
            tradePointsIds: "Кофейни",
            showButton: "Показать",
            order: {
                title: "Сортировка",
                alphaAsc: "От А до Я",
                alphaDesc: "От Я до А",
                rateAsc: "От лучших к худшим",
                rateDesc: "От худших к лучшим",
                dateAsc: "От старых к новым",
                dateDesc: "От новых к старым",
            },
            search: {
                title: "Поиск",
            },
        },
        proceedsSum: {
            title: "Выручка",
            unit: "%p#rubs#",
        },
        averageCheckSum: {
            title: "Средний чек",
            unit: "%p#rubs#",
        },
        receiptsQuantity: {
            title: "Количество чеков",
            unit: "%p#receipts#",
        },
        okkComplaintsCount: {
            title: "Количество жалоб",
            unit: "%p#complaints#",
            currentValuesTitle: "Количество жалоб за текущий период",
            previousValuesTitle: "Количество жалоб за предыдущий период",
            chartTitle: "Жалобы за текущий период",
            previousChartTitle: "Жалобы за предыдущий период",
            chartUnit: "кол-во",
        },
        okkGratitudesCount: {
            title: "Количество благодарностей",
            unit: "%p#complaints#",
            currentValuesTitle: "Количество благодарностей за текущий период",
            previousValuesTitle: "Количество благодарностей за предыдущий период",
            chartTitle: "Благодарности за текущий период",
            previousChartTitle: "Благодарности за предыдущий период",
            chartUnit: "кол-во",
        },
        okkComplaintsCategoriesPercentage: {
            title: "Категории обращений гостей",
            unit: "%",
            valuesTitle: "Процентное соотношение категорий за текущий период",
            previousValuesTitle: "Процентное соотношение категорий за предыдущий период",
        },
        okkComplaintStatusLog: {
            title: "Отчет по статусам обращений",
            complaintId: "Идентификатор обращений",
            tradePointName: "Кофейня",
            inspector: "Проверяющий",
            complaint: "Обращение",
            inWorkTime: 'Общее время в статусе "В работе"',
            waitSolutionTime: 'Общее время в статусе "Ожидает решения"',
        },
        qualityControl: {
            title: "Баллы несоответствия – общие",
            unit: "%p#scores#",
            onlyBad: "Только кофейни с нарушениями",
            subUnit: "%p#offences#",
        },
        technicalQualityControl: {
            title: "Баллы несоответствия – тех.состояние",
            unit: "%p#scores#",
            onlyBad: "Только кофейни с нарушениями",
            subUnit: "%p#offences#",
        },
        discrepancyIndex: {
            title: "Индекс несоответствия",
            unit: "%",
            onlyBad: "Только с превышением порога",
            subUnits: ["%p#scores#", "%p#receipts#"],
        },
        markingsReport: {
            title: "Отчет по маркировкам",
            markingName: "Маркировка",
            tradePoint: "Кофейня",
            createdAt: "Изготовлено",
            sellBy: "Годен до",
            rePrint: "Повторная печать",
            startDate: "Начало периода",
            endDate: "Конец периода",
            search: "Маркировка",
            count: "Количество",
            errors: {
                getTradePointsError: "Не удалось получить кофейни для формирования отчета",
                getReportError: "Не удалось получить данные для формирования отчета",
            },
        },
        mobileApp: {
            title: "Мобильное приложение",
            unit: "",
            onlyBad: "Только плохие ( оценка < 4.78 )",
            subUnit: "%p#feedback#",
            percentTooltip: "(% оцененных заказов)",
            percent: "(%p% оцененных заказов)",
        },
        writeOffActs: {
            title: "Акты списания",
            unit: "%p#acts#",
        },
        writeOff: {
            title: "Списание",
        },
        tradePoint: {
            from: "от",
            proceedsSum: {
                title: "Аналитика по выручке",
                unit: "%p#rubs#",
                subUnit: "",
            },
            feedbackIndexes: {
                thanksCategory: "Благодарность",
                focusCheckCategory: "Фокус месяца - проверки",
                title: "Индексы обратной связи",
                gratitudeIndex: "Индекс благодарностей",
                complaintIndex: "Индекс жалоб",
                noRecords: "Данные еще не загружены. Попробуйте немного позже",
            },
            averageCheckSum: {
                title: "Аналитика по чекам",
                unit: "%p#rubs#",
                subUnit: "%p#receipts#",
            },
            receiptsQuantity: {
                title: "Аналитика по чекам",
                unit: "%p#rubs#",
                subUnit: "%p#receipts#",
            },
            complaintIndex: {
                title: "Аналитика по обращениям",
                unit: "%p#scores#",
                subUnit: "%p#offences#",
                mobileAppDate: "отзыв",
                description: "Описание",
                complaintType: "Обращения",
                complaintType0: "Все",
                complaintType1: "С нарушениями",
                complaintType2: "Для расчёта индекса",
            },
            qualityControl: {
                title: "Аналитика по обращениям",
                unit: "%p#scores#",
                subUnit: "%p#offences#",
            },
            technicalQualityControl: {
                title: "Аналитика по обращениям - тех. состояние",
                unit: "%p#scores#",
                subUnit: "%p#offences#",
            },
            mobileApp: {
                title: "Аналитика мобильного приложения",
                unit: "%p#scores#",
                orderNumber: "Заказ №",
                comment: "Комментарий",
                onlyBad: "Только плохие ( оценка < 3 )",
                search: "Телефон / Имя гостя / Номер заказа",
                searchManager: "Номер заказа",
                loading: "Идет получение дополнительной информации. Подождите",
                orderDetails: {
                    title: "Подробности отзыва",
                    orderNumber: "Номер заказа",
                    createdDate: "Дата отзыва",
                    clientName: "Имя гостя",
                    userPhone: "Номер гостя",
                    userComment: "Отзыв",
                    dishes: "Позиции",
                },
            },
            checkList: {
                title: "Аналитика чек-листов",
                unit: "%",
                onlyBad: "Только плохие листы ( процент < 30% )",
                passed: "Пройден",
                notPassed: "Не пройден",
            },
            cln: {
                title: "Аналитика КЛН",
                unit: "%",
                onlyBad: "Только плохие листы ( процент < 30% )",
            },
        },
        tradePointDashboard: {
            title: "Общая аналитика по кофейне",
            filter: {
                date: "Дата",
                tradePoint: "Кофейня",
            },
            tooltips: {
                rating: "Рейтинг, относительно других кофеен",
                value: "Детально",
                primary: "Как в предыдущем месяце",
                success: "Лучше чем в предыдущем месяце",
                error: "Хуже чем в предыдущем месяце",
            },
            ratingSuffix: "-ая",
        },
    },

    appChecklist: {
        title: "Приложение для Чек-листов",
        add: {
            fields: {
                version: "Номер версии",
                description: "Описание",
                file: "APK файл",
            },
        },
        addTitle: "Добавить новую версию",
        fields: {
            version: "Номер версии",
            id: "ID",
            isActive: "Активная",
            imageId: "Скачать",
        },
        setActive: 'Установить версию "%s" в качестве активной?',
    },
    cities: {
        listTitle: "Список городов",
        editTitle: "Редактирование города",
        addTitle: "Добавление города",
        fields: {
            name: "Название",
            code: "Код города",
            timeZone: "Временная зона",
            region: "Регион",
        },
    },
    clients: {
        bonus: {
            title: "Бонусные баллы",
            titleGroup: "Бонусные баллы массово",
            clear: "Сброс",
            phonesCount: "Внесено: %p#numbers#",
            onlyProduction: "Функционал доступен только на основном сервере!",
            fields: {
                phone: "Номер телефона",
                phones: "Номер телефонов",
                phonesHelp: "Одна строка - один номер. 79000000000",
                bonus: "Кол-во баллов",
                categoryId: "Статья",
                description: "Комментарий",
                startDate: "Дата мероприятия",
                department: "Инициатор/отдел",
                number: "Номер сертификата",
                type: "Тип пополнения",
            },
            result: {
                sum: "на сумму",
                isOk: "Начислено гостям",
                isNotOk: "Не удалось начислить",
            },
            errors: {
                addBonuses: "Не удалось начислить бонусные баллы гостю!",
                phonesLength: "Укажите корректные номера телефонов",
            },
            success: {
                addBonuses: "Бонусные баллы начислены",
                setBonuses: "Бонусные баллы начислены %s гостям на сумму %s бонусов",
            },
        },
    },
    cfCustomerTypes: {
        title: "Сопоставление поставщиков с типами поставщиков для ФК",
        noRecordsText: "Нет данных",
        supplierType: "Тип поставщика",
        supplier: "Поставщик",
        errors: {
            getData: "Не удалось получить данные",
            save: "При сохранении произошла ошибка",
        },
        success: {
            save: "Сохранение прошло успешно",
        },
        save: "Сохранить",
    },
    cookFactory: {
        buyers: {
            title: "Заказ от торгового представителя",
            buyer: "Контрагент",
            buyerPlaceholder: "Выберите контрагента",
            address: "Адрес торговой точки",
            errors: {
                getOrders: "Не удалось получить заказы!",
                noAddresses: "Нет адресов для выбора",
            },
        },
        orders: {
            noOrders: "Нет заказов",
            statuses: {
                canceled: "Отменен",
                inProgress: "В работе",
            },
            order: {
                addTitle: "Новый заказ",
                title: "Редактировать заказ",
                order: "Заказ",
                goods: "Товары",
                newStatus: "Новый заказ",
                createOrder: "Заказать",
                canceledOrder: "Отменить",
                buttons: {
                    sendToIiko: "Накладная",
                },
                noRecordsText: "Нет накладных",
                fields: {
                    supplier: "Поставщик",
                    orderDate: "Дата поставки",
                    orderNumber: "Номер заказа",
                    address: "Адрес торговой точки",
                    status: "Статус",
                    user: "Пользователь",
                    name: "Продукт",
                    measureName: "ед. изм.",
                    quantity: "Кол-во",
                    amount: "Сумма заказа",
                    price: "Цена",
                    totalPrice: "Сумма",
                    stopList: "Наличие",
                    stopList0: "В стоп-листе",
                    stopList1: "Доступен",
                    invoice: "Счет",
                    collected: "Собран",
                    notCollected: "Не собран",
                    notCollectedItems: "Не собранные товары",
                },
                actions: {
                    show: "Просмотр заказа",
                    delete: "Удалить заказ",
                    edit: "Изменить заказ",
                    invoice1: "Сформировать счет на оплату",
                    invoice2: "Скачать счет на оплату",
                },
                success: {
                    createTradePointOrder: "Заказ создан",
                    updateTradePointOrder: "Заказ изменен",
                },
                errors: {
                    getTradePointOrder: "Не удалось получить информацию о заказе!",
                    getTradePointPrice: "Не удалось получить список товаров!",
                    createTradePointOrder: "Не удалось создать заказ!",
                    updateTradePointOrder: "Не удалось изменить заказ!",
                    isModify: "Данный заказ не доступен для редактирования!",
                    emptyGoods: "Необходимо выбрать хотя бы один товар!",
                    goodsNotAvailable: "Не все товары доступны для заказа!",
                    orderDateNotAvailable: "Нет возможности доставить заказ %s!",
                    orderInvoice: "Не удалось получить счет на оплату!",
                    getOrder: "Не удалось получить заказ, попробуйте обновить страницу",
                    emptyProductList: "Для данного поставщика не найдено ни одного товара",
                    notSelectSupplier: "Выберите поставщика",
                },
            },
            deleteConfirm: {
                title: "Удалить заказ",
                text: "Вы уверены, что хотите удалить заказ №%s на %s?",
                okText: "Да, удалить",
            },
            fields: {
                createDate: "Дата создания",
                status: "Статус",
                amount: "Сумма заказа",
                user: "Пользователь",
                orderDate: "Дата поставки",
                orderNumber: "Номер заказа",
                actions: "Действия",
                price: "Цена",
                totalPrice: "Сумма",
            },
            actions: {
                show: "Просмотр заказа",
                notAllCollected: "Не все товары собраны",
                delete: "Удалить заказ",
                edit: "Изменить заказ",
                send: "Отправить накладную в iiko",
            },
            success: {
                deleteTradePointOrder: "Заказ удален",
            },
            errors: {
                getTradePointOrders: "Не удалось получить список заказов!",
                deleteTradePointOrder: "Не удалось удалить заказ!",
                noTradePoints: "У вас нет доступных кофеен",
            },
        },
        personal: {
            title: "Мои заказы с фабрики кухни",
            showTitle: "Просмотр заказа",
            officeTradePointName: "Офис УК",
            tradePointFilter: "Место поставки",
        },
        tradePoints: {
            title: "Заказы для кофейни с фабрики кухни",
            showTitle: "Просмотр заказа",
            unavailableTradePoint: "Данное действие не доступна для данной кофейни",
        },
        iikoChecker: {
            code: "Укажите ваш табельный номер в Iiko",
            description:
                "Если вы знаете свой табельный номер - можете его указать. Если вы не знаете его, обратитесь к вашему менеджеру или в отдел по работе с персоналом",
            success: {
                checkIikoUserNewCode: "табельный номер добавлен к вашему профилю",
            },
            errors: {
                iikoUserCode: "Ваш табельный номер не внесен в базу портала.",
                checkIikoUserCode: "Не удалось получить Данные о пользователе в Iiko!",
                checkIikoUserNewCode: "Не удалось проверить данный табельный номер в Iiko!",
            },
        },
        hs: {
            title: "Заявки на оплату",
            addTitle: "Создать заявку",
            innSearch: "Поиск по ИНН",
            inn: "ИНН",
            bankAccountSuffix: "Последние 4 цифры счета",
            date: "Дата",
            number: "Номер счета",
            amount: "Сумма",
            depart: "ЦФО",
            org: "Организация",
            client: "Контрагент",
            purposeOfPayment: "Назначение платежа",
            budgetItem: "Статья бюджета",
            file: "Документ с обоснованием",
            success: {
                addPayment: "Заявка на оплату успешно создана",
            },
            errors: {
                loadData: "Не удалось получить данные о заявках!",
            },
        },
    },
    courses: {
        title: "Список курсов",
        addTitle: "Новый курс",
        editTitle: "Редактировать курс",
        fields: {
            title: "Курс",
            image: "Фото",
            description: "Описание",
        },
        success: {
            remove: "Курсы удалены",
        },
        errors: {
            loadData: "Ошибка при получении списка курсов!",
            remove: "Не удалось удалить курс!",
        },
        users: {
            add: "Добавить сотрудников",
            title: "Сотрудники",
            fields: {
                course: "Курс",
                user: "Сотрудник",
                tradePoint: "Кофейня",
                role: "Роль",
                passDate: "Дата прохождения",
            },
            status: "Сотрудники",
            status0: "Те кто не прошел",
            status1: "Те кто прошел",
            users: "Участники",
            saved: "Добавлено %s сотрудников",
            errors: {
                courseUsers: "Не удалось получить список сотрудников!",
                courseUsersAdd: "Не удалось сохранить данные на сервере",
            },
        },
    },
    dashboard: {
        title: "Дашборды",
        loading: "Загрузка...",
        noData: "Нет данных для отображения",
        fullScreen: "На весь экран",
        selector: "Выберите дашборд",
        zoom: "Zoom",
        tradePointTitle: "Дашборд кофейни",
        config: {
            title: "Настройка Дашборды",
            dashboard: "Дашборд",
            dashboardElement: "Элементы дашборда",
        },
        fields: {
            name: "Название",
            type: "Тип",
            url: "Ссылка",
            order: "Порядок",
            dashboardId: "Дашборд",
            displayDuration: "период обновления (в сек.)",
            description: "Описание",
        },
    },
    goList: {
        pageTitle: "Го-лист",
        fields: {
            target: "Целевое значение %",
            product: "Продукт",
        },
        buttons: {
            addRow: "Добавить",
            delete: "Удалить строку",
            save: "Сохранить строку",
        },
        errors: {
            load: "Ошибка при загрузке данных",
            delete: "Ошибка при удалении",
            save: "Ошибка при сохранении",
            productRequired: "Выберите продукт",
            invalidTarget: "Введите корректное целевое значение",
        },
        success: {
            saved: "Сохранено",
            deleted: "Удалено",
        },
    },
    huntflow: {
        title: "Кадровые процессы",
        mobileOnly: "Мобильная версия доступна только на устройствах с маленьким экраном",
        coffeeShop: "Кофейня",
        swipeHint: "Свайп влево = отклонить, Свайп вправо = принять",
        noApplicantsTitle: "Нет соискателей",
        noApplicantsText: "Все соискатели обработаны или нет новых заявок",
        chooseTradePointTitle: "Выберите кофейню",
        chooseTradePointText: "Для начала работы выберите кофейню из списка выше",
        rejectAction: "Отклонить",
        rejectReasonTitle: "Причина отказа",
        rejectReasonPlaceholder: "Укажите причину (необязательно)",
        openTelegram: "Открыть в Telegram",
        openWhatsApp: "Открыть в WhatsApp",
        sendEmail: "Отправить email",
        clickForDetails: "Нажмите для подробностей",
        resume: "Резюме",
        loadingResume: "Загрузка резюме…",
        education: "Образование",
        skills: "Навыки",
        lastPlace: "Последнее место",
        resumeUpdated: "Резюме обновлено",
        resumeNotFound: "Резюме не найдено или недоступно",
        additionalInformation: "Дополнительная информация",
        gender: "Пол",
        businessTripReadiness: "Командировки",
        travelTime: "Время в пути",
        contacts: "Контакты",
        age: "Возраст",
        years: "лет",
        months: "мес.",
        experience: "Опыт",
        level: "Уровень",
        desiredSalary: "Желаемая зарплата",
        currentSalary: "Текущая зарплата",
        faculty: "Факультет",
        organization: "Организация",
        year: "Год",
        period: "Период",
        verified: "Проверен",
        notSpecified: "Не указано",
        email: "почта",
        phone: "телефон",
        telegram: "телеграм",
        contact: "Контакт",
        call: "Позвонить",
        now: "по настоящее время",
        positionNotSpecified: "Позиция не указана",
        night: "Ночь",
        day: "День",
        cancel: "Отмена",
        statuses: {
            interview: "Интервью с заказчиком",
            waitingForInterview: "Назначено интервью",
            offer: "Оффер",
            rejected: "Отказ",
            movedComment: "Перемещено с доски портала",
            errorUpdateStatus: "Не удалось изменить статус",
            cannotMoveToOffer: "Сначала назначьте интервью кандидату",
            errorUpdateToken: "Ошибка обновления токена Huntflow",
            errorUpdateApplicants: "Не удалось загрузить кандидатов Huntflow",
            errorUpdateResume: "Не удалось загрузить резюме кандидата",
            cannotMoveToRejectedForManagers: 'Недоступно из статуса "Оффер принят" для менеджеров',
        },
        createAccount: {
            title: "Создать учётную запись",
            fullFormTitle: "Данные сотрудника",
            nextBtn: "Далее",
            userExists: "Пользователь с такими данными уже существует в системе",
            noTradePoint: "Выберите кофейню",
            savingToHuntflow: "Сохранение в Huntflow…",
            vacancy: "Вакансия",
            workShift: "График",
        },
    },
    departments: {
        title: "Структурные подразделения",
        addTitle: "Новое подразделение",
        editTitle: "Редактировать подразделение",
        deleteConfirm: {
            title: "Удалить подразделение",
            text: 'Вы хотите удалить подразделение "%s"',
            okText: "Да, удалить",
        },
        fields: {
            title: "Название",
            parentId: "Родитель",
            tradePointId: "Кофейня",
            legalPersonId: "Юр. лицо",
        },
        errors: {
            getRecord: "Ошибка при получении данных!",
            save: "Ошибка при сохранении данных!",
            clearLegalPerson: "Нельзя удалить подразделение, т.к. оно связано с Юр. лицом",
            clearTradePoint: "Нельзя удалить подразделение, т.к. оно связано с кофейней",
            clearText: "Удалите зависимости, если хотите удалить подразделение",
            delete: "Ошибка при удалении подразделения!",
        },
        success: {
            save: "Данные сохранены",
        },
    },
    documents: {
        my: {
            title: "Мои документы",
            editTitle: "Редактировать документ",
            fields: {
                title: "Документ",
                createdDate: "Дата создания",
                updatedDate: "Дата последнего изменения",
                description: "Описание",
            },
            steps: {
                viewTitle: "Просмотр документа",
                editTitle: "Редактировать документ",
                main: "Документ",
                history: "История согласований",
                statusDescription: "Комментарий",
                confirm: {
                    title: "Согласование документа",
                    confirm: "Согласовано",
                    confirmText: 'Вы ходите согласовать документ "%s"?',
                    confirmOkText: "Да, согласовать",
                    notConfirmOkText: "Да, Не согласовано",
                    notConfirm: "Не согласовано",
                    notConfirmText:
                        'Вы уверены, что ходите пометить документ "%s" как "Не согласованный"?',
                },
                edit: {
                    title: "Сохранить документ",
                    okText: "Да, сохранить",
                    text: 'Вы ходите сохранить документ "%s"?',
                    save: "Сохранить",
                },
                actions: {
                    show: "Просмотр",
                    edit: "Внести информацию",
                    confirm: "Подтвердить документ",
                    toEdit: "Назад",
                    toFinish: "Отправить документ",
                    goToChangeProblem: "Исправить ошибки",
                    haveProblems: "У вас есть ошибки в документе",
                },
                success: {
                    finish: "Вы закончили заполнение документа",
                    finishWithError:
                        "Вы закончили заполнение документа, но в нем имеются ошибки. Проверьте описание заполненного документа",
                    confirm: 'Документ "%s" согласован',
                    notConfirm: 'Документ "%s" помечен как Несогласован',
                    saveAnswer: "Ответ изменен",
                },
                errors: {
                    finish: "Не удалось закончить заполнение документа!",
                    confirm: "Не удалось подтвердить документ!",
                    saveAnswer: "Не удалось отредактировать ответ!",
                },
            },
            history: {
                createdUser: "Кто",
                prevStatus: "Предыдущий статус",
                status: "Новый статус",
                description: "Комментарий",
            },
        },
        list: {
            title: "Все документы",
            number: "Номер документа",
            date1: "Дата выдачи/Дата заключения",
            date2: "Дата рождения/Дата прохождения сан. минимума",
            haveProblems: "Есть ошибки",
        },
        check: {
            title: "Документы на проверку",
            showClear: "Показывать не заполненные документы",
        },
        warnings: {
            title: "Есть проблемы",
        },
        templates: {
            title: "Шаблоны документов пользователей",
            editTitle: "Редактировать шаблон",
            addTitle: "Новый шаблон",
            userRoleFlag: "Роли пользователей",
            tabs: {
                main: "Основное",
                fields: "Поля документа",
            },
            success: {
                edit: "Шаблон изменен",
                add: "Создан новый шаблон",
                saveFieldEdit: "Поле %s изменено",
                saveFieldAdd: "Добавлено новое поле: %s",
                saveFieldsOrder: "Порядок полей изменен",
                removeField: "Удалено поле: %s",
            },
            errors: {
                getRecord: "Не удалось получить информацию о шаблоне!",
                save: "Не удалось отредактировать шаблон!",
                saveField: "Не удалось отредактировать поле %s!",
                saveFieldsOrder: "Не удалось изменить порядок полей!",
                removeField: "Не удалось удалить поле: %s",
            },
            questions: {
                addTitle: "Новое поле документа",
                editTitle: "Редактировать вопрос",
                isDragEnabled: "Сортировка вопросов",
                saveOrder: "Сохранить порядок вопросов",
            },
        },
        templateTypes: {
            title: "Типы шаблонов документов",
            editTitle: "Редактировать тип",
            addTitle: "Новый тип",
            tabs: {
                main: "Основное",
                processing: "Согласование",
            },
            processings: {
                title: "Настройка согласования",
                saveChanges: "Сохранить изменения",
                fields: {
                    action: "Действие",
                    userType: "Кто совершает",
                    nextStatus: "Новый статус",
                    errorStatus: "Статус если не согласовано",
                },
                errors: {
                    noRecords: "Укажите параметры для согласования",
                    notCreatedCount: 'Ожидается 1 запись со статусом "Новый", найдено: %s.',
                    successCount: 'Ожидается хотя бы 1 запись со статусом "Подтвержден".',
                    sequence:
                        "Нарушена последовательность. Для записи ID=%s с новым статусом = %s не найден Статус.",
                },
            },
            success: {
                edit: "Тип изменен",
                add: "Создан новый тип",
            },
            errors: {
                getRecord: "Не удалось получить информацию о типе шаблона!",
                save: "Не удалось отредактировать тип шаблона!",
                saveProcessings: "Не удалось отредактировать согласования для шаблона!",
            },
        },
    },
    equipmentRegister: {
        add: {
            title: "Новая запись",
            text: "Что хотите добавить?",
            type: "Тип оборудования",
            equipment: "Оборудование/Инвентарь",
        },
        remove: {
            titleEquipment: "Удалить оборудование",
            titleType: "Удалить тип оборудования",
            textEquipment: 'Вы хотите удалить оборудование "%s"?',
            textType: 'Вы хотите удалить тип оборудование "%s"?',
            okText: "Да, удалить",
        },
        success: {
            removeType: 'Тип "%s" удален',
            removeEquipment: 'Оборудование "%s" удалено',
        },
        errors: {
            checkParents: "У данного типа есть вложенные элементы. Удалите сначала их!",
            removeType: "Не удалось удалить тип!",
            removeEquipment: "Не удалось удалить оборудование!",
        },
    },
    externalResources: {
        changePassword: "Смените пароль",
        admin: {
            title: "Внешние сервисы",
            fields: {
                accessFeatures: "Уникальные доступы",
                category: "Категория",
                login: "Логин",
                url: "Ссылка на внешний сервис",
                passwordStatus: "Статус пароля",
            },
        },
        categories: {
            title: "Категории внешних сервисов",
        },
        accesses: {
            create: "Подать заявку",
            update: "Редактирование заявки",
            details: "Данные для авторизации",
            noRecordsText: "Нет доступов",
            noRecordsLink: "Запросить доступ",
            admin: {
                title: "Заявки на получение доступа",
                approve: {
                    title: "Подтверждение заявки",
                    text: "Вы уверены, что хотите подтвердить %s заявок?",
                    okText: "Да, подтвердить",
                },
            },
            user: {
                title: "Мои доступы",
                button: {
                    request: "Запросить доступ",
                    show: "Показать данные",
                },
                clipboard: {
                    password: "Пароль скопирован в буфер обмена",
                    login: "Логин скопирован в буфер обмена",
                    url: "Ссылка скопирована в буфер обмена",
                },
            },
            fields: {
                adminComment: "Комментарий администратора",
                userComment: "Комментарий пользователя",
                status: "Статус",
                title: "Сервис",
                user: "Пользователь",
                login: "Логин для входа",
                description: "Дополнительная информация",
                url: "Ссылка на внешний сервис",
                requestMode: "Режим подачи заявки",
            },
            errors: {
                createMessage: "Не удалось создать заявку",
                updateMessage: "Не удалось обновить заявку",
                approveMessage: "Не удалось подтвердить заявки на получение доступа",
            },
            success: {
                createMessage: "Заявка создана",
                updateMessage: "Заявка обновлена",
                approveMessage: "Заявки на получение доступа подтверждены: %s шт.",
            },
        },
    },
    fileShare: {
        title: "Файлы",
        toMain: "В корневую папку",
        viewType: {
            title: "Вид",
            grid: "Список",
            table: "Таблица",
        },
        config: {
            title: "Настройки",
            roles: {
                title: "Доступы по ролям",
                fields: {
                    roleId: "Роль",
                    folders: "Папки",
                },
                success: {
                    updateRole: "Доступ для роли изменен",
                },
                errors: {
                    updateRole: "Не получилось обновить роль!",
                },
            },
            accessFeatures: {
                title: "Уникальные доступы",
                fields: {
                    accessFeatureId: "Доступ",
                    folders: "Папки",
                },
                success: {
                    updateAccessFeature: "Доступ изменен",
                },
                errors: {
                    updateAccessFeature: "Не получилось обновить доступ!",
                },
            },
            linkManager: {
                title: "Управление ссылками",
                fields: {
                    folder: "Папка",
                    link: "ссылка",
                    createdUser: "Создатель",
                    createdDate: "Дата",
                    uid: "ID",
                },
            },
        },

        folderLink: {
            title: "Доступ по ссылке",
            getFolderLinkData: "Нет доступа",
        },
        errors: {
            noFolders: "Нет доступных для отображения папок",
        },
    },
    gpt: {
        title: "GPT чат",
        placeholder: "Введите сообщение...",
        loadingFiles: "Загрузка файлов...",
        clear: "Очистить чат",
        deleteChat: "Удалить чат",
        copied: "Скопировано",
        toCopy: "Копировать",
        typing: "Печатает...",
        filesReadyToAttach: "Файлы готовы к отправке",
        historySaved: "История сохранена",
        historyError: "Ошибка при работе с историей",
        newChat: "Новый чат",
        newChatTitle: "Создание нового чата",
        chatName: "Название чата",
        chatSelection: "Выбор чата",
        chooseModel: "Выберите модель",
        tokensRemaining: "Осталось токенов",
        modelSettings: "Настройки модели",
        selectAgent: "Выберите агента для редактирования",
        accessFeatureForAgent: "Уникальный доступ для агента",
        agent: "Агент",
        file: "Файл",
        agentName: "Имя агента",
        unknownAgent: "Неизвестный агент",
        systemPrompt: "Системный промпт",
        dropzoneInstruction: "Перетащите файлы сюда или нажмите «Добавить файлы»",
        uploadFile: "Загрузить файл",
        addFiles: "Добавить файлы",
        attachedFiles: "Прикрепленные файлы",
        createAgent: "Создать агента",
        deleteAgent: "Удалить агента",
        createNameAgent: "Пожалуйста, укажите имя агента",
        confirmDeleteAgent: "Вы уверены, что хотите удалить агента",
        selectModel: "Выбор модели",
        temperature: "Температура",
        maxTokens: "Макс. токенов",
        noLimits: "Без ограничений",
        accessFeatureForAgentTooltip: "Если оставить пустым, то агент будет доступен только вам",
        uploaded: "Загружено",
        regenerate: "Перегенерировать",
        clearAllFiles: "Очистить все файлы",
        saving: "Сохранение...",
        webSearch: "Поиск в интернете",
        descriptionRegenerate:
            "Опишите, что именно не так с текущим результатом. Это поможет модели сгенерировать более подходящий ответ.",
        placeholderRegenerate:
            "Например: ответ слишком формальный, нужно быть более дружелюбным...",
        errors: {
            copy: "Не удалось скопировать текст",
            fileNotSupported: "не поддерживается и будет проигнорирован.",
            fileError: "Ошибка при обработке файла",
            saveAgentError: "Ошибка при сохранении агента",
            errorFromGpt: "Ошибка при применении данных GPT",
            fileNotFound: "Файл не найден",
            loadAgentsError: "Ошибка при загрузке агентов",
            complaintError: "Ошибка при загрузке данных жалобы",
        },
        kuku: {
            title: "GPT Ку́Ку",
            complaintData: "Данные жалобы для анализа",
            analysisResults: "Результаты анализа GPT",
            loading: "Загрузка данных...",
            analysisSuccess: "Анализ жалобы успешно завершен",
            analysisError: "Ошибка при анализе жалобы",
            backToClaims: "Назад к жалобе",
            applyResults: "Применить результаты",
            updatedFields: "Обновлено",
            fields: {
                complaintId: "ID жалобы",
                tradePoint: "Торговая точка",
                category: "Категория",
                status: "Статус",
                dateTime: "Дата и время",
                clientName: "Имя клиента",
                complaintDescription: "Описание жалобы",
                regenerate: "Перегенерировать",
                sourceType: "Источник обращения",
                mark: "Оценка",
                positions: "Позиции",
            },
            actionTypes: {
                managerResponse: "Ответ менеджеру",
                guestResponse: "Ответ гостю",
                bonusCompensation: "Компенсация",
                tagAssignment: "Тэг",
                categoryClassification: "Категория",
            },
            noData: "Данные не получены",
            processing: "Обработка...",
            waitingResponse: "Ожидание ответа...",
            fullReanalysis: "Полный переанализ",
        },
        maxCountFiles: "Максимальное количество файлов",
        filesIgnored: "Остальные файлы будут проигнорированы.",
        saveAgentError: "Ошибка при сохранении агента",
    },
    home: {
        title: "Главная страница",
        admin: {
            title: "Главная",
        },
        inspector: {
            title: "Главная",
            links: {
                claims: "Обращения",
                claims2: "Обращения второй линии",
                clientInfo: "Гости",
            },
        },
        manager: {
            title: "Ваши сотрудники",
            addUser: "Добавить сотрудника",
            learningManagement: "Обучение",
            warningIsLoading: "Загрузка...",
        },
        terDir: {
            title: "Ваши кофейни",
            checkerTitle: "Введите основную информацию о пользователе",
            addUser: "Добавить сотрудника",
            learningManagement: "Обучение",
            errors: {
                loadData: "Ошибка при получении данных от сервера",
            },
        },
        tradePointWarnings: {
            title: "%p#employees# имеют проблемы",
        },
        usersList: {
            lastVisitDate: "Последний вход",
        },
    },
    ingredientsRegistry: {
        common: {
            unaccept: "Отменить принятие",
            accept: "Принять",
            accepted: "Принято",
            add: "Добавить",
            cancel: "Отменить",
            description: "Описание",
            delete: "Удалить",
            ok: "Ok",
            save: "Сохранить",
            edit: "Редактировать",
            text: "Текст",
            name: "Наименование",
            print: "Печать",
            notSelected: "Не выбрано",
            unit: "ед. изм.",
            noData: "Данные отсутствуют",
            count: "Количество",
            feedback: "Обратная связь для перегенерации поля",
            filter: {
                chooseAll: "Выбрать все",
            },
        },
        notifications: {
            requestSaved:
                "Запрос сохранен в очередь и будет отправлен при восстановлении соединения",
            loadedFromCache: "Данные загружены из кэша",
            dataSaved: "Данные сохранены",
            requestsSynced: "Запросы на сервер о печати маркировок синхронизированы",
        },
        check: {
            title: "Проверки",
            noCFSupplier: "Заполнен 1С гуид, но нет поставщиков ФК",
            notUniqCFSupplier: "Более одного поставщика ФК",
            haveDouble1CGuidL: "Не уникальный 1С гуид",
            haveDeletedIikoNomenclature: "Связан с удаленной номенклатурой",
            noGuid1C: "Есть поставщик ФК, но не заполнен 1С гуид",
            noIikoGuids: "Заполнен 1С гуид, но не заполнено гуид iiko",
        },
        catalogs: {
            titlePlural: "Справочники",
            ingredientCategories: {
                titlePlural: "Категории продуктов",
            },
            temperatureRegime: {
                titlePlural: "Температурные режимы",
                add: "Добавить температурный режим",
                edit: "Изменить температурный режим",
            },
            storageCondition: {
                titlePlural: "Условия хранения",
                add: "Добавить условие хранения",
                edit: "Изменить условие хранения",
            },
            states: {
                titlePlural: "Состояния продукта",
                add: "Добавить состояние",
                edit: "Изменить состояние",
            },
            expirationUnit: {
                titlePlural: "Единицы измерений времени",
                add: "Добавить единицу измерения времени",
                edit: "Изменить единицу измерения времени",
            },
            amountUnit: {
                titlePlural: "Физические единицы измерения",
                add: "Добавить физическую единицу измерения",
                edit: "Изменить физическую единицу измерения",
            },
        },
        reports: {
            titlePlural: "Отчеты",
            forRegion: "Реестр продуктов по региону",
            uniqueProducerProducts: "Реестр продуктов",
        },
        category: {
            title: "Категория",
            titlePlural: "Категории",
            editing: "Редактирование категорий продуктов",
            edit: "Редактировать категории",
            add: "Создать категорию",
            name: "Наименование категории",
        },
        errors: {
            httpGetError: "Не удалось загрузить данные с сервера!",
            httpGetErrorFromCache: "Нет данных в кэше!",
            httpSaveError: "Не удалось сохранить данные!",
            amountBoundError: "Верхняя граница значений меньше нижней! Продукт - ",
        },
        producer: {
            add: "Добавить производителя",
            title: "Производитель",
            titlePlural: "Производители",
            delete: "Удалить производителя",
            deleteConfirm: "Вы действительно хотите удалить производителя?",
            edit: "Редактировать производителя",
            name: "Наименование производителя",
            ingredient: {
                add: "Добавить нового производителя",
                delete: "Удалить продукт производителя",
                deleteConfirm: "Вы действительно хотите удалить продукт производителя?",
                noData: "Информация о производителях отсутствует",
            },
        },
        provider: {
            add: "Добавить поставщика",
            edit: "Редактировать поставщика",
            title: "Поставщик",
            titlePlural: "Поставщики",
            filter: "Фильтр по поставщику",
        },
        region: {
            title: "Регион",
            titlePlural: "Регионы",
            edit: "Редактировать регион",
            add: "Добавить регион",
            filter: "Фильтр по региону",
        },
        title: "Реестр номенклатур",
        markings: {
            temperatureRegime: "Температурный режим",
            markingsTitle: "Печать маркировок",
            state: "Состояние",
            createdAt: "Создано",
            sellBy: "Годен до",
            errorExpirationDate: "Некорректное значение срока годности",
            errorExpirationDateUnit: "Некорректная единица измерения срока годности",
        },
        ingredient: {
            add: "Добавить номенклатуру",
            packaging: "Фасовка в портале",
            additionalInfo: "Доп. информация",
            amountMin: "Количество",
            amountUnit: "Единица измерения",
            packagingInIiko: "Фасовка в Iiko",
            conversionAmount: "Количество для Iiko",
            conversionUnit: "Единица измерения для Iiko",
            amount: {
                title: "Фасовка",
                min: "от",
                max: "до",
                byWeight: "По весу",
                none: "не указана",
            },
            state: {
                title: "Состояние",
            },
            category: "Категория",
            cfTypes: "Тип поставщика с ФК",
            categoryTypes: {
                all: "Все категории",
                semiFinished: "Полуфабрикаты",
                products: "Товары",
                packaging: "Упаковка",
                householdExpenses: "Хозяйственные расходы",
            },
            edit: "Редактировать номенклатуру",
            expiration: "Срок годности",
            image: "Изображение",
            isPrimary: {
                title: "Осн./Альт.",
                primary: "Основной",
                alternate: "Альтернативный",
            },
            isCookFactory: {
                title: "Поставщик ФК",
            },
            title: "Номенклатура",
            titlePlural: "Номенклатуры",
            temperatureRegime: "Температурный режим",
            typeName: "Тип",
            storageConditions: {
                title: "Требования к хранению",
                title2: "Условия хранения и сроки годности",
            },
            type: {
                title: "Тип",
                raw: "Сырье",
                semiFinished: "Полуфабрикат",
            },
            marking: {
                isMarkingPrintable: "Печатать маркировку",
                printMarking: "Маркировка",
                notMarking: "Нет маркировки",
                createdAt: "изготовлено:",
                sellBy: "годен до:",
            },
            guid: {
                iiko: "GUID в iiko",
                oneC: "GUID в 1С",
            },
            search: {
                placeholder: "Введите название товара или GUID для поиска...",
                noResults: "Товары не найдены",
                changeProduct: "Изменить товар...",
                enterGuidOrSearch: "Введите GUID или нажмите поиск",
                guidLabel: "GUID",
            },
        },
        cookFactoryOrderWarning: {
            emptyGUID1C: "У товара есть поставщик с признаком ФК. Не забудьте заполнить 1С GUID!",
            noCFSuppliers:
                "У товара заполнен 1С GUID. Не забудьте указать поставщика с признаком ФК!",
            emptyIikoGUID: "У товара заполнен 1С GUID. Не забудьте заполнить iiko GUID!",
        },
        success: {
            dataSaved: "Данные сохранены",
        },
    },
    journals: {
        config: "Управление журналами",
        assign: {
            title: "Назначение журналов",
            startDate: "Дата ",
            success: {
                assign: "Назначено: %p#journals#",
                assign0: "Не удалось назначить новые журналы. Такие уже есть",
            },
            errors: {
                selectJournals: "Укажите шаблоны журналов",
                assign: "Не удалось назначить журналы кофейням!",
            },
        },
        available: {
            title: "Мои журналы",
            titleCompleted: "Мои заполненные журналы",
            titleUsersCompleted: "Заполненные журналы сотрудников",
            titleEquipmentsUsersCompleted: "Заполненные журналы оборудования",
            type: {
                users: "Журнал сотрудников",
                equipments: "Журнал оборудования",
            },
            fields: {
                startDate: "Дата начала",
                updatedDate: "Дата заполнения",
                endDate: "Дата окончания",
                status: "Состояние журнала",
                type: "Тип журнала",
            },
            confirm: {
                text: 'Приступить к заполнению журнала "%s" для кофейни "%s"?',
                okText: "Да, приступить",
            },
        },
        users: {
            template: {
                title: "Шаблоны журналов сотрудников",
                titleShort: "Шаблоны",
                editTitle: "Редактирование шаблона",
                addTitle: "Новый шаблон",
                tabs: {
                    main: "Основное",
                    questions: "Вопросы",
                    tradePoints: "Кофейни",
                },
                confirmDelete: {
                    title: "Удалить шаблон журнала",
                    text: 'Вы уверены, что хотите удалить шаблон журнала "%s"?',
                    okText: "Да, удалить",
                },
                success: {
                    edit: "Шаблон изменен",
                    add: "Создан новый шаблон",
                    remove: "Шаблон удален",
                    saveQuestion: "Вопрос изменен",
                    removeQuestion: "Вопрос удален",
                    orderingQuestions: "Порядок вопросов изменен",
                    addTradePoints: "Кофейни добавлены: %s штук",
                    removeTradePoints: "Кофейни удалены",
                },
                errors: {
                    save: "Не удалось изменить шаблон!",
                    getRecord: "Не удалось получить шаблон!",
                    remove: "Не удалось удалить шаблон!",
                    saveQuestion: "Не удалось изменить вопрос!",
                    removeQuestion: "Не удалось удалить вопрос!",
                    orderingQuestions: "Не удалось изменить порядок вопросов!",
                    addTradePoints: "Не удалось добавить кофейни!",
                    removeTradePoints: "Не удалось удалить кофейню!",
                    notificationSecondsDuration:
                        '"Напомнить за" должен быть меньше чем "Повторять 1 раз в"!',
                },
                question: {
                    addTitle: "Новый вопрос",
                    editTitle: "Изменить вопрос",
                    title: "Вопросы",
                    saveSort: "Сохранить порядок расположения",
                    remove: {
                        title: "Удалить вопрос",
                        text: "Вы хотите удалить вопрос %s?",
                    },
                },
            },
            assignment: {
                title: "Заполнение журнала",
                isCompleted: "Заполнен",
                isNotCompleted: "Не заполнен",
                endJournal: {
                    userData: "Заполнено %s из %s сотрудников",
                    title: "Закончить заполнение журнала",
                    text: "Вы уверены, что хотите закончить заполнение журнала?",
                    text2: "У вас не заполнена информация по %s сотрудникам из %s",
                    okText: "Да, закончить",
                },
                confirm: {
                    title: "Заполнить журнал",
                    text: 'Начать заполнение журнала "%s" для сотрудника %s?',
                    okText: "Начать",
                },

                success: {
                    addUserAnswers: "Данные по сотруднику: %s внесены",
                    addEquipmentAnswers: "Данные по оборудованию: %s внесены",
                    setCompleted: "Заполнение журнала завершено",
                },
                errors: {
                    getRecord: "Не удалось получить информацию о журнале!",
                    addUserAnswers: "Не удалось добавить запись по сотруднику!",
                    addEquipmentAnswers: "Не удалось добавить запись по оборудованию!",
                    setCompleted: "Не удалось завершить заполнение журнала!",
                    userIsCompleted: "Вы уже заполнили журнал по этому сотруднику",
                },
                userSelector: {
                    title: "Новый сотрудник",
                    placeholder: "Укажите сотрудника не из кофейни",
                },
            },
            completed: {
                title: "Заполненные журналы сотрудников",
                titleShort: "Заполненные журналы",
                errors: {
                    getCompleted: "Не удалось получить данные журнала!",
                },
            },
        },
        equipments: {
            template: {
                title: "Шаблоны журналов оборудования",
            },
            assignment: {
                completedCount: "Заполнено",
                selectEquipment: "Выбери модель оборудования из предложенного списка",
                endJournal: {
                    countData: "Заполнено оборудования - %s",
                    title: "Закончить заполнение журнала",
                    text: "Вы уверены, что хотите закончить заполнение журнала?",
                    okText: "Да, закончить",
                },
                confirm: {
                    title: "Заполнить журнал",
                    text: 'Начать заполнение журнала "%s" для оборудования %s?',
                    text2: 'Заполнить журнала "%s" для ЕЩЕ ОДНОГО оборудования %s?',
                    okText: "Начать",
                },
            },
            completed: {
                title: "Заполненные журналы оборудования",
                errors: {
                    getCompleted: "Не удалось получить данные журнала!",
                },
            },
        },
    },
    iiko: {
        inventoryDocuments: {
            title: "Документы инвентаризации",
            showTitle: "Просмотр документа инвентаризации",
            addTitle: "Новый документ инвентаризации",
            editTitle: "Редактирование документа инвентаризации",
            noRecords: "Нет документов инвентаризации",
            fields: {
                actions: "Действия",
                dateIncoming: "Дата документа",
                documentNumber: "Номер документа",
                comment: "Комментарий",
                status: "Статус",
            },
            statuses: {
                created: "Создан",
                sent: "Отправлен",
            },
            deleteConfirm: {
                title: "Удалить документ",
                text: "Вы уверены, что хотите удалить документ №%s от %s?",
                okText: "Да, удалить",
            },
            actions: {
                show: "Просмотр документа",
                send: "Отправить",
                delete: "Удалить документ",
            },
            items: {
                title: "Товары",
                noRecords: "Нет товаров",
                fields: {
                    ingredient: "Товар",
                    amount: "Количество",
                    comment: "Комментарий",
                },
                actions: {
                    delete: "Удалить строку",
                },
            },
            success: {
                save: "Документ инвентаризации сохранён",
                send: "Документ инвентаризации отправлен в iiko",
                delete: "Документ инвентаризации удалён",
            },
            errors: {
                loadData: "Не удалось получить список документов инвентаризации!",
                loadDocument: "Не удалось загрузить документ инвентаризации!",
                loadIngredients: "Не удалось получить список товаров!",
                save: "Не удалось сохранить документ инвентаризации!",
                send: "Не удалось отправить документ инвентаризации в iiko!",
                delete: "Не удалось удалить документ инвентаризации!",
            },
        },
        stopListProducts: {
            title: "Стоп-листы продуктов",
            productTitle: "Наименование продукта",
            addedDate: "Дата добавления",
            addedUserName: "Кто добавил",
            noUser: "Не указано",
            errors: {
                stopListLoadData: "Не удалось загрузить стоп-листы!",
            },
        },
        reporting: {
            users: {
                title: "Пользователи Iiko",
                deleted: "Удален",
                active: "Активен",
                fields: {
                    onlyActive: "Только активные",
                    name: "ФИО",
                    code: "Табельный номер",
                    phone: "Телефон",
                    status: "Статус",
                    id: "ID",
                },
            },
        },
    },
    innerLearning: {
        search: "Поиск",
        filters: {
            dateStart: "Дата начала",
            dateEnd: "Дата окончания",
            status: "Статус",
            attestationStatus: "Аттестация пройдена?",
            allStatuses: "Все",
            search: "Поиск",
            date: "Дата",
            confirm: "Подтверждение",
        },
        directories: {
            title: "Справочники по внутреннему обучению",
            coachPayments: {
                title: "Выплаты тренерам",
                list: {
                    name: "Наименование выплаты",
                    sum: "Сумма выплаты",
                },
            },
            coachActivityTypes: {
                title: "Виды мероприятий тренера",
                list: {
                    name: "Наименование мероприятия",
                },
            },
            practicalInternships: {
                title: "Практические стажировки",
                list: {
                    name: "Наименование Стажировки",
                },
            },
            learningActivities: {
                title: "Виды обучающих мероприятий",
                list: {
                    name: "Наименование",
                    place: "Место проведения",
                    learningActivityType: "Тип обучающего мероприятия",
                    price: "Стоимость",
                    employeePay: "Выплата сотруднику",
                },
            },
            videoContentWorks: {
                title: "Работа с видео-контентом",
                list: {
                    name: "Потребность для генерации видео-контента",
                    workType: "Тип работ",
                    price: "Стоимость",
                    employeePay: "Выплата сотруднику",
                },
            },
        },
        list: {
            title: "Внутреннее обучение",
            plansTitle: "Планы внутреннего обучения",
            fields: {
                studentName: "Обучающийся",
                coachName: "Основной наставник",
                dateStart: "Дата начала обучения",
                dateEnd: "Дата окончания обучения",
                status: "Статус",
            },
            deleteConfirm: {
                title: "Удалить запись об обучении",
                text: "Вы уверены что хотите удалить запись об обучении?",
                okText: "Да, удалить",
            },
            errors: {
                add: "Ошибка при попытке добавить запись об обучении!",
                edit: "Ошибка при попытке отредактировать запись об обучении!",
                remove: "Ошибка при попытке удалить запись об обучении!",
                get: "Ошибка при попытке получить данные о записях об обучении!",
                getList: "Ошибка при попытке получить список записей об обучении!",
            },
            success: {
                add: "Запись об обучении добавлена",
                edit: "Запись об обучении отредактирована",
                remove: "Запись об обучении удалена",
            },
        },
        add: {
            title: "Добавить план обучения сотрудника",
            success: "Данные успешно добавлены",
            error: "Не удалось сохранить данные",
            studentName: "Обучающийся",
            studentRole: "Роль обучающегося",
            studentPhone: "Телефон обучающегося",
            coachName: "Основной наставник",
            coachRole: "Роль основного наставника",
            coachPhone: "Телефон основного наставника",
            dateStart: "Дата начала обучения",
            dateEnd: "Дата окончания обучения",
            groups: {
                dates: "Даты обучения",
                general: "Общая информация",
            },
        },
        plan: {
            assignedEvents: "Назначенные события",
            title: "План сотрудника",
            notAccess: "Нет разрешения",
            excel: "Скачать план обучения",
            excelName: "Отчет по плану обучения",
            userProfile: {
                fullName: "Ф.И.О",
                phone: "Телефон",
                workPlace: "Место работы",
                startDate: "Начало обучения",
                endDate: "Окончание обучения",
                coach: "Основной наставник",
                downloadCost: "Скачать стоимость обучения ↓",
                downloadPlan: "Скачать план обучения ↓",
                post: "Роль",
            },
            trainingProgram: {
                lessons: "Назначенные уроки",
                consultations: "Назначенные консультации и тренинги",
                internships: "Практические стажировки",
            },
            lessons: {
                name: "Название",
                dateEnd: "Срок до",
                date: "Дата и время проведения",
                mark: "Отметка о выполнении",
                status: "Статус",
            },
            activities: {
                cancelReason: "Причина отмены",
                cancelReasonRequired: "Укажите причину отмены",
                name: "Наименование консультации/тренинга",
                date: "Дата и время проведения",
                student: "Обучающийся",
                coach: "Ведущий",
                phone: "Контакты",
                place: "Место проведения",
                address: "Адрес",
                price: "Стоимость",
                employeePay: "Выплата",
                status: "Отметка о выполнении",
                confirm: "Подтверждение",
                statusChangeSuccess: "Статус мероприятия успешно изменен",
                statusChangeError: "Ошибка при изменении статуса мероприятия",
                confirmStatusChangeSuccess: "Статус подтверждения успешно изменен",
                confirmStatusChangeError: "Ошибка при изменении статуса подтверждения",
                comment: "Комментарий",
            },
            internships: {
                statusChangeSuccess: "Статус стажировки успешно изменен",
                statusChangeError: "Ошибка при изменении статуса стажировки",
                confirmStatusChangeSuccess: "Статус подтверждения стажировки успешно изменен",
                confirmStatusChangeError: "Ошибка при изменении статуса подтверждения стажировки",
            },
            surveys: {
                title: "Опрос",
                template: "Шаблон опроса",
                loading: "Загрузка шаблонов опросов...",
                noTemplates: "Нет доступных шаблонов опросов",
                loadingError: "Ошибка при загрузке шаблонов опросов",
                questionsTitle: "Вопросы опроса",
                noQuestions: "В выбранном шаблоне нет вопросов",
                requiredField: "Обязательное поле",
                requiredQuestionsError: "Ответьте на все обязательные вопросы",
                textAnswerPlaceholder: "Введите ваш ответ",
                templateRequired: "Выберите шаблон опроса",
                noOptions: "Нет вариантов ответа для этого вопроса",
                commentTitle: "Комментарий к опросу",
                commentPlaceholder: "Дополнительная информация или комментарий (по желанию)",
                optionCommentPlaceholder: "Дополнительный комментарий к ответу (необязательно)",
                existingResponse: "Вы просматриваете ранее заполненные ответы",
                edit: "Редактировать",
                fill: "Заполнить",
                student: "Студент",
                coach: "Наставник",
                date: "Дата и время проведения",
                status: "Статус",
                statusChangeSuccess: "Статус опроса успешно изменен",
                statusChangeError: "Ошибка при изменении статуса опроса",
                confirmStatusChangeSuccess: "Статус подтверждения опроса успешно изменен",
                confirmStatusChangeError: "Ошибка при изменении статуса подтверждения опроса",
                initiator: "Инициатор опроса",
                initiatorType: "Тип инициатора опроса",
                initiatorTypeSelect: "Выберите тип инициатора опроса",
                initiatorTypeSelectError: "Необходимо выбрать тип инициатора опроса",
                initiatorTypeSelectSuccess: "Тип инициатора опроса выбран",
                saveSuccess: "Опрос успешно сохранен",
                saveError: "Ошибка при сохранении опроса",
                deleteSuccess: "Опрос успешно удален",
                deleteError: "Ошибка при удалении опроса",
                loadSuccess: "Опрос успешно загружен",
                loadError: "Ошибка при загрузке опроса",
                addSuccess: "Опрос успешно добавлен",
                noTemplateSelected: "Не выбран шаблон опроса",
            },
            attestations: {
                deleteAttemptError: "Ошибка при удалении попытки",
                deleteAttemptSuccess: "Попытка удалена",
                changeStatusError: "Ошибка при изменении статуса аттестации",
                changeStatusSuccess: "Статус аттестации успешно изменен",
                grantSetError: "Ошибка при установке гранта",
                grantSetSuccess: "Грант успешно установлен",
                grantValueRequired: "Значение гранта обязательно",
                attempt: "Попытка",
                title: "Аттестация",
                grant: "Стипендия",
                deleteAttempt: "Удалить попытку",
                addAttempt: "Добавить попытку",
                addGrant: "Назначить стипендию",
                changeStatus: "Изменить статус попытки",
                passedStatus: {
                    complete: "Пройдена",
                    nonComplete: "Не пройдена",
                },
            },
            changeStatus: "Сменить статус",
            totalCosts: {
                activities: "Итоговые суммы по консультациям и тренингам:",
                internships: "Итоговые суммы по стажировкам:",
                priceActivities: "Итоговая стоимость за консультации и тренинги: ",
                priceInternships: "Итоговая стоимость за практические стажировки: ",
            },
        },
        addActivities: {
            title: "Добавить тренинг/консультацию",
            internshipTitle: "Добавить практическую стажировку",
            studentName: "Обучающийся",
            coachName: "Наставник курса",
            coachRole: "Роль наставника курса",
            coachPhone: "Телефона наставника курса",
            dateStart: "Дата начала обучения",
            dateEnd: "Дата окончания обучения",
            learningActivity: "Тренинг/консультация",
            practicalInternship: "Практическая стажировка",
            place: "Место проведения",
            address: "Адрес",
            success: "Запись успешно добавлена",
        },
        addAttestation: {
            date: "Дата и время проведения аттестации",
        },
        trainerTrip: {
            title: "Учет выезда тренера",
            excelName: "Отчет по учету выездов тренеров",
            fields: {
                employeeName: "ФИО сотрудника",
                eventType: "Тип мероприятия",
                coffeeShop: "Кофейня",
                startDate: "Дата начала",
                endDate: "Дата окончания",
                dailySalary: "Ежедневный оклад",
                workDaysCount: "Количество рабочих дней",
                additionalPayments: "Дополнительные выплаты",
                paymentType: "Тип выплаты",
                amount: "Сумма выплаты",
                status: "Статус",
                comment: "Комментарий",
            },
            actions: {
                addPayment: "Добавить выплату",
            },
            errors: {
                save: "Ошибка при сохранении данных",
                delete: "Ошибка при удалении записи",
                noPayments: "Необходимо добавить хотя бы одну выплату",
                invalidPayments: "Заполните все поля выплат корректно",
                cantRemoveLastPayment: "Нельзя удалить единственную выплату",
                load: "Ошибка при загрузке данных",
            },
            success: {
                save: "Данные успешно сохранены",
                delete: "Запись успешно удалена",
            },
        },
        coachTitle: "Наставничество",
        managerAccounting: {
            title: "Учет обучения менеджера кофейни",
            excelName: "Учет обучения менеджеров",
            fields: {
                managerFullName: "ФИО сотрудника",
                managerTradePoint: "Кофейня сотрудника",
                learningLocation: "Место обучения",
                dateStart: "Дата начала",
                dateEnd: "Дата окончания",
                status: "Статус",
                grantAttempt: "Попытка",
                grantAmount: "Сумма стипендии",
                comment: "Комментарий",
            },
            success: {
                save: "Данные успешно сохранены",
            },
            errors: {
                save: "Ошибка при сохранении данных",
                load: "Ошибка при загрузке данных",
            },
        },
        reports: {
            title: "Отчеты",
            tabs: {
                managerAccounting: "Учет обучения менеджера кофейни",
                trainerTrips: "Учет выезда тренера",
                trainingAccounting: "Учет обучающих мероприятий",
            },
        },
        trainingAccounting: {
            title: "Учет обучающих мероприятий",
            excelName: "Отчет по учету обучающих мероприятий",
            fields: {
                trainingActivity: "Обучающее мероприятие",
                studentFullName: "ФИО обучаемого",
                studentTradePoint: "Место работы обучаемого",
                learningLocation: "Место обучения",
                trainerFullName: "Тренер/наставник",
                dateStart: "Дата начала",
                dateEnd: "Дата окончания",
                trainingCost: "Стоимость обучения",
                trainerPayment: "Выплата наставнику",
                status: "Статус",
                comment: "Комментарий",
            },
            success: {
                save: "Данные успешно сохранены",
            },
            errors: {
                save: "Ошибка при сохранении данных",
                load: "Ошибка при загрузке данных",
            },
        },
        survey: {
            loading: "Загрузка опроса...",
            noTemplate: "Шаблон опроса не найден",
            loadError: "Ошибка загрузки шаблона опроса",
            saveError: "Ошибка сохранения ответов",
            saveSuccess: "Ответы успешно сохранены",
            submit: "Отправить",
            saving: "Сохранение...",
            requiredQuestionsError: "Пожалуйста, ответьте на все обязательные вопросы",
            textAnswerPlaceholder: "Введите ваш ответ",
            results: "Результаты опроса",
            completedDate: "Дата заполнения",
            selectedOptions: "Выбранные варианты",
        },
    },
    learning: {
        examination: {
            templates: {
                title: "Аттестационные шаблоны",
                fields: {
                    title: "Наименование",
                    updatedDate: "Изменено",
                    gradeId: "Грейд",
                },
                deleteConfirm: {
                    title: "Удалить шаблон",
                    text: "Вы точно хотите удалить %p#templates#?",
                    okText: "Да, удалить",
                },
                success: {
                    deleteTemplates: "Удалено: %p#templates#",
                },
                errors: {
                    loadData: "Не удалось получить список шаблонов!",
                    deleteTemplates: "Не удалось удалить шаблон!",
                },
            },
            template: {
                title: "Редактирование шаблона",
                addTitle: "Новый шаблон",
                fields: {
                    title: "Наименование",
                    timeLimit: "Ограничение по времени (минут)",
                    passRate: "Процент прохождения",
                    isAutomaticReassignment: "Автоматически переназначать",
                    autoReassignmentInterval: "Интервал переназначений (в днях)",
                    autoReassignmentPeriod: "Период переназначений (в днях)",
                    gradeId: "Грейд",
                },
                errors: {
                    loadData: "Не удалось получить шаблон!",
                    addTemplate: "Не удалось создать шаблон!",
                    updateTemplate: "Не удалось изменить шаблон!",
                },
                success: {
                    addTemplate: "Шаблон создан",
                    updateTemplate: "Шаблон изменен",
                },
                rules: {
                    title: "Уроки",
                    addTitle: "Новый урок",
                    lesson: "Урок",
                    questionsAmount: "Кол-во вопросов (макс. %s)",
                    deleteConfirm: {
                        title: "Удалить урок",
                        text: 'Вы уверены, что хотите удалить урок "%s"',
                        okText: "Да, удалить",
                    },
                    errors: {
                        addData: "Не удалось получить информацию об уроке",
                        lessonStepsCount: "У данного урока нет шагов с вопросами",
                        lessonAlreadyExist: "Данный урок уже есть в этой аттестации",
                    },
                },
            },
            assign: {
                title: "Назначение аттестации",
                fields: {
                    users: "Сотрудники",
                    expirationDate: "Дедлайн",
                    examination: "Аттестация",
                },
                success: {
                    assign: "Назначено: %p#examinations# ",
                },
                errors: {
                    assign: "Не удалось назначить аттестацию!",
                },
            },
            results: {
                title: "Аттестации",
                statusList: {
                    all: "Все",
                    success: "Завершенные",
                    failed: "Проваленные",
                    terminated: "Отмененные",
                    notEnded: "Не законченные",
                },
                fields: {
                    title: "Аттестация",
                    createdDate: "Назначена",
                    user: "Аттестуемый",
                    tradePoint: "Кофейня",
                    rightAnswerPercent: "Пройдено",
                    status: "Статус",
                    grade: "Грейд",
                },
                result: {
                    title: "Аттестация",
                    mainData: {
                        status: "Статус",
                        user: "Аттестуемый",
                        createdDate: "Дата создания",
                        deadline: "Пройти до",
                        sessionStart: "Дата начала",
                        sessionEnd: "Дата окончания",
                        passRate: "Для прохождения",
                        passRateValue: "%s% из %p#questions#",
                        result: "Пройдено",
                        resultValue: "%s%, %p#errors#",
                    },
                    errors: {
                        loadData: "Не удалось получить данные об аттестации!",
                    },
                    details: {
                        title: "Прохождение",
                        noData: "Нет данных",
                    },
                },
            },
            learning: {
                title: "Прохождение аттестации",
                start: "Начать",
                continue: "Продолжить",
                errors: {
                    checkSession: "Не удалось получить информацию об аттестации!",
                    startSession: "Не удалось приступить к аттестации!",
                    terminated: "Прохождение урока было отменено",
                    stepOut: "Не удалось отправить данные о прохождении шага аттестации!",
                },
                messages: {
                    continue: 'Вы хотите продолжить прохождение аттестации "%s?"',
                    start: 'Вы хотите начать прохождение аттестации "%s?"',
                    passed: "Вы уже прошли эту аттестацию",
                },
                completeMessage: {
                    completed: {
                        title: "Поздравляем!",
                        text: "Вы успешно прошли аттестацию.",
                    },
                    expired: {
                        title: "Вы не успели",
                        text: "К сожалению вы не успели вовремя",
                    },
                    failed: {
                        title: "Аттестация провалена",
                        text: "Слишком много ошибок.",
                    },
                    terminated: {
                        title: "Аттестация отменен",
                        text: "Прохождение аттестации было отменено.",
                    },
                },
            },
        },
        grades: {
            title: "Дерево грейдов",
            gradeTree: "Дерево грейдов",
            adminUserSelect: "Пользователь",
            toEdit: "Редактировать грейды",
            errors: {
                svg: "Не удалось загрузить дерево грейдов",

                lessonLearnSessionId:
                    "Отсутствует идентификатор сессии, обратитесь к администратору",
            },

            stepInfo: {
                title: "Информация по прохождению шага грейда",
                addFailedGradeStep: "Провалить",
                lesson: {
                    title: "Урок %s ( ID: %s )",
                    status: "Статус",
                    isAvailable: "Доступность",
                    createdDate: "Дата создания",
                },
                gradeStepSession: {
                    title: "Сессия шага грейда ( ID: %s )",
                    createdDate: "Дата создания",
                    status: "Статус",
                    initiator: "Инициатор",
                    sessionBegin: "Начало",
                    sessionEnd: "Окончание",
                    expires: "Нужно окончить до",
                },
                lessonLearnSession: {
                    title: "Сессия урока ( ID: %s )",
                    createdDate: "Дата создания",
                    status: "Статус",
                    isAssigned: "Назначен",
                    errors: "Ошибки",
                    countLessonLearnSession: "Кол-во вхождений в GradeSession",
                    expirationDate: "Нужно окончить до",
                },
                errors: {
                    addFailedGradeStepSession: "Не удалось провалить шаг",
                },
            },
            adminInfo: {
                fields: {
                    createdDate: "Дата",
                    type: "Статус",
                    comment: "Описание",
                },
                confirmAdd: {
                    title: "Назначить грейд",
                    text: 'Вы уверены, что хотите назначить грейд "%s" пользователю?',
                    okText: "Да, назначить",
                },
                confirmRemove: {
                    title: "Удалить грейд",
                    text: 'Вы уверены, что хотите удалить грейд "%s" у пользователя?',
                    okText: "Да, удалить",
                },
                isAchieved: "Получен",
                isNotAchieved: "Не получен",
                showDetails: "Подробнее",
                toAdd: "Добавить грейд",
                toRemove: "Удалить грейд",
                toHistory: "История изменений",
                historyTitle: 'История грейда "%s" - текущий статус "%s"',
            },
        },
        gradeStep: {
            title: "%s. Шаг %s",
            errors: {
                loadData: "Не удалось найти информацию по шагу грейда!",
            },
            messages: {
                continue: 'Вы хотите продолжить прохождение шага грейда "%s?"',
                start: 'Вы хотите начать прохождение шага грейда "%s?"',
                failed: "Слишком много ошибок. Урок провален.",
                passed: "Вы уже прошли этот урок",
            },
            start: "Начать",
            continue: "Продолжить",
        },
        gradesList: {
            title: "Редактирование грейдов",
            gradeTree: "Дерево грейдов",
            fields: {
                id: "ID",
                image: "Фото",
                name: "Название",
            },
            errors: {
                getGradeListByTree: "Ошибка при получении информации о грейдах ",
            },
        },
        gradeEdit: {
            title: "Редактирование грейда",
            addGradeStep: "Добавить шаг грейда",
            gradeSteps: "Шаги грейда",
            fields: {
                name: "Наименование",
                gradeTreeId: "Дерево грейдов",
                finishFormUrl: "Ссылка на форму опроса",
                imageId: "Изображение",
                userRoles: "Роли пользователей",
            },
            confirm: {
                title: "Удалить шаг грейда",
                text: 'Вы точно хотите удалить шаг "%s"?',
                okText: "Да, удалить",
            },
            addStep: {
                title: "Добавить шаг",
                fields: {
                    lesson: "Урок",
                    deadline: "Дата прохождения",
                },
            },
            messages: {
                reorder: "Порядок шагов грейда был изменен",
                remove: "Шаг удален",
                add: "Шаг добавлен",
                save: 'Грейд "%s" сохранен',
            },
            errors: {
                reorder: "Ошибка при попытке изменения порядка шагов грейда",
                remove: "Ошибка при попытке удаления шага",
                add: "Ошибка при попытке добавления шага",
                save: "Ошибка при попытке сохранения грейда",
                notFoundSteps: "Найдены зацикленные шаги: %s. Обратитесь к администратору",
                stepsCount:
                    "Кол-во шагов грейда не соответствует ожидаемому %s из %s. Обратитесь к администратору",
                getGrade: "Ошибка при получении информации о грейде",
            },
        },
        gradeLearning: {
            title: "Дерево грейдов",
            noGrades: "Грейды отсутствуют",
            toAction: "Перейти",
            toUserGrade: "Посмотреть",
            toGrades: "Дерево грейдов",
            toAdminGrades: "Подробнее",
            toInformationLessonText: "Хотите сейчас повторить материал в справочных уроках?",
            toInformationLessonButton: "Да, повторю сейчас",
            toInformationLessonCancel: "Нет, повторю позже",
            toGoConfirm: {
                new: {
                    text: 'Начать прохождение урока "%s"?',
                    okText: "Да, начать",
                },
                inProgress: {
                    text: 'Продолжить прохождение урока "%s"?',
                    okText: "Да, продолжить",
                },
                examinationCreated: {
                    text: 'Начать прохождение аттестации "%s"?',
                    okText: "Да, начать",
                },
                examinationInProgress: {
                    text: 'Продолжить прохождение аттестации "%s"?',
                    okText: "Да, продолжить",
                },
            },
            gradeStatus: {
                ok: "Получен",
                problems: "Нужно пройти",
                blocked: "Заблокирован",
                warnings: "Скоро будет аннулирован",
            },
            success: {
                actionGradePassed: 'Грейд "%s" пройден',
                actionGradeFailed: 'Грейд "%s" удален',
                actionStepPassed: 'Шаг "%s" пройден',
                actionStepFailed: 'Шаг "%s" провален',
                actionStepConfirmed: 'Шаг "%s" подтвержден',
                actionStepReseted: 'Шаг "%s" аннулирован',
                changeExaminationStatus: 'Статус аттестации "%s" изменен',
            },
            errors: {
                getUserGradeSteps: "Не удалось получить информацию о шагах грейда!",
                passed: 'Вы уже прошли урок "%s".',

                waitingConfirmEmployee: 'Урок "%s" ожидает подтверждения от менеджера',
                waitingConfirm: 'Урок "%s" ожидает подтверждения от академии',
                failed: {
                    title: "Урок провален",
                    textEmployee: "Слишком много ошибок. Обратитесь к менеджеру.",
                    text: "Слишком много ошибок. Обратитесь к сотруднику академии.",
                },
                expired: {
                    title: "Урок провален",
                    textEmployee: "Вы не успели вовремя. Обратитесь к менеджеру.",
                    text: "Вы не успели вовремя. Обратитесь к сотруднику академии.",
                },
                notAvailable: 'Данный урок "%s" вам пока не доступен.',
                setStepAction: "Не удалось выполнить действие над шагом грейда!",
                userGrade: "Не удалось выполнить действие над грейдом пользователя!",
                changeExaminationStatus: "Не удалось изменить статус аттестации",
                examinationPassed: 'Вы уже прошли аттестацию "%s"!',
                examinationFailed: "Слишком много ошибок. Обратитесь к сотруднику академии.",
                examinationExpired: "Вы не успели вовремя. Обратитесь к сотруднику академии.",
            },
        },

        lessons: {
            assign: {
                title: "Назначение уроков",
                noRecords: "Ничего не найдено",
                fields: {
                    lessons: "Уроки",
                    categories: "Категории",
                    expirationDate: "Дедлайн",
                    delayedDate: "Отложенное назначение",
                    users: "Сотрудники",
                },
                errors: {
                    addIds: "Укажите уроки и/или категории уроков",
                    add: "Ошибка при назначении урока!",
                    loadData: "Не удалось получить информацию об уроках!",
                },
                success: {
                    add: "Назначено: %p#lessons#",
                },
            },
            info: {
                toPrevStep: "Предыдущий шаг",
                toNextStep: "Далее",
                toList: "К списку уроков",
                errors: {
                    loadData: "Не удалось получить информацию об уроке!",
                    noSteps: "В уроке пока нет информации",
                },
            },
            infoList: {
                title: "Справочные уроки",
                noRecords: "Ничего не найдено",
                errors: {
                    loadData: "Не удалось получить информацию об уроках!",
                },
            },
            catalog: {
                title: "Каталог уроков",
                noRecords: "Ничего не найдено",
                selectGrade: "Укажите грейд",
                addButton: "Добавить урок/каталог",
                grade: "Грейд",
                edit: {
                    title: {
                        addLesson: "Добавить урок",
                        addCatalog: "Добавить каталог",
                        editLesson: "Редактировать урок",
                        editCatalog: "Редактировать каталог %s",
                    },
                    lesson: "Урок",
                    catalog: "Каталог",
                    fields: {
                        type: "Тип",
                        lessonParentCatalogId: "Родительский каталог",
                        name: "Название",
                        image: "Фото",
                        isInfoShow: "Выводить в справочных уроках",
                    },
                    success: {
                        catalogUpdated: "Каталог %s отредактирован",
                        catalogAdded: "Каталог %s добавлен",
                    },
                    errors: {
                        updateCatalog: "Не удалось отредактировать каталог!",
                    },
                },
                deleteConfirm: {
                    lessonTitle: "Удалить урок",
                    lessonText: 'Вы уверены, что хотите удалить урок "%s"?',
                    catalogTitle: "Удалить каталог",
                    catalogText: 'Вы уверены, что хотите удалить каталог "%s"?',
                    okText: "Да, удалить",
                    success: {
                        removeLesson: 'Урок "%s" удален',
                        removeCatalog: 'Каталог "%s" удален',
                    },
                    errors: {
                        removeLesson: "Не удалось удалить урок!",
                        removeCatalog: "Не удалось удалить каталог!",
                    },
                },
                tooltips: {
                    catalogDelete: "Удалить каталог",
                    catalogEdit: "Редактировать каталог",
                    catalogLessonPaste: 'Вставить урок "%s" в категорию',
                    lessonCopy: "Скопировать урок",
                    lessonEdit: "Редактировать урок",
                    lessonDelete: "Удалить урок",
                    preview: "Посмотреть",
                },
                success: {
                    lessonCopy: 'Урок "%s" скопирован в память',
                    lessonCopied: 'Урок "%s" скопирован в каталог',
                },
                errors: {
                    loadData: "Не удалось получить информацию об уроках!",
                    lessonCopied: "Не удалось скопировать урок!",
                },
                gradeFilter: {
                    title: "Грейды",
                },
            },
            lesson: {
                lesson: "Урок",
                grades: {
                    title: "Грейды",
                    addTitle: "Добавить урок в грейд",
                    deleteText: 'Вы уверены, что хотите удалить урок из грейда "%s"?',
                    success: {
                        stepRemove: "Урок удален из грейда!",
                    },
                    errors: {
                        stepRemove: "Не удалось удалить урок из грейда!",
                    },
                    fields: {
                        gradeId: "Грейд",
                        deadline: "Дата прохождения",
                    },
                },
                lessonSteps: "Шаги урока",
                fields: {
                    lessonCatalogId: "Родительский каталог",
                    name: "Название",
                    image: "Фото",
                    description: "Описание",
                    isInformationLesson: "Урок справочный",
                    confirmType: "Подтверждение",
                    isRandomLesson: "Шаги предлагать в случайном порядке",
                    randomCount: "Шагов для прохождения",
                    isExamLesson:
                        "Урок экзаменационный (выход из урока будет засчитан, как провал)",
                    isReady: "Урок готов",
                    canBeAssignedByManager: "Может быть назначен менеджером",
                    maxErrors: "Максимальное число ошибок в уроке",
                    expiration: "Времени на прохождение",
                    isImportantChanges: "Важные изменения",
                    endDate: "Дата к которой нужно пройти урок в грейде",
                },
                errors: {
                    getCatalogLesson: "Не удалось получить данные урока!",
                    randomCount: "Укажите сколько нужно шагов для прохождения",
                    endDate: "Укажите дату к которой нужно пройти урок в грейде",
                    endDateMin: "Дата к которой нужно пройти не может быть меньше текущей",
                    endDateMax: "Дата к которой нужно пройти не может быть больше 6-ти месяцев",
                    maxErrors: "Укажите максимальное число ошибок в уроке",
                    updateLesson: "Не удалось отредактировать урок!",
                    updateStep: "Не удалось отредактировать шаг урока!",
                    removeStep: "Не удалось удалить шаг урока!",
                    sortSteps: "Не удалось изменить порядок шагов!",
                    removeStepAnswer: "Не удалось удалить ответ шага урока!",
                    sortAnswers: "Не удалось изменить порядок ответов!",
                    copyStep: "Не удалось скопировать шаг урока!",
                    cutStep: "Не удалось переместить шаг урока!",
                },
                success: {
                    sortAnswers: "Порядок ответов изменен",
                    sortSteps: "Порядок шагов урока изменен",
                    copyStep: "Шаг урока скопирован",
                    cutStep: "Шаг урока перемещен",
                },
                steps: {
                    actions: {
                        add: "Добавить шаг",
                        copy: 'Копировать шаг "%s в данный урок"',
                        cut: 'Переместить шаг "%s"  в данный урок',
                        dragEnabled: "Сортировка разрешена",
                        dragDisabled: "Сортировка запрещена",
                    },
                    confirmDelete: {
                        title: "Удалить шаг урока",
                        text: 'Вы действительно хотите удалить шаг урока "%s"?',
                        okText: "Да, удалить",
                    },
                    fields: {
                        lessonBody: "Описание",
                        shortDescription: "Название",
                        stepType: "Тип шага",
                        isRandomStep: "Ответы в случайном порядке",
                    },
                    answers: {
                        title: "Варианты ответов",
                        editTitle: "Вариант ответа",
                        add: "Добавить ответ",
                        fields: {
                            answerBody: "Ответ",
                            isWrong: "Это не верный ответ",
                        },
                    },
                    editStep: "Редактировать шаг урока",
                    addStep: "Редактировать шаг урока",
                    copy: "Скопировать шаг",
                    copied: 'Шаг "%s" скопирован',
                    stepErrors: {
                        noAnswers: "Нет вариантов ответов",
                        onlyOneRightAnswer: "Должен быть только один правильный вариант",
                        noRightAnswers: "Укажите правильный вариант ответа",
                        typeIsDeprecated: "Данный тип шага не используется, измените тип",
                    },
                },
                answers: {
                    confirmDelete: {
                        title: "Удалить вариант ответа",
                        text: "Вы действительно хотите удалить этот вариант ответа?",
                        okText: "Да, удалить",
                    },
                },
                pollTemplateList: {
                    title: "Опросы",
                },
            },
        },
        lessonLearnSession: {
            title: "Урок",
            start: "Начать",
            continue: "Продолжить",
            errors: {
                getLesson: "Не удалось получить информацию об уроке!",
                startSession: "Не удалось начать урок!",
                completed: "Вы уже прошли этот урок",
                failed: "Вы провалили прохождение урока. Вы допустили %s ошибок",
                expired: "Вы не успели пройти урок за выделенное время.",
                terminated: "Прохождение урока было отменено",
                waitingConfirm: "Урок ожидает подтверждения",
                noStep: "Не найден шаг урока. Обратитесь в Академию",
                stepOut: "Не удалось отправить данные о прохождении шага урока",
                addNoInstance: "Не удалось отправить данные об опросе!",
            },
            messages: {
                continue: 'Вы хотите продолжить прохождение урока "%s?"',
                start: 'Вы хотите начать прохождение урока "%s?"',
                failed: "Слишком много ошибок. Урок провален.",
                passed: "Вы уже прошли этот урок",
                expired: "Вы не успели пройти урок за выделенное время. ",
            },
        },
        management: {
            title: "Управление обучением",
            waitingConfirmTitle: "Подтверждение уроков",
            failedTitle: "Проваленные уроки",
            expiredTitle: "Просроченные уроки",
            startDate: "Начиная с",
            fields: {
                user: "Пользователь",
                lesson: "Урок",
                grade: "Грейд",
                tradePoint: "Кофейня",
                createdDate: "Дата назначения",
                sessionBegin: "Дата начала",
                sessionEnd: "Дата окончания",
                expirationDate: "Пройти до",
            },
            waitingConfirm: {
                title: "Подтверждение прохождения",
                text: 'Вы уверены, что хотите подтвердить прохождение урока "%s" пользователю %s?',
                okText: "Да, подтвердить",
            },
            failedConfirm: {
                title: "Сбросить прохождение",
                text: 'Сбросить провал урока "%s" пользователю %s?',
                okText: "Да, сбросить",
            },
            success: {
                confirmLessonStep: 'Урок "%s" подтвержден',
                resetLessonStep: 'Урок "%s" сброшен',
            },
            errors: {
                loadData: "Не удалось получить информацию об обучении!",
                confirmLessonStep: "Не удалось подтвердить прохождение урока!",
                resetLessonStep: "Не удалось подтвердить прохождение урока!",
            },
            failedLessonInfo: {
                userAnswer: "Ответ пользователя",
                rightAnswer: "Правильный ответ",
                rightAnswers: "Правильные ответы",
                wrongAnswers: "Неправильные ответы",
                collapse: "Свернуть",
                expand: "Развернуть",
            },
        },

        userErrorFeedbacks: {
            title: "Найденные пользователями ошибки",
            fields: {
                user: "Инициатор",
                lesson: "Урок",
            },
            noRowsLabel: "Ошибок не найдено",
            errors: {
                loadData: "Не удалось получить список ошибок!",
            },
            edit: {
                title: "Обработка ошибки",
                toCancel: "Отказать",
                toComplete: "Выполнено",
                toActive: "Вернуть в обработку",
                fields: {
                    lesson: "Урок",
                    step: "Шаг урока",
                    createdDate: "Дата",
                    user: "Инициатор",
                    description: "Описание",
                    selectedText: "Выделенный текст",
                },
                tooltips: {
                    view: "Посмотреть урок",
                    edit: "Редактировать шаг урока",
                    toUser: "Посмотреть пользователя",
                },
                success: {
                    setStatus: "Статус изменен на %s",
                },
                errors: {
                    loadData: "Не удалось получить информацию об ошибке!",
                    setStatus: "Не удалось изменить статус!",
                },
            },
        },
    },
    legalPerson: {
        title: "Юридические лица",
        addTitle: "Новое юр. лицо",
        fields: {
            title: "Юридическое лицо/ИП",
            inn: "ИНН",
            address: "Адрес юридического лица",
            contacts: "Контакты юридического лица",
            kpp: "КПП",
        },
        errors: {
            getRecord: "Не удалось получить информацию о юр.лице!",
        },
    },
    main: {
        loaderText: "Идет загрузка данных. Подождите...",
    },
    messages: {
        title: "Оповещения",
        toUrl: "Перейти",
        refresh: "Обновить",
        readAll: "Пометить все как прочитанные",
        clickToOpen: "Нажмите для перехода",
        types: {
            title: "Типы оповещений",
            fields: {
                name: "Системное название",
                isCheckedByDefault: "Выбран по умолчанию",
                accessParams: "Кому показывать",
                isAutoShowed: "Автоматически показывать",
                soundFileId: "Звук воспроизведения",
            },
        },
        status: {
            site: {
                new: "Новое",
                ok: "Прочитано на портале",
            },
            email: {
                failed: "Не удалось отправить e-mail. Проверьте настройки оповещений. Возможно, Вы заблокировали получение сообщений с портала в электронной почте.",
                readed: "Оповещение было отправлено на e-mail",
            },
            telegram: {
                failed: "Не удалось отправить сообщение. Проверьте настройки оповещений. Возможно, Вы заблокировали бота в telegram.",
                readed: "Оповещение было отправлено через Telegram",
            },
            notifications: {
                failed: "Не удалось отправить сообщение. Проверьте настройки уведомлений.",
                readed: "Оповещение было отправлено в браузер",
            },
            maxBot: {
                failed: "Не удалось отправить сообщение. Проверьте настройки оповещений. Возможно, Вы заблокировали бота в Max.",
                readed: "Оповещение было отправлено через Max",
            },
        },
        errors: {
            markAllMessageAsRead: "Ошибка. Не удалось пометить все сообщения как прочитанные",
        },
        config: {
            title: "Настройки оповещений",
            email: {
                title: "Оповещения по E-mail",
                email: "Укажите E-mail для оповещения",
                confirm: "Хочу получать оповещения на E-mail",
                messageTypes: "Типы оповещений",
            },
            telegram: {
                title: "Оповещения в Telegram",
                confirm: "Хочу получать оповещения через Telegram",
                messageTypes: "Типы оповещений",
                bot: "Перейти в Telegram Бота",
            },
            maxBot: {
                title: "Оповещения в Max",
                checkSubscription: "Проверить подписку",
                checkSubscriptionTrue: "Подписка проверена",
                checkSubscriptionFalse: "Подписка добавлена",
                unSubscription: "Отменить подписку",
                unSubscriptionSuccess: "Подписка отменена",
                registered: {
                    start: "Вы представлены нашему ",
                    bot: "Max боту ",
                },
                confirm: "Хочу получать оповещения через Max",
                messageTypes: "Типы оповещений",
                bot: "Перейти в Max в нашего Бота",
                notRegistered: {
                    start: "Вы еще не представлены нашему Max боту ",
                    end: "Перейдите в него",
                },
                component: {
                    tooltip: "Перейти в бота и получить ссылку на пользователя",
                    tooltipDisabled:
                        "Вы не зарегистрированы в Max, не получится дать вам ссылку на пользователя",
                    error: "Не удалось отправить Вам контакт пользователя",
                    success: "Контакт пользователя отправлен Вам в Max",
                },
            },
            notifications: {
                title: "Оповещения в браузере",
                confirm: "Хочу получать оповещения через ЭТОТ браузер",
                messageTypes: "Типы оповещений",
                reload: "Для того, чтобы применились изменения, необходимо перезагрузить страницу. Перезагрузить?",
                notReload: "Хорошо, изменения применятся при следующем обновлении страницы.",
            },
            errors: {
                saveConfig: "Не удалось сохранить настройки!",
            },
            success: {
                saveConfig: "Настройки сохранены",
            },
        },
        sender: {
            title: "Рассылка сообщений",
            reset: "Сброс",
            fields: {
                title: "Заголовок",
                description: "Сообщение",
                messageType: "Тип",
                url: "Ссылка",
                user: "Получатель",
                createdDate: "Дата",
            },
            errors: {
                sendMessage: "Не удалось отправить сообщение!",
            },
            success: {
                sendMessage: "Сообщение отправлено",
            },
        },
    },
    mobileApp: {
        resendOrders: {
            title: "Переотправка отзывов",
            startDate: "Начальная дата",
            endDate: "Конечная дата",

            submitBtnText: "Переотправить отзывы",
            success: "Переотправка отзывов успешно завершена",
            error: "Не удалось переотправить отзывы",
        },
        tradePointFeatures: {
            title: "Отметки кофеен",
            feature: "Отметка",
            selectedPoints: "Выбрано кофеен: %s",
            error: "Не удалось изменить отметку для кофеен!",
            success: "Отметка для кофеен изменена",
        },
        menu: {
            title: "Меню",
            externalMenuId: "ID меню",
            syncMenu: "Синхронизировать все меню",
            syncCustomMenu: "Синхронизировать отдельное меню",
            syncPoints: "Синхронизировать кофейни",
            forceSyncCustomMenu: "Принудительная синхронизация отдельного меню",
            cachedSyncCustomMenu: "Синхронизация отдельного меню из кэша",
            forceAll: "Принудительная синхронизация всех меню",
            force: "Принудительная синхронизация",
            okBtnText: "Синхронизировать",
            errorSyncAllMenu: "Не удалось синхронизировать все меню!",
            errorSyncCustomMenu: "Не удалось синхронизировать отдельное меню!",
            errorSyncPoints: "Не удалось синхронизировать кофейни!",
            successSyncAllMenu: "Все меню синхронизированы",
            successSyncCustomMenu: `Отдельное меню синхронизировано: %s шт.`,
            successSyncPoints: "Кофейни синхронизированы",
            noMenusSelected: "Не выбрано ни одного меню",
            syncHistory: {
                title: "История синхронизации",
                createdDate: "Дата синхронизации",
                version: "Версия",
                isLatest: "Последняя версия",
                isSyncComplete: "Завершена",
                isSyncSuccessful: "Успешна",
            },
        },
        products: {
            title: "Продукты",
            withImage: "С изображением",
            withoutImage: "Без изображения",
            externalMenuIds: "Кол-во меню",
            imageFilter: "Фильтр по изображению",
            images: {
                imageUrl: "Ссылка на изображение",
                title: "Изображения для товаров",
                noImage: "Без изображения",
                saveSuccess: "Изменения сохранены",
                saveError: "Не удалось сохранить изменения",
                add: "Добавить изображение",
                imageUrlAlreadyExists: "Это изображение уже было добавлено",
            },
        },
    },
    navigationMenu: {
        title: "Редактор меню",
        category: {
            editTitle: "Изменить категорию",
            addTitle: "Новая категория",
            sortTooltip: "Сортировка",
            editTooltip: "Редактировать категорию",
            addTooltip: "Создать категорию",
            deleteTooltip: "Удалить категорию",
            fields: {
                title: "Название",
                order: "Порядок вывода",
            },
            deleteConfirm: {
                title: "Удалить категорию",
                text: 'Вы действительно хотите удалить категорию "%s"',
                okText: "Да, удалить",
            },
            success: {
                saveCategory: "Категория отредактирована",
                deleteCategory: "Категория удалена",
                saveOrder: "Порядок изменен",
                saveItem: "Пункт меню изменен",
                removeItem: "Пункт меню удален",
            },
            errors: {
                saveCategory: "Не удалось сохранить категорию!",
                deleteCategory: "Не удалось удалить категорию!",
                saveOrder: "Не удалось изменить порядок!",
                saveItem: "Не удалось изменить пункт меню!",
                removeItem: "Не удалось удалить пункт меню!",
            },
        },
        items: {
            saveSort: "Сохранить порядок расположения",
            fields: {
                displayName: "Видимое название",
                internalName: "Системное имя",
                icon: "Иконка",
                uri: "ссылка",
                categoryId: "Категория",
                roles: "Роли",
                homePageRoles: "Отобразить для ролей",
                accessFeatureIds: "Доступы",
                accessFeatureCategoryIds: "Категории доступов",
                isWorkOffline: "Может работать офлайн",
                isHomePageShow: "Отобразить на домашней странице",
                homePageOrder: "Порядок на главной (больше - выше)",
                homePageAccessFeatureIds: "Отобразить для доступов",
                homePageAccessFeatureCategoryIds: "Отобразить для категорий доступов",
            },
            groups: {
                mainGroup: "Основные",
                homePageGroup: "Домашняя страница",
            },
            errors: {
                remove: "Ошибка при удалении пункта меню!",
                save: "Ошибка при сохранении пункта меню!",
                addAccessFeaturesOrRoles: "Укажите роли или доступы",
            },
            deleteConfirm: {
                title: "Удалить пункт меню",
                text: 'Вы хотите удалить пункт меню "%s"?',
                okText: "Да, удалить",
            },
            editTitle: "Редактировать пункт меню",
            addTitle: "Новый пункт меню",
        },
        accessFeatures: "Доступы",
        accessFeatureCategories: "Категории доступов",
        roleFilter: "Роли",

        viewer: {
            title: "Просмотр меню",
            userSelect: "Пользователь",
            view: "Просмотр",
        },
    },
    homePage: {
        title: "Домашняя страница",
        emptyPageError: "Страница не настроена, обратитесь к администратору",
    },
    marketing: {
        pntr: {
            title: "Рейтинг внешних площадок",
            fullAddress: "Адрес",
            weightedMeanRating: "Средневзвешенный рейтинг",
            rating: "Рейтинг",
            ratings: {
                yandexMaps: "Яндекс Карты",
                googleMaps: "Google Карты",
                twoGIS: "2ГИС",
                reviewBooster: "Отзывы из активатора",
                reviewsBook: "Книга отзывов",
                reviews: "отзывов",
            },
            links: {
                title: "Ссылки",
                yandexMaps: "Яндекс Карты",
                googleMaps: "Google Карты",
                twoGIS: "2ГИС",
                flamp: "Flamp",
                foursquare: "Foursquare",
                tripadvisor: "Tripadvisor",
                yell: "Yell",
                zoon: "Zoon",
                pointer: "Pointer",
            },
        },
    },
    news: {
        title: "Новости",
        delConfirm: 'Вы действительно хотите удалить новость "%s"?',
        delConfirmYesBtn: "Удалить",
        fromDate: "От",
        startDate: "Скрыто до",
        isDeleted: "Новость удалена",
        errors: {
            notFound: "Новость не найдена!",
            load: "Не удалось получить данные!",
            save: "Не удалось сохранить новость!",
        },
        success: {
            remove: "Новость удалена",
        },
        edit: {
            addTitle: "Добавить новость",
            added: 'Новость "%s" создана',
            editTitle: "Редактирование новости",
            edited: 'Новость "%s" отредактирована',
            name: "Название",
            shortDescription: "Краткое описание",
            description: "Новость",
            image: "Фото",
            publicationDate: "Дата публикации",
        },
        search: {
            placeholder: "Введите текст для поиска",
        },
    },
    notFound: {
        redirectText: "Идет перенаправление. Подождите...",
    },
    okk: {
        preOrderCancels: {
            preOrderCancel: {
                modalTitle: "Добавление отмены предзаказа",
                modalUpdateTitle: "Обновление отмены предзаказа",
                tradePointTitle: "Кофейня",
                entryDateTitle: "Дата внесения",
                cancelReason: "Ситуация(Не забрал/Отменил)",
                cancelReason1: "Не забрал",
                cancelReason2: "Отменил",
                descriptionTitle: "Описание",
                dateStartBlockTitle: "Блокировка с",
                dateEndBlockTitle: "Блокировка до",
                noRecords: "Информация не найдена",
            },
        },
        checkList: {
            checkListTemplates: {
                title: "Шаблоны чек-листов",
                addTitle: "Создать шаблон",
                addCategory: "Создать Категорию",
                editTitle: "Изменить шаблон",
                editItems: "Редактировать шаги",
                main: "Основное",
                errors: {
                    load: "Не удалось получить список чек-листов",
                    noRecords: "Не найдено",
                    deleted: "Не удалось удалить шаблон",
                    templateCategories: "Не удалось получить список категорий!",
                    added: "Не удалось создать шаблон!",
                    updated: "Не удалось изменить шаблон!",
                    getTemplate: "Не удалось получить информацию о шаблоне!",
                    saveCategory: "Не удалось изменить категорию!",
                    deleteCategory: "Не удалось удалить категорию!",
                    copyTemplate: "Не удалось скопировать шаблон!",
                },
                success: {
                    deleted: "Шаблон удален",
                    added: 'Шаблон "%s" создан',
                    updated: 'Шаблон "%s" изменен',
                    saveCategory: "Категория отредактирована",
                    deleteCategory: "Категория удалена",
                },
                deleteConfirm: {
                    title: "Удалить шаблон?",
                    text: 'Вы точно хотите удалить шаблон "%s" ?',
                    categoryTitle: "Удалить категорию?",
                    categoryText: 'Вы точно хотите удалить категорию "%s" ?',
                    okText: "Да, удалить",
                },
                fields: {
                    createdDate: "Создан",
                    updatedDate: "Изменен",
                    title: "Название",
                    qcCheckListTemplateCategory: "Категория",
                    penalizationType: "Начислять баллы за",
                    complaintCreationMode: "Обращения создаются",
                    showPreviousResultsDuringEvaluation:
                        "Показывать результаты предыдущей оценки чек-листа",
                    canBeFilledByManager:
                        "Может быть заполнен менеджером или территориальным директором",
                    canBeFilledByExternalUser: "Может быть заполнен внешним пользователем",
                },
                items: {
                    title: "Шаги",
                    editTitle: "Редактировать шаг",
                    addTitle: "Добавить шаг",
                    insertSearchText: "Укажите текст для поиска. Не менее %s символов",
                    fields: {
                        title: "Наименование",
                        description: "Описание",
                        requirement: "Требование",
                        samplePhoto: "Образец",
                        id: "ID",
                        template: "Шаблон",
                        category: "Категория",
                    },
                    deleteConfirm: {
                        title: "Удалить шаг?",
                        text: 'Вы точно хотите удалить шаг  "%s" ?',
                        okText: "Да, удалить",
                    },
                    deleteConfirmItems: {
                        title: "Удаление шагов",
                        text: "Вы точно хотите удалить %p#steps# ?",
                        okText: "Да, удалить",
                    },
                    success: {
                        updated: "Шаги шаблона изменены",
                        itemUpdated: "Шаг шаблона изменен",
                        itemsDeleted: "%p#steps# удалено",
                    },
                    errors: {
                        updated: "Не удалось изменить шаги шаблона!",
                        itemUpdated: "Не удалось изменить шаг шаблона!",
                        notFound: "Не удалось найти шаги шаблонов!",
                        itemsDeleted: "Не удалось удалить шаги шаблонов!",
                    },
                },
                copy: {
                    title: "Копирование шаблона",
                },
            },
            templateCategory: {
                title: "Редактировать категорию",
                addTitle: "Новая категория",
                fields: {
                    title: "Название",
                },
            },
            checkListItem: {
                tooltips: {
                    retry: "Изменить снимок",
                    capture: "Сделать снимок",
                    example: "Посмотреть пример",
                },
                example: {
                    title: "Пример",
                },
                finish: {
                    success: "Чек-лист отправлен на проверку!",
                    sendForCheck: "Отправить на проверку",
                    stay: "Не хочу",
                    continue: "Хочу",
                    confirmMessage: "Вы действительно хотите отправить чек-лист на проверку?",
                    quizBeforeConfirmMessage: "Пройдите опрос перед отправкой ответов на проверку",
                },
                errors: {
                    save: "Не удалось сохранить данные.",
                },
            },
            checkList: {
                title: "Чек-листы ОУК",
                status: "Статус чек-листа",
                startDate: "Период с",
                endDate: "Период по",
                fields: {
                    createdDate: "Дата создания",
                    title: "Название",
                    tradePointName: "Кофейня",
                    evidenceCollectorName: "Сборщик фото",
                    evidenceCollectionFinished: "Дата заполнения",
                    evaluationFinished: "Дата оценки",
                    evaluatedBy: "Проверяющий",
                    actions: "Действия",
                },
                actions: {
                    photo: "Заполнить чек-лист",
                    delete: "Удалить чек-лист",
                    user: "Назначить проверяющего",
                    check: "Оценить",
                    view: "Посмотреть",
                    deleteConfirm: {
                        title: "Удалить чек-лист",
                        text: 'Вы уверены, что хотите удалить чек-лист "%s"',
                        okText: "Да, удалить",
                    },
                },
                userSelector: {
                    title: "Назначить ответственного",
                    okText: "Назначить",
                    onReset: "Удалить ответственного",
                    user: "Ответственный",
                    fields: {
                        imageId: "Фото",
                        fullName: "ФИО",
                        tradePoints: "Кофейня",
                        role: "Роль",
                        phone: "Телефон",
                    },
                },
                errors: {
                    loadData: "Не удалось получить список чек-листов!",
                    initStartInspector: "Не удалось назначить начального инспектора для чек-листа!",
                    remove: "Не удалось удалить чек-лист!",
                    assignCollector: "Не удалось назначить ответственного на заполнение чек-листа!",
                    resetCollector: "Не удалось удалить ответственного на заполнение чек-листа!",
                },
                success: {
                    remove: "Чек-лист удален",
                    assignCollector:
                        '%s назначен ответственным за заполнение чек-листа "%s" на кофейне "%s"',
                    resetCollector: "Ответственный удален",
                },
                add: {
                    title: "Назначение чек-листов",
                    save: "Назначить",
                    fields: {
                        templates: "Шаблоны чек-листов",
                        tradePoints: "Кофейни",
                    },
                    success: {
                        assign: "Назначено: %p#checkList#",
                    },
                    errors: {
                        templates: "Не удалось получить список шаблонов!",
                        assign: "Не удалось назначить чек-листы!",
                        tradePoints: "Не удалось получить список кофеен!",
                    },
                },
            },
            result: {
                title: "Результат: %s",
                show: "Показать результаты опроса",
                values: {
                    tradePoint: "Кофейня",
                    status: "Статус шага",
                    evidenceCollector: "Сборщик фото",
                    inspector: "Проверяющий",
                    evaluationDate: "Период оценки",
                    evidenceCollectionDate: "Период заполнения",
                    createdDate: "Дата назначения",
                },
                itemStatusFilter: {
                    all: "Все",
                    onlyBad: "С нарушениями",
                    onlyGood: "Без нарушений",
                },
                itemStatusFilterLabel: "Статус",
                prevImage: "Фото с пред. проверки",
                complaint: "Обращение",
                errors: {
                    loadData: "Не удалось получить информацию о текущем чек-листе!",
                },
            },
            evaluation: {
                title: "Оценка чек-листа",
                toComplaint: "Перейти к обращению",
                createComplaint: "Создать обращение",
                toCheckList: "К чек-листу",
                success: {
                    createComplaint: 'Обращение создано по шагу "%s"',
                    finishEvaluation: "Чек-лист проверен",
                },
                errors: {
                    loadData: "Не удалось получить информацию о чек-листе!",
                    createComplaint: "Не удалось создать обращение по чек-листу!",
                    finishEvaluation: "Не удалось сохранить результаты проверки!",
                },
            },
            outsources: {
                title: "Рейтинг аутсорсов",
                managerRate: "Оценка менеджера",
                inspectorRate: "Оценка инспектора",
                rates: "оценок",
            },
        },
        clients: {
            client: {
                title: "Информация о госте",
                noRecords: "Информация не найдена",
                comments: "Заметки оператора",
                highRiskInfo: {
                    highRiskTitle: "Высокий риск",
                    highRiskComment: "Причина",
                    saveButtonTitle: "Сохранить",
                    saveSuccessText: "Успешное обновление высокого риска",
                },
                search: {
                    title: "Поиск гостя",
                    noRecords: "Гости не найдены",
                    mobile: "Мобильное приложение",
                },
                errors: {
                    userNotFound: "Пользователь не найден",
                },
                success: {
                    update: "Данные гостя изменены",
                    contactUpdate: "Контакт гостя изменен",
                    contactRemove: "Контакт гостя удален",
                },
                base: {
                    title: "Общая информация",
                    clientBase: "Информация",
                    mobile: "Мобильное приложение",
                    name: "Имя",
                    category: "Категория",
                    companyUser: "Сотрудник",
                    phone: "Телефон",
                    car: "Машина",
                    createdDate: "Дата создания",
                    createdAt: "Дата регистрации",
                    registrationPromo: "Промокод",
                    isReferralProgramActivated: "Реф. программа",
                    isReferralProgramActivated1: "Сработала",
                    isReferralProgramActivated0: "Не сработала",
                    referrerPhone: "Рекомендатель",
                    bonus: "Количество бонусов",
                    noRecords: "Информация не найдена",
                    editCategory: {
                        title: "Изменить категорию пользователя",
                    },
                },
                orders: {
                    title: "Заказы гостя",
                    noPhones: "У гостя нет номеров телефонов",
                    orderNum: "Номер заказа",
                    accountingDate: "Дата",
                    openTime: "Время заказа (на кассе)",
                    printTime: "Время операции (на сервере)",
                    totalPrice: "Сумма",
                    priceWithoutDiscount: "Сумма без скидки",
                    paymentDescription: "Тип транзакции",
                    paymentPrice: "Сумма",
                    userPhone: "Телефон клиента",
                    noRecords: "У гостя еще нет заказов. Что странно...",
                    errors: {
                        loadData: "Не удалось получить список заказов!",
                    },
                },
                complaints: {
                    title: "Обращения",
                    tradePoint: "Кофейня",
                    dateTime: "Дата",
                    complaintStatus: "Статус",
                    clientBonusPoints: "Бонусы",
                    mark: "Оценка",
                    description: "Обращение",
                    noRecords: "Нет данных",
                },
                preOrderCancels: {
                    title: "Отмена предзаказов",
                },
                contacts: {
                    title: "Контакты",
                    addTitle: "Добавить контакт",
                    editTitle: "Редактировать контакт",
                    noRecords: "Нет контактов",
                    actions: {
                        copy: "Скопировать",
                        edit: "Редактировать",
                        delete: "Удалить",
                        copied: 'Текст "%s" скопирован в буфер обмена',
                        whatsApp: "в WhatsApp",
                        telegram: "в Telegram",
                    },
                    deleteConfirm: {
                        title: "Удалить контакт",
                        text: 'Вы уверены, что хотите удалить контакт "%s"',
                    },
                    fields: {
                        contactPhone: "Номер телефона",
                        contactEmail: "E-mail",
                        contactTelegram: "Логин",
                        contactType: "Тип контакта",
                        description: "Описание",
                        isMain: "Предпочтительный способ связи",
                    },
                    errors: {
                        required: "Поле обязательно к заполнению",
                        email: "Укажите корректный Email",
                        phone: "Укажите корректный номер телефона",
                        telegram: "Укажите корректный логин в Telegram",
                    },
                },
                bonusHistory: {
                    title: "История выдачи бонусов",
                    details: "Подробности операции",
                    fields: {
                        category: "Статья",
                        bonus: "Кол-во баллов",
                        phone: "Номер телефона",
                        changeType: "Тип пополнения",
                        updatedUser: "Кто начислил",
                        description: "Комментарий",
                        startDate: "Дата мероприятия",
                        department: "Инициатор/отдел",
                        number: "Номер сертификата",
                    },
                },
                merger: {
                    title: "Объединить карточки",
                    merge: "Объединить",
                    fields: {
                        id: "ID",
                        name: "Имя",
                        contact: "Контакт",
                        createdDate: "Создан",
                        category: "Категория",
                    },
                    success: {
                        merge: "%p#clientCards# объеденины",
                    },
                    errors: {
                        merge: "Ошибка при попытке объединения карточек",
                    },
                },
            },
        },

        offences: {
            edit: {
                title: "Нарушения",
                actions: {
                    editCategory: 'Редактировать категорию "%s"',
                    editItem: 'Редактировать нарушение "%s"',
                    new: "Добавить",
                },
                category: "Категория",
                item: "Нарушение",
                fields: {
                    name: "Название",
                    type: "Тип",
                    points: "Баллы",
                    categoryId: "Категория нарушений",
                },
                success: {
                    editCategory: "Категория нарушения изменена",
                    addCategory: "Категория нарушения добавлена",
                    addItem: "Нарушение добавлено",
                    editItem: "Нарушение изменено",
                    removeItem: 'Нарушение "%s" удалено',
                    new: "Запись добавлена",
                },
                errors: {
                    editCategory: "Ошибка при попытке редактирования категории нарушения",
                    addCategory: "Ошибка при попытке создания категории нарушения",
                    addItem: "Ошибка при попытке создания нарушения",
                    editItem: "Ошибка при попытке редактирования нарушения",
                    removeItem: "Ошибка при попытке удаления нарушения",
                    new: "Ошибка при добавлении записи",
                    name: "Укажите название",
                    points: "Укажите кол-во  баллов",
                    noRecords: "В данной категории еще нет нарушений",
                },
                deleteConfirm: {
                    title: "Удалить нарушение",
                    text: 'Вы уверены, что хотите удалить нарушение "%s"?',
                    okText: "Да, удалить",
                },
            },
        },
        claims: {
            title: {
                main: "Обращения",
                progress: "Обращения в обработке",
                processed: "Обработанные обращения",
                feedbackClarification: "Обращения на уточнении",
                guestCommunication: "Обращения второй линии",
                guestRating: "Обращения третьей линии",
                protest: "Запросы на возврат",
                additionalComments: "Дозапросы менеджера",
            },
            add: "Добавить обращение",
            noRecords: "Обращений не найдено",
            filter: {
                okkFilter: "Отправитель ОУК",
                status: "Статус",
                tradePointId: "Кофейня",
                isRead: "Только непрочитанные",
                search: "Текст для поиска",
                startDate: "Созданы не позднее",
                isGuestCommunicationRequired: "Повторная коммуникация",
                categoryIds: "Категории",
            },
            fields: {
                id: "ID",
                date: "Дата",
                deadline: "Дедлайн",
                tradePoint: "Кофейня",
                status: "Статус",
                operator: "Оператор",
                inspector: "Инспектор",
                info: "Информация",
            },
            info: {
                client: "Гость: %s",
                category: "Категория: %s",
                clientBonusPoints: "Бонусов начислено: %s",
            },
            protest: {
                add: "Не согласен, вернуть в работу",
                confirm: 'Вернуть в "В работе"',
                cancel: "Отказать в возврате",
                reason: "Причина",
                errors: {
                    addProtest: "Не удалось опротестовать решение!",
                    confirmProtest: "Не удалось вернуть в работу!",
                    cancelProtest: "",
                },
                success: {
                    addProtest: "Ваш запрос отправлен! Ожидайте решения в ближайшее время",
                    confirmProtest: 'Обращение возвращено в статус "В работе"',
                    cancelProtest: 'Обращение возвращено в статус "Обработано c нарушениями"',
                    submittedToCommission: "Обращение вынесено на Комиссию",
                },
                submitToCommission: "Вынести на Комиссию",
            },
            additionalComments: {
                add: "Ответить на дозапрос",
                success: {
                    addAdditionalComment: "Дозапрос отправлен",
                    removeAdditionalComment: "Ответ на дозапрос отправлен",
                },
                errors: {
                    addAdditionalComment: "Не удалось отправить дозапрос!",
                    removeAdditionalComment: "Не удалось ответить на дозапрос!",
                },
                manager: {
                    add: "Дозапросить информацию",
                    value: "Каких данных вам не хватает",
                    save: "Отправить",
                },
            },
            edit: {
                orderDetailInfo: {
                    modalTitle: "Информация о деталях заказа",
                    dishName: "Наименование блюда",
                    dishCount: "Количество",
                    dishPrice: "Цена за шт",
                    orderCreateDate: "Время заказа",
                    orderDate: "Дата заказа (примерно)",
                    orderDateHint: "Заказ ищется в диапазоне +-месяц от указанной даты",
                    closeTime: "Время закрытия",
                    noData: "Данные не найдены",
                },
                title: "Обработка обращения",
                editTitle: "%s на кофейне %s",
                addTitle: "Создание обращения",
                params: "Параметры",
                paramsDescription: "Заполните все поля",
                clientDetails: "Информация о госте",
                iikoOrderNumberEdit: "Номер заказа",
                inspectorResolution: {
                    title: "Заключение инспектора",
                },
                iikoBonusesAdd: {
                    modalTitle: "Добавление бонусов гостю",
                    clientContactsTitle: "Телефон гостя",
                    bonusesCountTitle: "Количество бонусов",
                    successAddBonuses: "Бонусы успешно начислены",
                    errorAddBonuses: "Ошибка при зачислении бонусов",
                },
                fields: {
                    clientId: "Гость",
                    tradePointId: "Кофейня",
                    tradePointIds: "Кофейни",
                    dateTime: "Время отзыва",
                    dateTimeMobileApp: "Время заказа",
                    categories: "Категории",
                    clientBonusPoints: "Бонусов начислено гостю",
                    clientBonusPointsByOperator: "Бонусов начислено оператором",
                    clientBonusPointsByInspector: "Бонусов начислено инспектором",
                    complaintStatus: "Статус обращения",
                    videoChecksCount: "Проверено видео",
                    videoExtraChecksCount: "Дополнительно проверено видео",
                    complaintDescription: "Описание",
                    files: "Файлы",
                    sourceType: "Источник поступления сообщения",
                    inspector: "Проверяющий",
                    operator: "Оператор",
                    guestCommunicationFinishDate: "Коммуникация с гостем завершена",
                    guestCommunicationStatus: "Коммуникация с гостем",
                    guestCommunicationStatus0: "Не требуется",
                    guestCommunicationStatus1: "Требуется повторная",
                    isOkkQualitySurveyRequired: "Запросить оценку качества обслуживания",
                    okkQualitySurveyStatus: "Оценка качества обслуживания",
                    okkNote: "Заметки ОУК",
                    gptSuitableResponse: "Уместный ответ на обращение (*сгенерирован gpt)",
                    comments: "Обсуждение обращения",
                    tags: "Теги",
                    offenseItemIds: "Нарушения",
                    address: "Адрес",
                    legalPersonName: "Юр. лицо",
                    guestCommunicationImages: "Фото переписки с гостем",
                    guestCommunicationRating: "Оценка коммуникации с гостем",
                },
                gptAssistance: {
                    feedbackSuitableResponse: "gpt уместный ответ на обращение...",
                    feedbackSuitableTags: "gpt теги...",
                    feedbackSuitableCategories: "gpt категории...",
                },
                success: {
                    add: "%p#complaints# создано",
                    iikoOrderNotFound: "Заказ найден",
                    gptDataApplied: "Данные от GPT Куку успешно применены!",
                    guestCommunicationUpdated: "Фото коммуникации загружено",
                },
                errors: {
                    load: "Не удалось получить информацию об обращении!",
                    add: "Не удалось создать обращение",
                    reOpenComplaint: "Не удалось переоткрыть обращение",
                    createOkkQualitySurvey: "Не удалось запросить оценку гостем",
                    updateComplaint: "Не удалось отредактировать обращение",
                    haveOffenses:
                        'Нельзя закрыть обращение со статусом "Обработано" так как у него имеются незакрытые нарушения',
                    haveOffensesAction: "Сейчас исправлю",
                    notHaveOffenses: "Необходимо указать нарушения",
                    actionNotFound: "Действие не найдено",
                    loadTags: "Не удалось загрузить список тегов. Попробуйте обновить страницу!",
                    addTag: "Не удалось добавить новый тег!",
                    iikoOrderNotFound: "Заказ не найден",
                    iikoOrderNotChecked: "Заказ не проверен",
                    guestCommunicationImageIds: "Загрузите фото переписки с гостем",
                },
                actions: {
                    save: "Сохранить изменения",
                    send: "Отправить в GPT Куку",
                },
                noFilesText: "Нет загруженных файлов",
            },
            qCCheckListData: {
                title: "Информация о Чек-листе",
                checklist: "Наименование чек-листа",
                checklistItem: "Наименование пункта чек-листа",
                date: "Время прохождения чек-листа",
                requirement: "Требование",
            },
            secretVisitsData: {
                title: "Информация об Анкете",
                checklist: "Наименование анкеты",
                checklistItem: "Наименование пункта анкеты",
                date: "Время прохождения анкеты",
                requirement: "Требование",
            },
            tradePointCheckListData: {
                title: "Информация о Чек-листе",
                checklist: "Наименование чек-листа",
                checklistItem: "Наименование пункта чек-листа",
                date: "Время прохождения чек-листа",
                period: "Период для прохождения чек-листа",
            },
            inputOrderNumber: {
                title: "Номер заказа",
                saveButton: "Сохранить",
            },
            mobileApp: {
                title: "Информация из Мобильного приложения",
                main: "Общее",
                mark: "Оценка",
                orderNumber: "Номер заказа",
                mobileApp: "Мобильное приложение",
                isWindow: "Окно/телефон",
                closeDate: "Время закрытия",
                isFromMobileApp: "Источник заказа",
                payment: "Оплата",
                orderCreateDate: "Время заказа",
                createdDate: "Время отзыва",
                noCriteria: "Критерии не выбраны",
                criteriaBads: "Отрицательные критерии",
                criteriaGoods: "Положительные критерии",
                files: "Вложения",
                details: "Позиции",
                totalPrice: "Сумма: %p#rubs#",
                additionalGuestSurvey: "Показать результаты дополнительного опроса",
                additionalGuestSurveyTitle: "Результаты опроса от %s",
                comment: "Комментарий",
                guestComment: "Комментарий гостя",
            },
            permission: {
                manager: {
                    toWaitingDecision: "Отправить на проверку",
                    toWaitingDecisionAlert: "Обращение передано на проверку",
                    toInProgress: "Доуточнить комментарии",
                    toInProgressAlert: "Обращение возвращено для уточнения",
                },
                dutyOperator: {
                    close: "Закрыть обращение",
                    closeAlert: "Обращение Закрыто",
                    guestCommunication: "Оценить коммуникацию с гостем",
                    guestCommunicationAlert: "Оценка сохранена",
                    toWaitingDecision: "Отправить на проверку",
                    toWaitingDecisionAlert: "Обращение передано на проверку",
                },
                inspector: {
                    guestCommunication: "Оценить коммуникацию с гостем",
                    guestCommunicationAlert: "Оценка сохранена",
                    reOpen: 'Вернуть в "Ожидает решения"',
                    reOpenAlert: 'Обращение возвращено в статус "Ожидает решения"',
                    toInProgress: "Отправить в работу",
                    toInProgressAlert: "Обращение отправлено в работу",
                    toWaitingDecision: "Отправить на проверку",
                    toWaitingDecisionAlert: "Обращение передано на проверку",
                },
            },
            errors: {
                dataLoad: "Не удалось загрузить список обращений. Попробуйте позже",
            },
            offences: {
                title: "Нарушения",
                points: "%p#scores#",
                add: "Добавить нарушение",
                offence: "Нарушение",
                type: "Тип",
                delete: "Удалить нарушение",
                cancel: "Аннулировать нарушение",
                canceled: "Аннулировано",
                userId: "Сотрудник",
                otherUser: "Другой сотрудник",
                success: {
                    cancel: "Нарушение аннулировано",
                },
                errors: {
                    cancel: "Не удалось аннулировать нарушение",
                },
            },
        },
    },
    operationCards: {
        config: {
            title: "КСО",
            deletedTitle: "Удаленные КСО",
            logs: "История изменений",
            addTitle: "Новый КСО",
            editTitle: "Изменить КСО",
            main: "Основное",
            deletedDate: "Дата удаления",
            restore: "Восстановить",
            copy: {
                title: "Скопировать запись",
                copy: "Копия %s",
            },
            deleteConfirm: {
                title: "Удалить КСО",
                text: 'Вы хотите удалить КСО "%s"?',
                okText: "Да, удалить",
            },
            success: {
                save: "Запись изменена",
                remove: 'Запись "%s" удалена',
                removeStep: "Шаг удален",
                saveOrderSteps: "Порядок шагов изменен",
                restoreRecord: "Запись восстановлена",
                copyRecord: "Запись скопирована",
            },
            errors: {
                loadData: "Не удалось получить записи",
                getRecord: "Не удалось получить запись!",
                save: "Не удалось изменить запись!",
                saveEquipments: "Не удалось изменить список оборудования!",
                saveIngredients: "Не удалось изменить списка ингридиентов!",
                remove: "Не удалось удалить запись!",
                addStep: "Не удалось добавить шаг производства!",
                removeStep: "Не удалось удалить шаг!",
                saveOrderSteps: "Не удалось изменить порядок шагов!",
                restoreRecord: "Не удалось восстановить КСО!",
                copyRecord: "Не удалось скопировать запись!",
            },
            equipments: {
                title: "Оборудование и инвентарь",
                noRecords: "Нет выбранного оборудования",
            },
            ingredients: {
                title: "Ингредиенты",
                noRecords: "Нет выбранных ингредиентов",
                measure: "Количество",
                ingredientResult: "Итоговый выход",
            },
            steps: {
                title: "Шаги производства",
                deleteText: 'Вы уверены, что хотите это удалить шаг "%s"?',
                fields: {
                    order: "№",
                    title: "Наименование",
                    duration: "Время, сек",
                    description: "Описание",
                    successResult: "Показатели успешного выполнения",
                    failResult: "Последствия невыполнения",
                    saveOrder: "Сохранить порядок шагов",
                },
            },
        },
        logs: {
            title: "История изменений",
            errors: {
                loadData: "Не удалось загрузить данные!",
            },
        },
    },
    polls: {
        poll: {
            title: "Опросы",
            fields: {
                title: "Название",
                startDate: "Дата начала опроса",
                endDate: "Дата окончания опроса",
            },
            errors: {
                getList: "Ошибка при получении списка опросов",
                getById: "Ошибка при получении данных опроса!",
                add: "Ошибка при сохранении результата опроса",
            },
            success: {
                add: "Опрос пройден",
            },
            noRowsLabel: "Нет доступных опросов",
            checklistInfo: "Информация о чек-листе",
            evidenceCollector: "Сборщик фото",
            checklistOutsourcePoll: {
                endMessage: {
                    badRate:
                        "Дорогой друг, благодарим тебя за обратную связь. Нам очень жаль, что проверка сформировала у тебя такое впечатление. Мы сейчас же начнем работать над исправлением ситуации. Надеемся, что ты вернешься к нам снова!",
                    goodRate:
                        "Дорогой друг, благодарим тебя за обратную связь. Нам есть над чем поработать и в ближайшее время постараемся исправить ситуацию в лучшую сторону. Надеемся снова встретиться с тобой на проверках!",
                    perfectRate:
                        "Дорогой друг, благодарим тебя за обратную связь. Ждем тебя снова!",
                },
            },
            checklistManagerPoll: {
                endMessage: {
                    badRate:
                        "Коллега, очень жаль, что так получилось. Мы сейчас же начнем работать над исправлением ситуации и проведем с аутсорсом серьезную работу. Спасибо, что не остался в стороне и поделился своими впечатлениями",
                    goodRate:
                        "Дорогой коллега, спасибо, что поделился впечатлениями. Несомненно, есть над чем поработать. Возьмем данного аутсорса под особый контроль",
                    perfectRate:
                        "Дорогой друг, благодарим тебя за обратную связь. Ждем тебя снова!",
                },
            },
            endMessage: "Спасибо за прохождения опроса",
            notFound: "Прохождение опроса не доступно для вас. Возможно вы уже его прошли!",
            toHome: "На главную",
            toBack: "К списку опросов",
        },
        instances: {
            add: "Новый опрос",
            title: "Назначенные опросы",
            oukTitle: "Опросы ОУК",
            noAnswer: "Без ответа",
            fields: {
                title: "Название",
                type: "Тип",
                roles: "Роли",
                description: "Описание",
                startDate: "Дата начала опроса",
                endDate: "Дата окончания опроса",
                count: "Опрошено человек",
                userRolesTitle: "Роли пользователей",
                template: "Шаблон",
            },
            errors: {
                getPollReport: "Не удалось получить результаты опроса!",
                getById: "Ошибка при получении данных опроса",
                add: "Ошибка при добавлении опроса",
                edit: "Ошибка при редактировании опроса",
                remove: "Ошибка при удалении опроса",
                view: "Ошибка при получении информации о опросе",
            },
            success: {
                add: "Опрос добавлен",
                edit: 'Опрос "%s" отредактирован',
                remove: 'Опрос "%s" удален',
            },
            remove: {
                title: "Удалить опрос",
                text: 'Вы уверены, что ходите удалить опрос "%s"?',
                okText: "Да, уверен",
            },
            details: {
                title: "Результат опроса",
            },
        },
        feedbacks: {
            title: "Обратная связь по опросам",
            addAnswerAdmin: "Добавить ответ администратора",
            questionText: "Вопрос",
            resolutionAnswer: "Ответ УК",
            noData: "Нет данных",
            question: "Вопрос",
            detailsAnswer: "Детали ответа",
            userAnswer: "Ответ пользователя",
            description: "Подробности",
            success: "Ваш ответ добавлен",
            error: "Произошла ошибка во время добавления ответа",
        },
        templates: {
            add: "Новый шаблон",
            title: "Шаблоны опросов",
            remove: {
                title: "Удалить опрос",
                text: 'Вы уверены, что ходите удалить опрос "%s"?',
                okText: "Да, уверен",
            },

            fields: {
                description: "Описание",
                type: "Тип опроса",
                endMessage: "Сообщение после прохождения",
                updatedDate: "Изменен",
            },
            errors: {
                add: "Ошибка при добавлении опроса!",
                edit: "Ошибка при редактировании опроса!",
                getById: "Ошибка при получении данных опроса!",
                remove: "Ошибка при удалении опроса!",
                loadData: "Ошибка при получении списка опросов",
            },
            success: {
                add: 'Опрос "%s" добавлен',
                edit: 'Опрос "%s" отредактирован',
                remove: 'Опрос "%s" удален',
            },
            items: {
                title: "Вопросы",
                addItemTitle: "Новый вопрос",
                answers: {
                    title: "Варианты ответов",
                    count: "%s Вариантов ответов",
                },
                fields: {
                    title: "Заголовок",
                    description: "Описание",
                    type: "Тип",
                    isRequired: "Обязательно для заполнения",
                },
                remove: {
                    title: "Удалить вопрос",
                    text: 'Вы уверены, что ходите удалить вопрос "%s"?',
                    okText: "Да, уверен",
                },
                inputProps: {
                    minValue: "Минимальное значение",
                    maxValue: "Максимальное значение",
                    icon: "Изображение",
                    example: "Пример",
                    icons: {
                        star: "Звезда",
                        favorite: "Сердце",
                        coffee: "Чашка кофе",
                        faces: "Смайлики",
                    },
                    slider: "от %s до %s",
                },
            },
        },
        report: {
            title: "Отчеты",
            instances: "Выберите опрос",
            selectList: "Выберите опрос из списка",
            download: "Скачать отчет",
        },
    },
    profile: {
        dismissDate: "Дата увольнения",
        title: "Профиль",
        myProfile: "Мой профиль",
        learning: "Обучение",
        rating: {
            inspectorRate: "Оценка инспектора",
            managerRate: "Оценка менеджера",
            averageRage: "Средняя оценка",
            fields: {
                tradePoint: "Кофейня",
                checklist: "Чек-лист",
                checkDate: "Дата проверки",
                comment: "Комментарий",
                impression: "Общее впечатление",
                photoQuality: "Качество фото",
                rate: "Общая оценка",
            },
        },
        userMenu: {
            title: "Настройки",
            image: "аватар",
            actions: {
                avatar: "Загрузка аватара",
                messagesConfig: "Настройка оповещений",
                password: "Смена пароля",
            },
            siteConfig: {
                deviceLimitAdmin: "Лимит устройств (админ)",
                title: "Настройки сайта",
                theme: "Тема сайта",
                themes: {
                    light: "Светлая",
                    dark: "Темная",
                    system: "От настроек браузера",
                },
            },
            biometricConfig: {
                title: "Настройки биометрии",
            },
            devices: {
                title: "Устройства",
                titleBio: "Мои устройства (биометрия)",
                titleSimple: "Мои устройства (без биометрии)",
                delete: "Удалить",
                emptyBio: "Нет зарегистрированных устройств",
                emptySimple: "Нет зафиксированных устройств",
                lastUsed: "Последнее использование: %s",
                lastSeen: "Последняя активность: %s",
                removeSuccess: "Удалено",
                removeError: "Ошибка удаления",
            },
            errors: {
                setIcon: "Не удалось загрузить изображение!",
                savePassword: "Не удалось изменить пароль!",
                saveSiteConfig: "Не удалось изменить настройки сайта!",
            },
            success: {
                savePassword: "Пароль успешно изменен!",
                saveSiteConfig: "Настройки сайта успешно изменены!",
            },
        },
        main: {
            title: "Личные данные",
            birthDate: "Дата рождения",
            lastVisitDate: "Последний вход",
        },
        grades: {
            title: "Грейды",
            gradeTree: "Дерево грейдов",
            history: "История",
            noHistory: "Нет шагов с тестами",
            fields: {
                title: "Наименование",
                expirationDate: "Пройти до",
                status: "Статус",
                createdDate: "Дата создания",
                sessionBegin: "Дата начала",
                sessionEnd: "Дата окончания",
                grade: "Грейд",
            },
            errors: {
                getUserHistory: "Не удалось получить информацию о прохождении уроков!",
            },
        },
        innerLearning: {
            title: "Обучение",
        },
        courses: {
            title: "Курсы",
            passDate: "Пройден",
            noRecords: "Нет пройденных курсов",
            empty: "пусто",
        },
        lessons: {
            title: "Уроки",
            activeLessons: "Назначенные уроки",
            created: "Назначено",
            inProgress: "В процессе",
            unlimited: "Не ограничено",
            notAvailable: "Действие не доступно",
            waitingConfirm:
                "Урок ожидает подтверждения. Обратитесь к своему менеджеру/сотруднику академии",
            confirm: {
                text: 'Приступить к прохождению урока "%s"?',
                okText: "Да, приступить",
            },
            fields: {
                title: "Наименование",
                expirationDate: "Пройти до",
                status: "Статус",
                createdDate: "Дата назначения",
                sessionBegin: "Дата начала",
                sessionEnd: "Дата окончания",
            },
            historyLessons: "История",
            errors: {
                loadData: "Не удалось получить информацию о прохождении уроков!",
            },
        },
        userRating: {
            title: "Рейтинг",
        },
        editorMenu: {
            changeRole: {
                action: "Сменить роль/дерево грейдов",
                title: "Смена роли и дерева грейдов",
                label: "Роль",
                gradeTreeIds: "Дерево грейдов",
                save: "Сменить",
                success: "У сотрудника изменена роль",
                error: "Ошибка при попытке изменения роли",
            },
            changeEmployee: {
                action: "Кадровые изменения",
                title: "Перемещение/смена должности сотрудника",
                tradePoint: "Место работы",
                employee: "Должность",
                isOfficial: "Официальный статус",
                employmentRate: "Ставка ШЕ",
                employmentOfficialRate: "Ставка",
                employmentFile: "Копия заявления от сотрудника",
                save: "Переместить",
                success: "Сотрудник перемещен в другую кофейню",
                error: "Ошибка при попытке перемещения сотрудника в другую кофейню",
                changeParams: {
                    title: "Запрос на корректировку кадровых изменений",
                    tooltip: "Запрос на корректировку",
                    commentToChange: "Описание запроса",
                    formTooltip:
                        "На основе этого запроса будет создана заявка в отдел кадров от вашего имени",
                    save: "Запросить корректировку",
                    success:
                        'Запрос на корректировку успешно создан. Заявку можно будет увидеть в разделе "Заявки в УК -> Заявки',
                    error: "Ошибка при создании запроса на корректировку",
                },
            },
            changePassword: {
                action: "Сменить пароль",
                title: "Смена пароля",
                newPassword: "Новый пароль",
                confirmPassword: "Подтвердите пароль",
                save: "Сохранить",
                passwordMismatch: "Пароли не совпадают",
                success: "Пароль успешно изменен",
                error: "Ошибка при смене пароля",
            },
            changeStatus: {
                action: "Уволить",
                title: "Увольнение сотрудника: %s",
                okText: "Уволить",
                success: "Сотрудник уволен",
                error: "Ошибка при попытке увольнения сотрудника",
                defaultReason: "по инициативе работника (по собственному желанию)",
                iikoLink: "Привязка прошла успешно",
                reasonTypeCategory: "Инициатор увольнения",
                reasonType: "Причина увольнения",
                reason: "Комментарий",
                blackList: "Занести в черный список",
                blackListReasonType: "Причина добавления в черный список",
                deferredDismissal: "Отложенное увольнение",
                dismissAt: "Дата увольнения",
            },
            edit: {
                action: "Редактировать",
            },
            iiko: {
                title: "Привязка сотрудника к данным iiko",
                userLabel: "Данные сотрудника",
                iikoUsers: "Сотрудник в iiko",
                save: "Сохранить",
                errorName: "Ошибка привязки сотрудника iiko",
                errorMessage: "Сотрудник уже имеет привязку к сотруднику iiko",
            },
        },
        phoneConfirm: {
            confirmed: "Подтвержден",
            notConfirmed: "Не подтвержден",
            title: "Подтверждение номера телефона",
            confirmCode: "Код подтверждения",
            confirmCodeDescription: "Введите сюда код, который пришел вам в СМС",
            text: `<p>Вам необходимо подтвердить, что телефон с номером <strong>%s</strong> принадлежит вам. Раскройте один из вариантов ниже и следуйте шагам.</p>`,
            telegramSteps: `<ul>
                        <li>Перейдите в нашего <strong>Telegram-бота</strong> по кнопке внизу блока</li>
                        <li>Напишите ему <strong>Привет</strong></li>
                        <li>Выберите в меню кнопку <strong>Подтвердить номер телефона</strong></li>
                        <li>Подтвердите запрос об <strong>Поделиться контактом</strong></li>
                        <li>Если всё сделано верно, вы увидите сообщение <strong>Номер телефона успешно подтвержден</strong></li>
                    </ul>`,
            maxSteps: `<ul>
                        <li>Перейдите в нашего <strong>бота в Max</strong> по кнопке внизу блока</li>
                        <li>Он запросит проверку номера телефона</li>
                        <li>Выберите в меню кнопку <strong>Подтвердить номер телефона</strong></li>
                        <li>Подтвердите запрос <strong>Поделитесь телефоном</strong></li>
                        <li>Если всё сделано верно, вы увидите сообщение о том, что Вас внесли Вас базу.</li>
                    </ul>`,
            toTelegramBot: "Подтвердить через Telegram",
            toMaxBot: "Подтвердить через Max",

            errors: {
                sendSmsToPhoneConfirm: "Не удалось отправить вам смс!",
                confirmPhoneCode: "Не удалось подтвердить ваш телефон!",
            },
            success: {
                confirmPhoneCode: "Ваш номер телефона успешно подтвержден",
            },
            notMyNumber: {
                title: "Не мой номер телефона",
                text: `<p>Если вы НЕ являетесь владельцем номера <strong>%s</strong>, 
                        то вам необходимо написать E-mail по адресу 
                        <a href="mailto:sd@cmachine.ru?subject=Смена номера %s&body=Номер %s мне не принадлежит. Пожалуйста измените его на ...">sd@cmachine.ru</a>.
                        В письме необходимо указать данный номер <strong>%s</strong>, а так же номер на который нужно изменить его.
                    </p>`,
                button: "Это не мой номер телефона",
            },
            noTelegram: {
                title: "У меня нет Telegram-а",
                text: "Тогда его можно завести. Это не сложно и займет несколько минут.",
                okText: "Хорошо, заведу",
                noText: "Нет возможности завести",
                confirmTitle: "Не могу завести Telegram",
                confirmText: `Это очень печально. Тогда придется отправить вам СМС с кодом активации на номер %s. Вы готовы?`,
                confirmOkText: "Да, отправляйте",
                confirmNoText: "Нет, не надо",
            },
            noMax: {
                title: "У меня нет Max",
                text: "Приложение Max можно установить бесплатно — это займёт несколько минут.",
                okText: "Хорошо, установлю",
                noText: "Нет возможности установить",
                confirmTitle: "Не могу установить Max",
                confirmText: `Тогда мы можем отправить вам СМС с кодом подтверждения на номер %s. Продолжить?`,
                confirmOkText: "Да, отправляйте",
                confirmNoText: "Нет, не надо",
            },
        },
        phoneNumberChanger: {
            title: "Смена номера телефона",
            success: "Номер успешно сменён",
            error: "Не удалось изменить номер",
        },
        ndaConfirm: undefined,
    },
    regions: {
        title: "Регионы",
    },
    reports: {
        list: {
            title: "Все отчеты",
            reportType: "Тип отчета",
            searchPlaceholder: "Введите название отчета или категории...",
            noReports: "Нет доступных отчетов",
            notFound: "Отчеты не найдены",
        },
        actions: {
            download: "Скачать отчет",
            view: "Поиск",
        },
        categories: {
            learning: "Отчеты по обучению",
            main: "Отчеты по качеству",
            employees: "Отчеты по документам",
            clients: "Отчеты по гостям",
        },
        fields: {
            categoryIds: "Категория нарушений",
            dateRage: "Период",
            endDate: "Конечная дата",
            gradeStepIds: "Шаги грейдов",
            gradeTree: "Дерево грейдов",
            grades: "Грейды",
            type: "Тип отчета",
            startDate: "Начальная дата",
            lessonIds: "Уроки",
            examinationIds: "Аттестации",
            pollTemplateUid: "Опрос",
            coach: "Наставник",
            student: "Студент",
            articleSelect: "Статья",
            month: "Месяц",
            year: "Год",
            reportPeriod: "Отчетный период",
        },
        errors: {
            download: 'Ошибка при попытке получения отчета "%s"',
            invalidDateInput: "Введены некорректные даты",
        },
        operationalReports: {
            title: "Операционные отчеты",
            reportType: "Тип отчета",
            main: "Скачать",
            showBtnText: "Показать",
            reportPeriod: "Месяц",
            salePlan: {
                planNow: "План на сегодня",
                planMonth: "План на месяц",
                result: "Получено",
                prognosis: "Прогноз выполнения плана",
                total: "Выручка",
                quantity: "Чеки",
            },
            errors: {
                download: "Ошибка при попытке получения отчета",
                noData: "Нет данных для отчета",
            },
        },
        sd: {
            main: "Отчеты по обращениям",
        },
        usersGrades: {
            confirm: {
                title: "Информация о пользователе",
                text: "Перейти в настройки пользователя %s ?",
                okText: "Да, перейти",
            },
        },
        thirdParty: {
            errors: {
                getReportByTradePoint: "Ошибка при получении данных отчета!",
            },
        },
        uk: {
            title: "Отчеты УК",
            reportType: "Тип отчета",
            errors: {
                download: 'Ошибка при попытке получения отчета "%s"',
            },
        },
        oukReportNotes: {
            title: "Комментарии ОУК",
            fields: {
                dateMonth: "Отчетный период",
                tradePoint: "Кофейня",
                inspector1: "Санитарное состояние",
                inspector2: "Техническое состояние",
                inspector3: "Работа с обращениями",
                comment: "Процессы общие",
            },
            errors: {
                save: "Ошибка при сохранении данных",
            },
            success: {
                save: "Данные сохранены",
            },
        },
        clients: {
            categoryId: "Статья",
        },
    },
    salePlan: {
        base: {
            title: "План продаж",
            planDate: "Месяц/Год",
            sum: "Сумма выручки",
            quantity: "Кол-во чеков",
            export: {
                title: "Загрузка файла с планами продаж",
                file: "Файл для загрузки",
                tooltip: "Загрузить файл с планами",
                save: "Загрузить",
                error: "Не удалось загрузить файл на сервер",
                added: "Записей добавлено",
                updated: "Записей обновлено",
                result: "Результат",
                errors: "Ошибки",
            },
        },
        budgetarySalePlan: {
            title: "Бюджетный план продаж",
            planDate: "Месяц/Год",
            sum: "Сумма выручки",
            quantity: "Кол-во чеков",
            export: {
                title: "Загрузка файла с бюджетным планом продаж",
                file: "Файл для загрузки",
                tooltip: "Загрузить файл с бюджетным планом продаж",
                save: "Загрузить",
                error: "Не удалось загрузить файл на сервер",
                added: "Записей добавлено",
                updated: "Записей обновлено",
                result: "Результат",
                errors: "Ошибки",
            },
        },
    },
    scheduledTasks: {
        title: "Регламентные задания",
        dismissTitle: "Намеченные на увольнение",
        executeAt: "Дата выполнения",
        resultText: "Результат",
        main: "Основное",
        extra: "Данные",
        tooltipDismiss: "Редактировать список",
        dismissList: "Намеченные на увольнение",
        deleteConfirm: {
            title: "Удалить намеченного на увольнение",
            text: "Вы уверены, что хотите удалить %s из списка на увольнение ?",
            okText: "Да, удалить",
        },
        tradePointLegalPerson: {
            title: "Отложенное изменение Юр. лица",
        },
    },
    sd: {
        claims: {
            addTitle: "Новая заявка",
            editTitle: "Заявка %s №%s",
            addClaim: "Создать заявку",
            showEmptyCategory: "Показывать пустые",
            search: "Поиск",
            searchPlaceholder: "Введите текст для поиска",
            messengersRequired:
                "Для создания заявки необходимо сделать привязку своего аккаунта в одном из мессенджеров из списка ниже",
            deleteClaim: {
                title: "Удалить заявку",
                text: 'Вы уверены, что хотите удалить заявку "%s"?',
                okText: "Да, удалить",
                error: "Ошибка при удалении заявки!",
                success: "Заявка удалена",
            },
            deleteObserver: {
                title: "Удалить наблюдателя",
                text: 'Вы уверены, что хотите удалить наблюдателя "%s"?',
                okText: "Да, удалить",
                error: "Ошибка при удалении наблюдателя!",
                success: "Наблюдатель %s удален",
            },
            addObserver: {
                success: "Наблюдатель добавлен",
                error: "Ошибка при добавлении наблюдателя!",
            },
            listTitle: "Список заявок",
            myViewTitle: "Моя заявка %s №%s",
            myTitle: "Мои заявки",
            tradePointTitle: "Заявки кофейни",
            noResponsible: "Не назначен",
            comments: "Обсуждение",
            noClaims: "Нет заявок",
            selectTradePoint: "Укажите кофейню",
            myResponsible: "Назначенные мне",
            allCategories: "Все категории",
            menuTitle: "Действия",
            claims: "Заявки",
            commentIsLock: "Внутреннее сообщение",
            commentIsNotLock: "Сообщение заявителю",
            isLockTooltip: "Внутреннее сообщение",
            userDetails: {
                main: "Основное",
                fullName: "Ф.И.О.",
                tradePointName: "Название",
                phone: "Телефон",
                legalPerson: "Юр. лицо",
                ownerType: "Тип собственности",
                sdServiceType: "Тип обслуживания",
                address: "Адрес",
                role: "Роль",
                tradePoint: "Подразделение",
            },
            statuses: {
                active: "Активные",
                closed: "Закрытые",
                waiting: "Отложенные",
            },
            submitBtnText: {
                toInProgress: "Вернуть в работу",
                new: "Взять в работу",
            },
            groups: {
                createdUser: "Заявитель",
                responsible: "Исполнитель",
                main: "Основное",
            },
            fields: {
                id: "Номер",
                createdDate: "Создана в",
                updatedDate: "Обновлена в",
                createdUser: "Заявитель",
                waitingDate: "Ожидать до",
                tradePointId: "Подразделение заявителя",
                categoryId: "Подгруппа",
                subCategoryId: "Группа",
                title: "Заголовок",
                isCritical: "Срочная",
                isCriticalTitle: "Тип заявки",
                isTariffication: "Платная",
                isTarifficationTitle: "Тарификация",
                status: "Статус",
                responsibleId: "Исполнитель",
                visitCost: "Стоимость выезда",
                observers: "Наблюдатели",
                description: "Описание",
                files: "Файлы",
                workHours: "Затрачено часов рабочих",
                extraHours: "Затрачено часов НЕ рабочих",
                tags: "Теги",
                sdDescription: "Заметки",
                addRating: "Оцените задачу",
            },
            success: {
                addClaim: "Заявка создана",
                addRating: "Ваша оценка добавлена",
            },

            errors: {
                addClaim: "Не удалось создать заявку!",
                notFound: "Заявка не найдена",
                getUserDetails: "Не найдена информация о пользователе!",
                toInProgressClaim: 'Не удалось перевести заявку в статус "В работе"!',
                updateClaim: "Не удалось изменить заявку!",
                addComment: "Введите текст или приложите файл",
                getClaims: "Не удалось получить заявки!",
                updateObservers: "Не удалось изменить наблюдателей!",
                addRating: "Не удалось оценить заявку!",
            },
            inputPlaceholder: {
                closed: "Введите комментарий, чтобы вернуть в работу",
                inProgress: "Введите комментарий",
            },
            events: {
                system: "Система",
                types: {
                    observerAdd: "+ наблюдатель",
                    observerRemove: "- наблюдатель",
                    status: "Статус",
                    isCritical: "Тип заявки",
                    isTariffication: "Тарификация",
                    workHours: "Кол-во рабочих часов",
                    extraHours: "Кол-во НЕ рабочих часов",
                    waitingDate: "Дата ожидания",
                    responsible: "Исполнитель",
                    category: "Категория",
                    visitCost: "Стоимость выезда",
                    userLink: "Пользователь",
                },
            },
        },
        claimCategories: {
            title: "Категории заявок",
            fields: {
                title: "Название",
                description: "Описание",
                accessFeatureIds: "Доступы",
                parentId: "Родитель",
                tradePointOwners: "Тип собственности",
                parenTooltip: "Если не указано - то будут применяться настройки родителя",
            },
        },
        rating: {
            responsibleAddTitle: "Оцените заказчика",
            responsibleAddResultTitle: "Заказчик оценен на %s",
            creatorAddTitle: "Оцените работу исполнителя",
            minLength: "Расскажите что случилось? Не менее %s символов",
            creatorAddResultTitle: "Исполнитель оценен на %s",
            rating: "Оценка",
            vote: "Оценить",
            toVote: "Перейдите по ссылке чтобы оценить",
        },
    },
    secretVisits: {
        template: {
            title: "Шаблоны анкет",
            addTitle: "Новый шаблон",
            editTitle: "Изменить шаблон",
            main: "Название",
            errors: {
                save: "Не удалось сохранить шаблон!",
                getRecord: "Не удалось получить шаблон!",
                remove: "Не удалось удалить шаблон!",
                removeGroup: "Не удалось удалить группа вопросов!",
                reorderGroup: "Не удалось изменить порядок группа вопросов!",
                saveQuestions: "Не удалось сохранить вопрос!",
                removeQuestion: "Не удалось удалить вопрос!",
                reorderQuestions: "Не удалось изменить порядок вопросов!",
            },
            success: {
                add: "Шаблон %s создан",
                edit: "Шаблон %s изменен",
                remove: "Шаблон %s удален",
                addGroup: "Группа вопросов %s создана",
                editGroup: "Группа вопросов %s изменена",
                removeGroup: "Группа вопросов %s удалена",
                reorderGroup: "Порядок групп вопросов изменен",
                saveQuestions: "Вопрос %s изменен",
                removeQuestion: "Вопрос %s удален",
                reorderQuestions: "Порядок вопросов изменен",
            },
            groups: {
                title: "Вопросы",
                count: "Кол-во групп",
                addGroup: "Добавить группу вопросов",
                editGroup: "Редактировать группу вопросов",
                saveOrder: "Сохранить порядок групп вопросов",
                isDragEnabled: "Сортировка групп",
            },
            questions: {
                addTitle: "Новый вопрос",
                editTitle: "Редактировать вопрос",
                group: "Группа вопросов",
                type: "Тип",
                synchronize: "Синхронизация",
                rate: "Вес шага",
                isRequiredComment: "Комментарий - обязателен",
                isDragEnabled: "Сортировка вопросов",
                saveOrder: "Сохранить порядок вопросов",
                weights: {
                    title: "Веса для значений",
                    percent: "Кол-во процентов",
                    deleteConfirm: "Вы действительно хотите удалить вес %s?",
                    errors: {
                        emptyWeights: "Массив весов пуст",
                        minValueLessThanAllowed:
                            "Минимальное значение %s меньше допустимого %s в диапазоне %s-%s",
                        maxValueMoreThanAllowed:
                            "Максимальное значение %s больше допустимого %s в диапазоне %s-%s",
                        minValueMoreThanMax:
                            "Некорректный диапазон: минимальное значение %s больше максимального %s",
                        rangeMissing: "Пропущены значения в диапазоне %s-%s",
                    },
                },
            },
        },
        checkLists: {
            title: "Анкеты тайного гостя",
            resultTitle: "Результат: %s",
            evaluationTitle: "Оценка: %s",
            checkList: "Заполнение анкеты",
            status: "Статус анкеты",
            noNewRecords: "Нет доступных анкет для заполнения",
            isChanged: "Ответ отредактирован проверяющим",
            editAnswer: "Изменить ответ тайного гостя",
            fields: {
                templateId: "Шаблон анкеты",
                createdDate: "Дата создания",
                evidenceCollectorName: "Тайный гость",
                inspector: "Проверяющий",
                evaluationDate: "Период оценки",
                evidenceCollectionDate: "Период заполнения",
                evaluationFinished: "Дата оценки",
                rate: "Рейтинг",
            },
            add: {
                title: "Назначение анкеты",
            },
            actions: {
                title: "Действия",
                showCheckList: "Заполнить анкету",
                remove: "Удалить анкету",
                add: "Назначить анкету",
                selectCollector: "Назначить тайного покупателя",
                startEvaluation: "Оценить",
                showResult: "Посмотреть",
                toTemplate: "Шаблоны анкет",
            },
            success: {
                assignment: "Назначено анкет: %s",
                remove: "Анкета %s удалена",
                assignUser: "Тайный гость назначен",
                resetUser: "Тайный гость сброшен",
                finishEvaluation: "Анкета проверена",
                updateAnswer: "Ответ отредактирован",
            },
            errors: {
                assignment: "Не удалось назначить анкету!",
                remove: "Не удалось удалить анкету!",
                assignUser: "Не удалось назначить тайного гостя!",
                finishEvaluation: "Не удалось сохранить результаты проверки!",
                updateAnswer: "Не удалось отредактировать ответ!",
            },
            userSelect: {
                title: "Назначить тайного гостя",
                select: "Назначить",
                evidenceCollector: "Тайный гость",
                reset: "Удалить тайного гостя",
                fields: {
                    imageId: "Фото",
                    fullName: "ФИО",
                    role: "Роль",
                    phone: "Телефон",
                },
            },
            steps: {
                comment: "Комментарий",
                answer: "Ваш ответ",
                answerImage: "Загрузите фото",
                tooltip: {
                    toPrev: "Назад",
                    toNext: "Далее",
                },
                actions: {
                    cancel: "Закрыть",
                    save: "Сохранить",
                },
                finish: {
                    success: "Чек-лист отправлен на проверку!",
                    noText: "Нет, пока рано",
                    okText: "Да, хочу",
                    text: "Вы действительно хотите отправить анкету на проверку?",
                },
                success: {
                    finish: "Вы закончили заполнение анкеты",
                    addAnswer: "Ответ добавлен",
                },
                errors: {
                    finish: "Не удалось закончить заполнение анкеты!",
                    addAnswer: "Не удалось добавить ответ!",
                },
            },
        },
    },
    siteBanner: {
        config: {
            title: "Настройка отображения баннеров",
            fields: {
                title: "Подсказка",
                type: "Тип отображения",
                link: "ссылка",
                siteUrl: "Где отображать",
                imageId: "Изображение",
                startDate: "Начало показа",
                endDate: "Окончание показа",
                roles: "Кому показывать",
                rolesHelperText: "Если пусто - то всем",
            },
            alert: {
                normal: "Стандарт",
                success: "Успех",
                warning: "Внимание",
                error: "Ошибка",
                info: "Информация",
            },
            allDate: "Всегда",
            startDate: "С",
            endDate: "По",
        },
    },
    statistics: {
        ratingSuffix: "-ая",
        cntSuffix: "шт.",
        moneySuffix: "р.",
        tradePoint: {
            title: "Статистика по кофейне",
            dateRange: "Период",
            prevValue: "Предыдущее значение: %s",
            planValue: "Ожидаемое значение: %s",
            details: {
                title: "Детальная аналитика",
                titleDetails: "%s за %s",
                titleGroupedDetails: "%s за период с %s по %s",
                gratitudeIndex: "Благодарности",
                complaintsIndex: "Жалобы",
                text: "Тут уже более подробная информация",
                statisticType: "Тип статистики",
                hours: "Время",
                days: "День месяца",
                months: "Месяц",
                extraData: {
                    title: "Тип",
                    complaint: "Обращение",
                    orderFeedback: "Отзыв о заказе",
                },
            },
            chart: {
                defaultTitle: "Статистика",
                noData: "Нет данных",
                millionSuffix: "М",
                thousandSuffix: "К",
            },
            errors: {
                loadData: "Не удалось получить статистику по кофейне!",
                noRecords: "Нет данных по кофейне",
                invalidType: "Статистика не найдена",
            },
            order: {
                title: "Сортировка",
                alphaAsc: "От А до Я",
                alphaDesc: "От Я до А",
                rateAsc: "От лучших к худшим",
                rateDesc: "От худших к лучшим",
                dateAsc: "От старых к новым",
                dateDesc: "От новых к старым",
            },
            filter: {
                title: "Фильтры",
                periodType: "Выберите период",
                periodTypeCustom: "Выберите период",
                selectDate: "Выберите дату",
                compareType: "Выберите сравнение",
                otherTradePoint: "Кофейня для сравнения",
                otherDatePeriod: "Период для сравнения",
            },
        },
    },
    surveys: {
        list: {
            title: "Мои чек-листы",
            status: "Статус",
            statusActive: "Активен",
            user: "Исполнитель",
            noRecordsText: "Чек-листы не найдены",
            alternateUsers: "Назначить заместителя",
            adminAlternateUsers: "Список заместителей",
            startDate: "Можно заполнить %s",
            endDate: "Закончится %s",
            endedDate: "Время для заполнения окончено",
            updatedDate: "Заполнен %s",
            edit: "Заполнить",
            fields: {
                title: "Название",
                status: "Статус",
                tradePoint: "Кофейня",
                date: "Период для заполнения",
                startText: "Информация",
            },
            success: {
                addUser: "Исполнитель назначен",
                removeUser: "Исполнитель удален",
            },
            errors: {
                timePeriod:
                    "Чек-лист не может быть заполнен. Доступное для заполнения время с %s до %s. Проводите проверку вовремя",
                startDiff: 'К заполнению чек-листа "%s" можно приступить %s !',
                statusFailed: 'Вы не успели заполнить чек-лист "%s" вовремя!',
                otherUser: "Чек-лист уже заполняет сотрудник %s!",
                addUser: "Не удалось назначить исполнителя!",
            },
        },
        survey: {
            title: "Заполнение чек-листа",
            complete: "Завершить",
            step: {
                text: "Ваш ответ",
                description: "Комментарий",
                descriptionPlaceholder: "Здесь можно указать дополнительную информацию",
                next: "Далее",
                prev: "Назад",
                end: "Закончить",
                image: "Добавить фото",
                samplePhoto: "Пример фото",
                video: "Добавить видео",
                sampleVideo: "Пример видео",
            },
            answers: {
                title: "Название",
                value: "Ответ",
                description: "Комментарий",
                questionDescription: "Описание",
                status: "Статус",
                date: "Период заполнения",
                updatedDate: "Заполнен",
            },
            errors: {
                loadData: "Не удалось получить чек-лист!",
                statusFailed: 'Данный чек-лист имеет статус "Провален"',
                endMySmartAgent: "Не удалось завершить Чек-лист!",
            },
        },
        userEdit: {
            title: "Назначить исполнителя",
            okText: "Назначить",
            onReset: "Удалить исполнителя",
            user: "Исполнитель",
        },
        templates: {
            title: "Шаблоны чек-листов",
            toAssign: "Назначить чек-листы",
            edit: {
                title: "Редактировать чек-лист",
                addTitle: "Создать чек-лист",
                hoursUntilFailsValidate: "Укажите число больше 0",
                main: "Основное",
                fields: {
                    title: "Название",
                    startDate: "Дата начала",
                    startTime: "Время начала",
                    hoursUntilFails: "Время на заполнение (в часах)",
                    userRoleId: "Роль",
                    tradePointIds: "Кофейни",
                    offenceItemIds: "Нарушения",
                    withOffences: "С нарушениями",
                    rRule: "Повторять",
                    isSmartAgent: "Виртуальный помощник",
                    minutesUntilFails: "Время на заполнение (в минутах)",
                },
                success: {
                    add: 'Чек лист "%s" создан',
                    edit: 'Чек лист "%s" изменен',
                    templateQuestionAdd: 'Вопрос "%s" добавлен',
                    templateQuestionEdit: 'Вопрос "%s" изменен',
                    templateQuestionRemove: "Вопрос удален",
                },
                errors: {
                    save: "Не удалось отредактировать чек-лист!",
                    loadData: "Не удалось получить чек-лист!",
                    templateQuestionSave: "Не удалось отредактировать вопрос чек-листа!",
                    templateQuestionRemove: "Не удалось удалить вопрос чек-листа!",
                },
                questions: {
                    title: "Вопросы",
                    addTitle: "Новый вопрос",
                    answers: "Варианты ответов",
                    answersCount: "%s Вариантов ответов",
                    fields: {
                        title: "Название",
                        description: "Описание",
                        type: "Тип вопроса",
                        samplePhoto: "Пример фото",
                        sampleVideo: "Пример видео",
                    },
                    confirmDelete: {
                        title: "Удалить вопрос",
                        text: 'Вы уверены, что хотите удалить вопрос "%s"?',
                        okText: "Да, удалить",
                    },
                    errors: {
                        answers: "Укажите варианты ответов",
                        templateQuestionsReordering: "Не удалось изменить порядок вопросов!",
                    },
                },
            },
            fields: {
                title: "Название",
                startDate: "Начало",
                rRule: "Период",
            },
            confirmDelete: {
                title: "Удалить шаблон",
                text: 'Вы уверены, что хотите удалить шаблон "%s"?',
                okText: "Да, удалить",
            },
            success: {
                remove: 'Шаблон "%s" удален',
                toAssign0: "Нет неназначенных чек-листов",
                toAssign: "Назначено: %p#checkList#",
            },
            errors: {
                loadData: "Не удалось получить список шаблонов!",
                remove: "Не удалось удалить шаблон!",
                toAssign: "Не удалось назначить чек-листы",
            },
        },
        result: {
            title: "Результаты заполнения",
            details: "Информация о заполнении",
            noRecordsText: "Нет данных",
            fields: {
                title: "Название",
                status: "Статус",
                date: "Период для заполнения",
                startDate: "С",
                endDate: "По",
                user: "Исполнитель",
                tradePoint: "Кофейня",
                roles: "Ответственные",
            },
            deleteConfirm: {
                title: "Удалить чек-листы",
                text: "Вы уверены, что хотите удалить %p#checkList#?",
                okText: "Да, удалить",
            },
            success: {
                removeUserAssignments: "Назначенные чек-листы удалены",
            },
            errors: {
                loadData: "Не удалось загрузить чек-лист!",
                deleteSelected: "Укажите чек-листы для удаления",
                removeUserAssignments: "Не удалось удалить назначенные чек-листы!",
            },
        },
        alternateUsers: {
            title: "Заместители",
            editTitle: "Заместитель",
            addTitle: "Назначить заместителя",
            startDate: "C %s",
            endDate: "По %s",
            list: {
                title: "Список замещений",
                addTitle: "Назначить заместителя",
                editTitle: "Заместитель",
                startDate: "C %s",
                endDate: "По %s",
                fields: {
                    user: "Пользователь",
                    alternateUser: "Заместитель",
                    surveyUid: "Чек-лист",
                    description: "Комментарий",
                    date: "Период",
                    startDate: "Дата начала",
                    endDate: "Дата окончания",
                },
                success: {
                    removeAlternateUser: "Заместитель удален",
                },
                errors: {
                    loadData: "Не удалось получить список заместителей!",
                    getTemplateList: "Не удалось получить список чек-листов!",
                    removeAlternateUser: "Не удалось удалить заместителя!",
                },
            },

            fields: {
                surveyUid: "Чек-лист",
                date: "Период",
                alternateUser: "Заместитель",
                startDate: "Дата начала",
                endDate: "Дата окончания",
                description: "Комментарий",
            },
            success: {
                removeAlternateUser: "Заместитель удален",
            },
            errors: {
                isYou: "Нельзя указывать себя в качестве заместителя",
                removeAlternateUser: "Не удалось удалить заместителя!",
                getTemplateList: "Не удалось получить список шаблонов!",
            },
        },
    },
    sw: {
        title: "Настройки offline",
        actions: {
            clearCache: "Обновить все",
        },
        permission: {
            denied: "Доступ запрещен",
            granted: "Доступ разрешен",
        },
    },
    tags: {
        title: "Редактор тегов",
        noRecords: "Нет тегов",
        fields: {
            tagsContext: "Тип",
            category: "Категория",
            points: "%p#scores#",
        },
        errors: {
            load: "Не удалось получить список тегов",
            removeTag: "Не удалось удалить тег",
            editTag: "Не удалось отредактировать тег",
            addTag: "Не удалось добавить тег",
        },
        success: {
            removeTag: 'Тег "%s" удален',
            editTag: "Тег изменен",
        },
        remove: {
            title: "Удалить тэг",
            text: 'Вы уверены, что хотите удалить тег "%s"?',
            okText: "Да, удалить",
        },
        edit: {
            title: "Редактировать тэг",
            addTitle: "Добавить тэг",
            fields: {
                tag: "Тэг",
                category: "Категория",
                points: "Баллы",
            },
        },
    },
    telegram: {
        title: "Телеграм",
        registered: {
            start: "Перейдите в ",
            bot: "Телеграм бота ",
            end: 'и напишите "Привет" ',
        },
        notRegistered: {
            start: "Вы еще не представлены нашему ",
            bot: "Телеграм боту ",
            end: 'перейдите в него, напишите "Привет" и следуйте инструкциям',
        },
        checker: {
            title: "Проверка данных",
            errors: {
                notRegister:
                    "Вам не удалось представиться системе. Вернитесь назад и попробуйте представиться еще раз!",
                search: "Не найдены необходимые параметры. Попробуйте еще раз",
            },
            success: {
                registration: "Telegram успешно подключен к вашей Учетной записи",
            },
        },
    },
    test: {
        yourVersion: "Ваша версия портала",
        login: "Войти",
    },
    thirdParty: {
        reports: {
            config: {
                title: "Настройка отчетов",
                titleParams: "Настройка параметров отчетов",
                fields: {
                    reportGuid: "guid",
                    reportName: "Наименование отчета ",
                    reportFolder: "Наименование раздела",
                    reportUrl: "Ссылка",
                    reportType: "Тип отчета",
                    paramName: "Название",
                    thirdPartyReport: "Отчет",
                    showCategory: "Отображать в",
                    isShowTradePointFilter: "Выводить фильтр по кофейням",
                    refreshInterval: "Обновлять раз в секунд",
                    refreshIntervalHelperText:
                        "0 - не обновлять. Введите число секунд, через которое отчет будет обновляться. Работает только для типа отчета MetabaseDashboard",
                    startHour: "Время начала",
                    endHour: "Время окончания",
                    percentForBonus: "Процент от выручки для премии",
                    needTime: "Целевое время (мин)",
                },
            },
            metabase: {
                title: "Отчеты по скорости сервиса",
                report: "Отчет",
            },
        },
    },

    tradePointDashboard: {
        title: "Работа кофейни",
        messagesTitle: "Важные сообщения",
        warningTitle: "Истечет в течение 30 минут",
        alarmTitle: "Просроченные продукты",
        noneWarningMessage: "Нет продуктов, срок годности которых скоро истечет",
        noneAlarmMessage: "Нет просроченных продуктов",
        goTo: "Перейти",
    },
    tradePoints: {
        list: {
            addTitle: "Добавление новой кофейни",
            showTitle: "Кофейня",
            title: "Список кофеен",
            main: "Основное",
            loading: "Идет обновление данных. Подождите...",
            showSwitcher: "Вкл/Выкл кофейню",
            onlyActive: "Только активные (30 дней)",
            mobileApp: {
                title: "Мобильное приложение",
                main: {
                    title: "Основное",
                    isDeleted: "Удалена",
                    isNotDeleted: "Активна",
                    fields: {
                        id: "ID",
                        isDeleted: "Статус",
                        dates: "Дата (создание, изменение)",
                        deliveryRestaurantName: "deliveryRestaurantName",
                        region: "Регион",
                        organizationId: "organizationId",
                        name: "Название",
                        address: "Адрес",
                        phone: "Телефон",
                        tag: "tag",
                        ip: "ip",
                        isOn: "isOn",
                        isAvailable: "isAvailable",
                        type: "Тип",
                        restaurantGroupId: "restaurantGroupId",
                        emailForOrder: "emailForOrder",
                        workTime: "workTime",
                        iDUWorkTime: "iDUWorkTime",
                        coordinates: "Координаты",
                        paymentTypes: "Типы оплаты",
                        features: "features",
                    },
                },
                cameras: {
                    title: "Камеры",
                    noRecords: "Нет данных",
                },
                closeReasons: {
                    title: "История выключений",
                    noRecords: "Нет данных",
                    fields: {
                        updatedAt: "Дата",
                        reasonTitle: "Название",
                        reason: "Причина",
                        from: "С",
                        to: "По",
                    },
                },
                legalEntity: {
                    title: "Юр. лицо/ИП",
                    noRecords: "Нет данных",
                    addModal: "Добавить Юр. лицо/ИП",
                    legalEntityName: "Название Юр. лицо/ИП",
                    merchant: "Оплата",
                    merchantName: "Тип оплаты",
                    merchantUserName: "Оплата, пользователь",
                    merchantPassword: "Оплата, пароль",
                    addPaymentTypeMPAY: 'Добавить тип оплаты "Онлайн"',
                    success: {
                        addLegalEntity:
                            "Юр. лицо добавлено! Убедитесь, что в ЛК мерчанта на портале поставщика услуг экваринга появилась соответствующая запись.",
                    },
                    errors: {
                        getLegalEntity: "Не удалось получить информацию о юр. лице!",
                        addLegalEntity: "Не удалось создать новое юр. лицо!",
                        merchant: "Не найдена информация об оплате",
                    },
                },
                merchant: {
                    name: "Тип оплаты",
                    userName: "Пользователь",
                    password: "Пароль",
                    errors: {
                        updateMerchant: "Не удалось изменить настройки оплаты!",
                    },
                    success: {
                        updateMerchant: "Настройки оплаты изменены",
                    },
                },
                errors: {
                    getTradePointPayments: "Не удалось получить информацию об оплате кофейни",
                },
            },
            mobileAppDb: {
                title: "Мобильное приложение База",
                main: {
                    title: "Основное",
                    workTime: "Время работы",
                    coordinates: "Координаты",
                    iArrived: "Я подъехал",
                    isOn: "Включено",
                    isAvailable: "Доступно",
                    pointSpeed: "Скорость",
                    maximumMinute: "Время скорости",
                    lateBonus: "Бонусы за невыполнение",
                    openTimeFrom: "Время начала",
                    openTimeTo: "Время окончания",
                    deliveryRestaurantName: "deliveryRestaurantName",
                    address: "Адрес",
                },
                speed: {
                    title: "Скорость и я подъехал",
                },
                legalEntity: {
                    title: "Юр. лицо/ИП",
                    name: "Название",
                    paymentSystem: "Тип оплаты",
                    payselectionMerchant: "Данные для оплаты",
                    addTitle: "Добавить юр. лицо",
                },
                payselectionMerchant: {
                    name: "Имя сайта",
                    siteId: "ID сайта",
                    publicKey: "Публичный ключ",
                    secretKey: "Секретный ключ",
                    confirmDelete: 'Вы уверены, что хотите удалить данные для оплаты "%s"?',
                },
                iikoEndPoint: {
                    title: "Настройки подключения",
                    organizationId: "Iiko Transport OrganizationId",
                    terminalGroupId: " Iiko Transport TerminalGroupId",
                    externalMenuId: " External Menu Id",
                },
                cameras: {
                    title: "Камеры",
                    addTitle: "Новая камера",
                    editTitle: "Редактировать камеру",
                    bar: "Бар",
                    kitchen: "Кухня",
                    streamUrl: "Ссылка на видео",
                    isAvailable: "Активна",
                    isNotAvailable: "Не активна",
                    order: "Порядок вывода",
                },
                pointFeatures: {
                    title: "Фичи",
                    add: {
                        title: "Добавить фичу",
                        pointFeature: "Фича",
                    },
                },
                success: {
                    onMainChange: "Данные изменены",
                },
                errors: {
                    noIikoId:
                        'У кофейни не указан "iiko Delivery Terminal Id" во вкладке настройки',
                    getPoint: "Не найдена информация о кофейне",
                    onMainChange: "Не удалось изменить данные!",
                },
            },
            settings: {
                title: "Настройки",
                fields: {
                    isSpeed: "Скорость",
                    bonusCalculationPercent: "Процент от выручки для премии",
                    speedTimeMetric: "Целевое время (сек)",
                    speedStartHour: "Время начала",
                    speedEndHour: "Время окончания",
                    showInQCCheckList: "Выводить в чек-листах ОУК",
                    sdServiceType: "Тип обслуживания",
                    sdDescription: "Заметки",
                    isWorkManagerPayrollsEnabled: 'Включить систему "Зарплатная ведомость"',
                },
                groups: {
                    speed: "Настройки Скорости",
                    show: "Настройки чек-листов ОУК",
                    sd: "Настройки Service Desk",
                    other: "Другие настройки",
                },
                success: {
                    save: "Данные изменены",
                },
                errors: {
                    save: "Не удалось сохранить изменения!",
                },
            },
            iiko: {
                title: "Параметры IIKO",
                paramsTitle: "Настройки IIKO",
                statusTitle: "Связи в БД IIKO и статус РМС",
                fields: {
                    iikoId: "iiko Delivery Terminal Id",
                    iikoRestorauntGroupId: "iiko Restaurant Group Id",
                    iikoConceptionId: "iiko Conception Id",
                },
                statusFields: {
                    pointOfSaleTitle: "Точка продаж (IIKO)",
                    iikoConceptionId: "iiko Conception Id (PointOfSale Id)",
                    pointOfSaleDeliveryTerminalId: "ID терминала доставки (IIKO)",
                    pointOfSaleRestorauntGroupId: "Группа ресторана (IIKO)",
                    rmsName: "RMS",
                    rmsVersion: "Версия RMS",
                    rmsUrl: "URL RMS",
                    rmsDepartmentName: "Подразделение RMS",
                    replicationStatus: "Статус репликации",
                    replicationLastSuccessAt: "Последняя успешная репликация",
                    replicationLastAttemptAt: "Последняя попытка",
                    replicationLastError: "Ошибка репликации",
                    rmsLastSyncError: "Ошибка синхронизации",
                    rmsIsActive: "Активна",
                },
                buttons: {
                    fillFromStatus: "Заполнить из статуса",
                },
                success: {
                    save: "Параметры IIKO сохранены",
                    fillFromStatus: "Поля заполнены из статуса",
                },
                errors: {
                    save: "Не удалось сохранить параметры IIKO",
                    load: "Не удалось получить параметры IIKO",
                },
            },
            legalPerson: {
                title: "Юр. данные",
                noDepartment: "Для кофейни не указано структурное подразделение!",
                toDepartment: "Указать",
                editDepartment: "Редактировать структурное подразделение",
                scheduleEdit: "Отложенное изменение Юр. лица",
                fields: {
                    title: "Подразделение",
                    legalPersonName: "Юр. лицо/ИП",
                    inn: "ИНН",
                    kpp: "КПП",
                    address: "Фактический адрес осуществления деятельности",
                    contacts: "Официальные контакты",
                },
                history: {
                    title: "История изменений",
                },
            },
            employees: {
                title: "Сотрудники",
                noRecords: "Пока нет",
                fields: {
                    fullName: "ФИО",
                    phone: "Номер телефона",
                    role: "Роль",
                    messengers: "Мессенджеры",
                },
            },
            fields: {
                name: "Название",
                isActive: "Активная",
                phone: "Номер телефона",
                fullName: "Наименование кофейни",
                city: "Город",
                address: "Адрес кофейни",
                firstOpenDate: "Дата открытия",
                ownerType: "Тип собственности",
                email: "Email",
                format: "Формат",
                brand: "Бренд",
                contacts: "Данные для рассылки",
                sdServiceType: "Тип обслуживания",
                legalPersonName: "Юр. лицо",
                legalPersonInn: "ИНН юр. лица",
                employeeType: "Тип кадрового учета",
            },
            errors: {
                download: "Ошибка при попытке скачать отчет!",
                add: "Ошибка при попытке добавить кофейню!",
                edit: "Ошибка при попытке отредактировать кофейню!",
                remove: "Ошибка при попытке удалить кофейню!",
                get: "Ошибка при попытке получить данные о кофейне!",
                all: "Ошибка при попытке получить список кофеен!",
            },
            success: {
                add: "Кофейня %s добавлена",
                edit: "Кофейня %s отредактирована",
                remove: "Кофейня удалена",
            },
            deleteConfirm: {
                title: "Удалить кофейню",
                text: 'Вы уверены что хотите удалить кофейню "%s"?',
                okText: "Да, удалить",
            },
            fiscal: {
                title: "ФН и ОФД",
                type: "Тип",
                endDate: "Дата окончания",
                serialNumber: "Заводской номер",
                isSupported: "Поддерживаемая",
            },
        },
        switcher: {
            reasons: {
                reason1: {
                    type: "Санитарная ночь",
                    title: "Наводим чистоту и красоту",
                    description: "Наступила санитарная ночь, увидимся утром!",
                },
                reason2: {
                    type: "Ревизия",
                    title: "Сейчас кофейня не работает",
                    description:
                        "Проверяем запасы зерен для кофе и тортильи для завертонов. Скоро вернемся!",
                },

                reason3: {
                    type: "Пропал интернет",
                    title: "У нас пропал интернет",
                    description:
                        "Сейчас приложение не может связаться с кофейней, но вы - можете. Делайте заказ по телефону или подъезжайте прямиком к окошку. Ждем вас!",
                },
                reason4: {
                    type: "Техническая проблема",
                    title: "Сейчас кофейня не работает",
                    description:
                        "У нас проблема – без техника не разберешься! Стараемся решить ее побыстрее",
                },
                reason5: {
                    type: "Нет сотрудника",
                    title: "Сейчас кофейня не работает",
                    description: "У нас проблема. Стараемся решить ее побыстрее. Увидимся позже!",
                },
                reason6: {
                    type: "Кофе в стопе",
                    title: "Бар немного неисправен",
                    description:
                        "Сейчас не все напитки из меню мы можем приготовить. Но перекус для вас точно найдется. О доступных напитках узнавайте по телефону или на окошке. Ждем вас!",
                },
                reason7: {
                    type: "Не работает печь",
                    title: "Печь решила отдохнуть",
                    description:
                        "Основное меню пока не готовим, но наверняка найдем для вас перекус. Узнавайте о доступных блюдах по телефону или на окошке. Ждем вас!",
                },
                reason8: {
                    type: "Работает мастер",
                    title: "Сейчас кофейня не работает",
                    description:
                        "Проверяем наше оборудование, чтобы работало исправно. Вернемся сразу после завершения работ.",
                },
                reason9: {
                    type: "Кофейня не справляется",
                    title: "Заказы принимаем у окошка",
                    description:
                        "Как много желающих выпить кофе, не успеваем варить! Подъезжайте к окошку, приготовим ваш заказ в порядке очереди.",
                },
                reasonIsland1: {
                    type: "Технический перерыв",
                    title: "Сотрудник вернется через 15 минут",
                    description:
                        "Наш сотрудник временно отсутствует на рабочем месте. Пожалуйста, подождите немного, и он скоро вернется, чтобы продолжить вам помогать.",
                },
            },
            reasonViewer: "Отображение в мобильном приложении",
            history: {
                title: "История отключения кофейни",
                comment: "Комментарий",
                status: "Статус",
                reason: "Причина",
                date: "Дата",
                turnedOn: "Включили",
                turnedOff: "Выключили",
                loading: "Идет получение информации о статусе кофейни. Подождите...",
                deleteOutage: "Удалили запланированное отключение",
                turningTimeOff: "%s Время отключения: c %s по %s",
                outages: "Запланированные отключения",
                errors: {
                    switchHistory: "Не удалось получить историю кофейни",
                    getPlannedOutages: "Не удалось получить запланированные отключения",
                    deleteOutage: "Не удалось удалить запланированное отключение",
                },
            },
            title: "Работа мобильного приложения",
            isOn: "Включен",
            isOff: "Выключен",
            isUnknown: "Нет данных",
            turnOn: {
                action: "Включить",
                confirm: 'Вы уверены, что хотите включить кофейню "%s"?',
            },
            turnOff: {
                action: "Выключить",
                confirm: 'Вы уверены, что хотите выключить кофейню "%s"?',
                comment: "Комментарий",
                reason: "Причина",
                isScheduled: "Отложенное отключение",
                startDate: "Время выключения",
                endDate: "Время включения",
            },
            errors: {
                isOpened: "Не удалось включить кофейню %s!",
                isClosed: "Не удалось выключить кофейню %s!",
                loadData: "Не удалось получить данные!",
            },
            success: {
                isOpened: "Кофейня %s включена",
                isClosed: "Кофейня %s выключена",
            },
        },
    },
    workManager: {
        salary: {
            title: "Зарплатная ведомость",
            dateRange: "Период",
            totalAmount: "Итого",
            details: {
                title: "Детали смены",
            },
        },
        rules: {
            id: "Правило",
            exchange: "Биржа смен",
            title: "Настройки правил выплат",
            editTitle: "Редактирование правила выплат",
            department: "Подразделение",
            value: "Цена за час дневной смены",
            nightValue: "Цена за час ночной смены",
            allValue: "Цена за час",
            base: "Общее правило",
            availableRules: "Правила выплат",
            bonuses: {
                title: "Бонусы за выполнение плана продаж",
                titleDescription: "Только для дневной смены",
                noBonusesText: "Нет бонусов",
                editTitle: "Редактирование бонуса",
                startPercent: "Мин. %",
                endPercent: "Макс. %",
                percent: "% Бонуса",
                value: "Цена за час",
                validationErrors: {
                    invalidRange: "Максимальное значение не может быть меньше минимального",
                    overlap: "Диапазоны процентов не должны пересекаться",
                    gap: "Диапазоны процентов должны идти без пропусков",
                },
            },
            delete: {
                title: "Удалить правило",
                text: "Вы уверены, что хотите удалить правило %s?",
                okText: "Да, удалить",
            },
            errors: {
                tradePointRequired: "Укажите кофейню",
                delete: "Не удалось удалить правило!",
                save: "Не удалось сохранить правило!",
                availableRules: "Не удалось получить список правил!",
            },
            success: {
                delete: "Правило удалено",
                save: "Правило сохранено",
            },
            calculator: {
                title: "Калькулятор правил выплат",
                groups: {
                    rule: "Правило выплат",
                    calculator: "Настройки калькулятора",
                },
                bonusSum: "План по выручке",
                copied: "Правило скопировано. Теперь его можно вставить в настройках выплат",
                copy: "Скопировать правило",
                paste: "Вставить правило",
            },
        },
        payroll: {
            title: "Управление ведомостями",
            confirmAll: "Подтвердить все смены сотрудника",
            confirmAllText:
                'У сотрудника "%s" есть %p#workManagerEvents#  на поверке. Вы уверены, что хотите утвердить все смены?',
            confirmAllOkText: "Да, утвердить",
            details: {
                title: "Детали смены",
                showRule: "Показать правило для расчета",
                reCalculate: "Пересчитать",
                toBlock: "Утвердить",
                toUnblock: 'Вернуть в статус "На проверке"',
                toCancel: "Удалить",
                payment: "Ставка в час",
                paymentDay: "Дневная ставка в час",
                paymentNight: "Ночная ставка в час",
                paymentBonus: " + Бонус за выполнение плана продаж",
                tooltips: {
                    toBlock: "Утвердить смену как выполненную. После этого ее нельзя редактировать",
                    toCancel: "Отметить смену как невыполненную",
                    toUnblock: 'Вернуть смену в статус "На проверке"',
                    reCalculate: "Пересчитать смену по актуальным на данный момент правилам выплат",
                    prepayment: "Из них выдано авансом: %s",
                },
                saleBonus: {
                    title: "Бонус за продажи",
                    totalSumTooltip: "Сумма продаж за смену",
                    ruleBonusTooltip: "Процент бонуса за продажи",
                    userPercentTooltip: "Кол-во часов, отработанных сотрудником",
                },
                bonuses: {
                    title: "Бонусы",
                    details: "Детали",
                    offences: "Удержания",
                    deleted: "Удалено",
                    value: "Сумма",
                    comment: "Причина",
                    periodDate: "Расчетный период",
                    deleteComment: "Причина удаления",
                    createdUser: "Добавил",
                    deletedUser: "Удалил",
                    addBonus: "Добавить бонус",
                    addOffence: "Добавить удержание",
                    edit: "Редактировать бонус",
                    delete: "Удалить бонус/удержание",
                    noRecords: "Нет записей",
                    bonusTooltip: "Бонус: %s",
                    offenceTooltip: "Удержание: %s",
                    bonusAndOffenceTooltip: "Бонус: %s, Удержание: %s. Итого: %s.",
                    prepayment: "Аванс",
                    prepaymentTooltip: "Аванс: %s",
                },
                period: "Смена",
                sum: "Кофекоины",
                formulaDescription: "Формула: ставка × Кол-во часов",
                formulaSaleBonusDescription:
                    "Формула: ставка × Кол-во часов + Бонус за выполнение плана продаж",
                rate: "Ставка",
                shiftHours: "Кол-во часов",
                dayShift: "дневная",
                nightShift: "ночная",
                notEqual: "Не совпадает с ",
                errors: {
                    addBonus: "Не удалось добавить бонус/удержание!",
                    deleteBonus: "Не удалось удалить бонус/удержание!",
                    reCalculate: "Не удалось пересчитать данные!",
                    reCalculateCnt: "Нет доступных смен для пересчета!",
                    block: "Не удалось зафиксировать смену!",
                    totalNotEqual: "Сумма не совпадает с рассчитанной!",
                    unblock: 'Не удалось вернуть смену в статус "На проверке"!',
                    addExtra: "Не удалось добавить бонус/удержание!",
                    deleteExtra: "Не удалось удалить бонус/удержание!",
                },
                success: {
                    addBonus: "Бонус/удержание на сумму %s добавлен",
                    deleteBonus: "Бонус/удержание на сумму %s удален",
                    reCalculate: "Данные пересчитаны",
                    reCalculates: "Смены пересчитаны: %s шт.",
                    block: "Смена зафиксирована",
                    blocks: "Смены зафиксированы",
                    unblock: 'Смена возвращена в статус "На проверке"',
                    addExtra: "Бонус/удержание на сумму %s добавлен",
                    deleteExtra: "Бонус/удержание на сумму %s удален",
                },
            },
        },
        payrollCreating: {
            title: "Создание зарплатных ведомостей",
            successCreate: "Ведомость создана",
            errorCreate: "Не удалось создать ведомость",
            toCreate: "Скачать ведомость",
        },
        list: {
            extra: "Выплаты/удержания",
            exchanges: "Откликов",
            events: "Смен",
            paymentDay: "Ставка",
            totalPrice: "Итого",
            paymentNight: "Ставка ночь",
            deleteExchangeEvent: "Удалить смену с биржи",
            plannedTitle: "Планирование смен",
            myPlannedTitle: "Мои будущие смены",
            myRevisionTitle: "Мои смены на проверке",
            myHistoryTitle: "Мои отработанные смены",
            historyTitle: "История смен",
            exchangesTitle: "Биржа смен",
            selectTradePoint: "Выберите кофейню",
            myTitle: "Мои смены",
            otherTradePoint: "Сотрудник c другой кофейни",
            showType: {
                title: "Тип отображения",
                list: "Список",
                calendar: "Календарь",
                table: "Таблица",
            },
            type: "Тип",
            user: "Работник",
            date: "Смена",
            status: "Статус",
            money: "Сумма",
            employeeName: "Должность",
            workHours: "ч.",
            afterEditTooltip: "Смена была отредактирована %s",
            delete: {
                title: "Удалить смены",
                text: "Вы уверены, что хотите удалить смену?",
                okText: "Да, удалить",
                success: "Смена удалена",
                error: "Не удалось удалить смену!",
            },
            shifts: {
                day: "дневная смена",
                night: "ночная смена",
            },
            tooltips: {
                fot: "ФОТ. Выручка: %s.  Расход: %s.",
                planPercent: "Дневная смена. Выручка: %s. План: %s. ",
                print: "Печатная форма",
                add: "Добавить смену",
                reCalculate: "Пересчитать данные по актуальным на данный момент правилам выплат",
                createPayroll: "Создать зарплатную ведомость",
            },
            errors: {
                loadData: "Не удалось получить данные!",
                invalidDate: "Не указана дата смены.",
                getUserList: "Не удалось получить список сотрудников кофейни!",
                add: "Не удалось добавить смену!",
                edit: "Не удалось отредактировать смену!",
                confirm: "Не удалось подтвердить смену!",
                saveOrdering: "Не удалось сохранить порядок сотрудников!",
                exchangeApprove: "Не удалось принять смену на бирже!",
                delete: "Не удалось удалить смену на бирже!",
            },
            success: {
                add: "Смена добавлена",
                edit: "Смена отредактирована",
                confirm: "Смена подтверждена",
                delete: "Смена удалена",
                exchangeApprove: "Смена на бирже принята",
            },
            reCalculateConfirm: {
                title: "Пересчет данных",
                text: 'Вы уверены, что хотите пересчитать смены в статусе "На проверке" по актуальным на данный момент правилам выплат? Не делайте этого, если не уверены!',
                okText: "Да, пересчитать",
            },
        },
        event: {
            addTitle: "Новая смена",
            addConfirmHistory: {
                title: "Добавления смены постфактум",
                text: "Вы уверены, что хотите добавить запись постфактум? Она будет помечена соответствующим образом!",
                okText: "Да, добавить",
            },
            anotherUser: "Сотрудник с другой кофейни",
            afterEditAction: "Изменить смену постфактум",
            afterEditTitle: "Редактировать смену постфактум!",
            editTitle: "Редактировать смену",
            historyTitle: "Детали смены",
            startDate: "Начало смены",
            endDate: "Окончание смены",
            employeeId: "Должность",
            userId: "Работник",
            status: "Статус",
            anotherUserId: "Работник с другой кофейни",
            comment: "Комментарий",
            confirm: "Я согласен",
            confirmTitle: "Подтверждение смены",
            dateSelector: {
                date: "Смена",
                allDay: "Весь день",
                startDate: "Дата",
                dayShift: "Дневная смена (8:00 - 20:00)",
                nightShift: "Ночная смена (20:00 - 08:00)",
                custom: "Другой период",
                shiftType: "Тип смены",
                startTime: "Время начала",
                endTime: "Время окончания",
                customRangeLabel: "Укажите диапазон",
                timeDifference: "Длительность: %s ч %s мин",
                tradePointLocalTime: "Время указано в часовом поясе кофейни",
                errors: {
                    invalidDate: "Невалидная или отсутствующая дата.",
                    dateInsert: "Укажите дату",
                    dateInPast: "Дата должна быть в будущем",
                    endDateBeforeStartDate: "Дата окончания не может быть раньше даты начала.",
                    invalidTimeDifference: "Не удалось вычислить разницу в датах.",
                    invalidShiftConfig: "Некорректная конфигурация смены.",
                },
            },
            exchange: {
                sumTooltip: "Ставка за час: %s",
                title: "Биржа смен",
                exchanges: "Отклики",
                add: "На биржу",
                approve: "Принять сотрудника на смену",
                user: "Биржа смен",
                workTime: "Смена",
                createdDate: "Дата отклика",
                sum: "Ставка за час",
                responses: "Откликов",
                notResponded: "Новая",
                responded: "Заявка подана",
                toRespond: "Откликнуться",
                delete: "Удалить отклик",
                viewProfile: "Просмотр профиля сотрудника",
                errors: {
                    add: "Не удалось добавить отклик!",
                    delete: "Не удалось удалить отклик!",
                    success: {
                        add: "Отклик добавлен",
                        delete: "Отклик удален",
                    },
                },
            },
            errors: {
                employeeId: "Укажите должность",
                exchangeStatus: 'Статус смены должен быть только "%s"!',
            },
        },
        print: {
            title: "Печатная форма",
            printTitle: "График смен на %s",
            statuses: "Статусы смен",
            load: "Поиск",
            toPrint: "Напечатать",
            downloadPng: "Скачать фото",
            downloadXlsx: "Скачать Excel",
            error: "Не удалось получить данные для печати!",
            employee: "Сотрудник",
            svgTitle: "График рабочего расписания SVG",
            isOfficial: "Оф.",
        },
        charts: {
            axisLabelEmployee: "Сотрудник",
            legendLabelDay: "12ч (дневная смена)",
            legendLabelNight: "12ч (ночная смена)",
            legendLabelPartial: "неполная смена",
            legendLabelOverlap: "пересечение",
            lineTitle: "Кол-во сотрудников",
            employee: "Должность",
            ganttTitle: "График смен",
            noRecords: "Нет данных выбранный за период",
        },
    },
    users: {
        deviceLimit: "Лимит устройств",
        title: "Пользователи",
        addTitle: "Добавление сотрудника",
        editTitle: "Просмотр сотрудника",
        edit: "Редактирование сотрудника",
        profile: "Профиль",
        documents: "Документы",
        employeeHistory: {
            title: "Кадровая информация",
            noRecords: "Нет данных",
            action: "Действие",
            employee: "ФИО",
            department: "Подразделение",
            reason: "Причина",
            isOfficial: "Официальный статус",
            rate: "Ставка",
        },
        status: {
            blackList: "Пользователь внесен в черный список",
            dismissed: {
                title: "Уволить сотрудника",
                text: "Вы уверены, что хотите уволить сотрудника?",
                okText: "Да, уверен",
            },
            working: {
                title: "Взять на работу сотрудника",
                text: "Вы уверены, что хотите взять на работу сотрудника?",
                okText: "Да, взять на работу",
            },
            error: "Ошибка при попытке смены статуса сотрудника!",
        },
        oauth: {
            title: "Авторизация",
            errors: {
                login: "Ошибка авторизации",
            },
        },
        ndaConfirm: {
            title: "Соглашение о неразглашении",
            subtitle: "%s",
            description1:
                "Для продолжения работы необходимо принять условия Соглашения о неразглашении. Вы можете ознакомиться с полной версией документа по ссылке ниже.",
            checkbox: "Я принимаю условия Соглашения о неразглашении (версия %s).",
            more: "Подробнее",
            accept: "Принять и продолжить",
        },
        filter: {
            onlyWorking: "Только активные",
        },
        employee: "Работник кофейни",
        employeeActions: {
            isOfficial: "Смена статуса на официальный ",
            isNotOfficial: "Смена статуса на не официальный",
            title: "Кадровые движения",
            dismiss:
                "Новая роль пользователя больше не является учитываемой для Отдела кадров. Внести запись об его увольнении?",
            work: "Новая Роль пользователя является учитываемой для Отдела кадров. Внести запись об его приеме на работу?",
            changeEmployee: "У пользователя изменилась должность",
            changeEmploymentRate: "У пользователя изменилась ставка",
            changeDepartment: "У пользователя изменилось подразделение",
            changeDepartmentWithOutTradePoint:
                "У пользователя изменилось подразделение, но не изменилась кофейня. Вы уверены, что так и надо?",
            changeTradePointWithOutDepartment:
                "У пользователя изменилась кофейня, но не изменилось  подразделение. Вы уверены, что так и надо?",
            textAfter: "Внести запись об этом?",
            notConfirm: "Сохранить без кадрового учета",
        },
        admin: "Работник офиса",
        adminPhoneConfirm: {
            title: "Подтверждение номера телефона",
            text: "Вы уверены, что хотите подтвердить номер телефона %s для пользователя %s?",
            okText: "Да, подтвердить",
            success: "Номер подтвержден",
            error: "Не удалось подтвердить номер телефона",
        },
        checker: {
            title: "Введите основную информацию о пользователе",
            status: {
                tablet: "Данный номер закреплен за планшетом кофейни.",
                tabletNotAdmin:
                    "Если вы хотите получить к нему доступ, обратитесь в службу поддержки.",
                exist: "Данный пользователь уже есть в базе.",
                blocked:
                    "Данный пользователь уже есть в базе, но заблокирован. Для разблокировки введите новый пароль.",
                otherName: "Данный номер закреплен за пользователем %s.",
                otherNameBlocked: "Данный номер закреплен за заблокированным пользователем %s.",
                adminExist: "Данный номер закреплен за работником офиса.",
                adminExistHuntflow:
                    "Номер уже используется (работник офиса). Укажите должность и новый пароль для приёма на работу в кофейню.",
                blackList: "Данный пользователь внесен в черный список",
            },
            actions: {
                goTo: "Перейти к записи",
                recovery: "Восстановить",
                confirm: "Да это он",
                continue: "Продолжить",
            },
            recovery: {
                error: "При попытке восстановления записи произошла ошибка",
                success: "Пользователь активирован",
            },
            submitBtnText: "Проверить",
            loaderText: "Идет проверка. Подождите...",
        },
        blackList: {
            title: "Черный список сотрудников",
            addTitle: "Новый пользователь в черный список",
            comment: "Комментарий",
            reasonType: "Причина внесения в черный список",
            updatedUser: "Внес изменения",
            confirmDelete: {
                title: "Удаление пользователя из черного списка",
                text: 'Вы уверены, что хотите удалить пользователя "%s" из черного списка?',
                okText: "Да, удалить",
            },
            success: {
                add: "Пользователь добавлен в черный список",
                remove: "Пользователь удален из черного списка",
                update: "Причина обновлена в черном списке",
            },
            errors: {
                add: "Не удалось добавить пользователя в черный список!",
                remove: "Не удалось удалить пользователя из черного списка!",
                update: "Не удалось обновить пользователя в черном списке!",
            },
        },
        bonuses: {
            title: "Бонусные баллы для сотрудников",
            addTitle: "Добавление пользователя",
            bonuses: "Кол-во баллов в месяц",
            maxBonuses: "Макс. кол-во баллов",
            confirmDelete: {
                title: "Удаление бонусных баллов для пользователя",
                text: "Вы уверены, что хотите удалить у данного пользователя бонусные баллы?",
                okText: "Да, удалить",
            },
            errors: {
                remove: "Не удалось удалить бонусные баллы для пользователя!",
                save: "Не удалось сохранить бонусные баллы для пользователя!",
            },
            success: {
                remove: "Бонусные баллы для пользователя %s удалены",
                save: "Данные сохранены",
            },
            problems: {
                title: "Поиск несоответствий в записях",
                description:
                    "Бонусы начисляются сотрудникам УК + менеджерам и тер. дирам кофеен под управлением и под полным управлением",
                delete: {
                    title: "Удаление Бонусы для пользователя",
                    text: "Вы уверены, что хотите удалить бонусы для пользователя %s?",
                    okText: "Да, удалить",
                },
            },
        },
        fields: {
            messengers: "Мессенджеры",
            birthDate: "Дата рождения",
            departmentId: "Подразделение",
            gradeTrees: "Деревья грейдов",
            employeeIsOfficial: "Официальный работник",
            employmentRate: "Ставка ШЕ",
            employmentOfficialRate: "Ставка",
            imageId: "Фото",
            name: "ФИО",
            phone: "Номер телефона",
            oldUserId: "GUID",
            tradePoint: "Кофейня",
            role: "Роль",
            userSex: "Пол",
            lastName: "Фамилия",
            firstName: "Имя",
            middleName: "Отчество",
            status: "Статус пользователя",
            email: "E-mail",
            image: "Фото",
            password: "Пароль",
            accessFeatures: "Доступы",
            blackList: "Пользователь внесен в черный список",
        },
        forGroups: {
            main: "Основная информация",
            additional: "Дополнительная информация",
            learning: "Обучение",
            employee: "Кадровый учет",
            password: "Данные авторизации",
        },
        errors: {
            saveDeviceLimit: "Ошибка сохранения лимита устройств",
            userName: "Данный номер телефона уже есть в базе",
            edit: "Ошибка при попытке отредактировать пользователя!",
            add: "Ошибка при попытке создать пользователя!",
            checkUserExist: "Не удалось проверить пользователя!",
            getUserData: "Не удалось найти информацию о пользователе!",
            insertTradePoint: "Укажите кофейню",
            insertTradePoints: "Укажите кофейни",
            insertGradeTrees: "Укажите дерево грейдов",
            insertEmployee: "Укажите должность",
            insertDepartment: "Укажите подразделение",
        },
        save: {
            edit: "Данные пользователя успешно изменены",
            add: "Пользователь  успешно создан",
        },
        extra: {
            title: "Дополнительно",
            user: {
                title: "Пользователь",

                adminLogin: "Зайти под пользователем",
            },
            learning: {
                title: "Обучение",
                updateUserGrades: "Пересчитать грейды",
                lastGradeCalculationsDate: "Дата последнего пересчета: %s",
            },
            additional: {
                title: "Дополнительные параметры",
                fields: {
                    iikoUserId: "ID пользователя в IIko",
                },
                success: {
                    updateUserAdditionalData: "Данные обновлены",
                },
                errors: {
                    updateUserAdditionalData: "Не удалось отредактировать пользователя!",
                },
            },
            accessFeatures: {
                title: "Уникальные доступы",
                errors: {
                    executeAsync: "Не удалось выполнить запрос!",
                    updateUsersFeatures: "Не удалось обновить доступы!",
                },
                success: {
                    updateUsersFeatures: "Доступы изменены",
                },
            },
            employee: {
                title: "Работник кофейни",
                lastVisitDate: "Последний вход",
                createdDate: "Создан",
            },
            success: {
                updateUserGrades: "Грейды пересчитаны",
                notUpdateUserGrades: "Грейды пересчитаны, ничего не изменилось",
            },
            errors: {
                updateUserGrades: "Ошибка при попытке пересчета грейдов!",
                getAdditionalData: "Не удалось получить данные о пользователе!",
                adminLogin: "Не удалось авторизоваться под пользователем!",
            },
        },
        login: {
            login: "Войти",
            password: "Пароль",
            title: "Войдите в ваш аккаунт",
            phone: "Телефон",
            removeDevice: {
                title: "Удаление устройства",
                text: "Вы уверены, что хотите удалить устройство?",
                cancel: "Отмена",
                remove: "Удалить и войти",
                lastActivity: "Последняя активность: %s",
                device: "Устройство",
            },
            ndaConfirm: {
                checkbox: "Я принимаю условия Соглашения о неразглашении (версия %s).",
                more: "Подробнее",
            },
            errors: {
                usernameOrPassword: "Неверный логин или пароль",
                blocked:
                    "Учётная запись заблокирована, обратитесь к своему менеджеру или в службу поддержки",
                default: "Что-то пошло не так. Обратитесь в службу поддержки",
                ndaNotAccepted: "Необходимо принять Соглашение о неразглашении для продолжения",
                deviceLimitReached: "Превышен лимит подключённых устройств. Обратитесь в ИТ-отдел.",
                removeDeviceError: "Не удалось удалить устройство. Попробуйте позже.",
            },
        },
        logout: {
            loaderText: "Идет выход из учетной записи. Подождите...",
        },
        webAuth: {
            errors: {
                notSupported: "Биометрическая аутентификация не поддерживается в вашем браузере",
                notFound:
                    "Биометрические данные не найдены. Пожалуйста, настройте биометрическую аутентификацию.",
                createCredentials: "Не удалось создать биометрические учетные данные",
                saveServer: "Не удалось сохранить биометрические данные на сервере",
                setup: "Ошибка настройки биометрической аутентификации",
                auth: "Ошибка биометрической аутентификации",
                canceled: "Аутентификация отменена или не удалась",
                failed: "Аутентификация не удалась",
            },
            success: {
                setup: "Биометрическая аутентификация успешно настроена!",
                auth: "Вход выполнен успешно!",
            },
            devices: {
                unknown: "Неизвестное устройство",
                iphone: "iPhone",
                ipad: "iPad",
                mac: "Mac",
                android: "Android",
                web: "Web",
            },
            biometryTypes: {
                touchId: "TouchID",
                faceId: "FaceID",
                faceIdTouchId: "FaceID/TouchID",
                fingerprint: "Отпечаток пальца",
                touchIdGeneric: "TouchID",
                biometry: "Биометрия",
                windowsHello: "Windows Hello",
            },
            login: {
                button: "Войти с {biometryType} 🔐",
                checking: "Проверка...",
            },
            setup: {
                title: "Быстрый вход с {biometryType}",
                description:
                    "Настройте вход с помощью {biometryType} для быстрого и безопасного доступа",
                deviceInfo: {
                    faceId: "📱 FaceID на iPhone/iPad",
                    touchId: "👆 TouchID на Mac",
                    fingerprint: "🔐 Отпечаток пальца на Android",
                    windowsHello: "💻 Windows Hello на ПК",
                },
                warning:
                    "⚡ После нажатия Настроить браузер покажет системный диалог для настройки биометрии",
                dontAskAgain: "Не показывать это предложение больше",
                buttons: {
                    notNow: "Не сейчас",
                    setup: "Настроить биометрию",
                    setting: "Настройка...",
                },
            },
            phonePrompt: "Введите номер телефона для входа с FaceID:",
            config: {
                title: "Настройки биометрии",
                quickLoginTitle: "Быстрый вход с {biometryType}",
                description:
                    "Используйте {biometryType} для быстрого и безопасного входа в систему",
                notAvailableWarning:
                    "Биометрическая аутентификация недоступна на этом устройстве. Убедитесь, что у вас настроена биометрия в системе.",
                notSupportedWarning:
                    "Биометрическая аутентификация не поддерживается в вашем браузере или устройстве",
                enabled: "Биометрия включена",
                disabled: "Биометрия отключена",
                activeDevices: "Активные устройства:",
                dontAskDisabledInfo: "Предложение настройки биометрии отключено",
                enableSuggestions: "Включить предложения",
                close: "Закрыть",
                errors: {
                    notAvailable: "Биометрическая аутентификация недоступна на этом устройстве",
                    setup: "Ошибка при настройке биометрической аутентификации",
                    disable: "Ошибка при отключении биометрической аутентификации",
                    loadStatus: "Ошибка при загрузке статуса биометрии:",
                },
                success: {
                    setup: "Биометрическая аутентификация успешно настроена!",
                    disabled: "Биометрическая аутентификация отключена",
                    suggestionsEnabled:
                        "Предложение биометрической настройки будет показано при следующем входе",
                },
            },
        },
    },
    suppliers: {
        title: "Поставщики",
        addTitle: "Новый поставщик",
        editTitle: "Редактировать поставщика",
        fields: {
            name: "Наименование",
            contactInfo: "Контактная информация",
            address: "Адрес",
            email: "Email",
            phone: "Телефон",
            taxpayerIdNumber: "ИНН",
        },
        errors: {
            getRecord: "Не удалось получить информацию о поставщике!",
            save: "Не удалось сохранить поставщика!",
            delete: "Не удалось удалить поставщика!",
        },
        success: {
            save: "Поставщик сохранен",
            delete: "Поставщик удален",
        },
        orders: {
            title: "Заказы поставщикам",
            editTitle: "Заказ поставщику %s",
            addTitle: "Новый заказ",
            details: {
                title: "Детали заказа",
                supplier: "Поставщик",
                deliveryDate: "Дата поставки",
            },
            fields: {
                orderNumber: "Номер заказа",
                supplier: "Поставщик",
                createDate: "Дата создания",
                orderDate: "Дата создания",
                deliveryDate: "Дата поставки",
                status: "Статус",
                items: "Позиции",
                totalAmount: "Общая сумма",
                deliveryAddress: "Адрес доставки",
                comment: "Комментарий",
                actions: "Действия",
                user: "Пользователь",
                product: "Продукт",
                container: "Контейнер",
                quantity: "Кол-во",
                measureUnit: "Ед. изм.",
                price: "Цена",
                totalPrice: "Сумма",
                unitPrice: "Цена за ед.",
            },
            errors: {
                load: "Не удалось загрузить заказы поставщикам",
                create: "Не удалось создать заказ поставщику",
                update: "Не удалось обновить заказ поставщику",
                delete: "Не удалось удалить заказ поставщику",
                orderNumber: "Номер заказа должен быть уникальным",
                noItems: "В заказе должна быть хотя бы одна позиция",
                invalidItems: "Некоторые позиции заказа содержат ошибки",
                getOrders: "Не удалось получить список заказов!",
            },
            success: {
                create: "Заказ поставщику успешно создан",
                update: "Заказ поставщику успешно обновлен",
                delete: "Заказ поставщику успешно удален",
                statusChange: "Статус заказа успешно изменен",
                deleteOrder: "Заказ удален",
            },
            actions: {
                create: "Создать заказ",
                edit: "Редактировать",
                delete: "Удалить",
                cancel: "Отменить",
                save: "Сохранить",
                changeStatus: "Изменить статус",
                addItem: "Добавить позицию",
                removeItem: "Удалить позицию",
                show: "Просмотр заказа",
            },
            status: {
                draft: "Черновик",
                sent: "Отправлен",
                confirmed: "Подтвержден",
                completed: "Выполнен",
                canceled: "Отменен",
            },
            deleteConfirm: {
                title: "Удалить заказ",
                text: "Вы уверены, что хотите удалить заказ на %s?",
                okText: "Да, удалить",
            },
            noOrders: "Нет заказов",
            ingredient: {
                title: "Каталог ингредиентов",
                primary: "Основной",
                amountRange: "Фасовка",
                categoryTypes: {
                    withoutCategory: "Без категории",
                    semiFinished: "Полуфабрикаты",
                    products: "Продукты",
                    packaging: "Упаковка",
                    householdExpenses: "Хозяйственные расходы",
                },
            },
        },
        order: {
            from: "Из",
            in: "В",
            addTitle: "Новый заказ",
            title: "Редактировать заказ",
            showTitle: "Просмотр заказа",
            notFound: "Заказ не найден",
            export: "Заказ поставщику",
            customer: "Поставщик",
            customerInn: "ИНН: %s",
            orderDate: "Дата создания",
            deliveryDate: "Дата поставки",
            status: "Статус",
            selectCustomer: "Выберите поставщика",
            noCustomers: "Нет поставщиков",
            noGroups: "Нет групп товаров",
            noSearchResults: "Ничего не найдено",
            emptyCart: 'Корзина пуста. Перейдите на вкладку "Каталог", чтобы добавить товары.',
            noProducts: "Нет товаров",
            search: "Поиск",
            store: "Склад",
            comment: "Комментарий",
            dueDate: "Срок оплаты",
            customsDeclarationNumber: "Номер ГТД",
            deleteOrder: "Удалить заказ",
            inn: "ИНН",
            cart: "Корзина",
            catalog: "Каталог",
            ingredients: "Ингредиенты",
            buttons: {
                sendToIiko: "Накладная",
                sendIngredientsToIiko: "Отправить ингредиенты в Iiko",
                export: "Экспорт в Excel",
                cancel: "Отменить",
                save: "Сохранить",
            },
            actions: {
                delete: "Удалить",
            },
            groups: {
                title: "Группы товаров",
                search: "Поиск товаров",
            },
            fields: {
                selectedProducts: "Выбранные товары",
                product: "Продукт",
                container: "Контейнер",
                quantity: "Кол-во",
                measureUnit: "Ед. изм.",
                price: "Цена",
                totalPrice: "Сумма",
                unitPrice: "Цена за ед.",
                actions: "Действия",
                user: "Пользователь",
                orderDate: "Дата создания",
                orderNumber: "Номер заказа",
                status: "Статус",
            },
            statuses: {
                created: "Черновик",
                delivered: "Отправлен в Iiko",
            },
            errors: {
                loadIngredients: "Не удалось загрузить ингредиентов",
                loadStoresFailed: "Не удалось загрузить список складов.",
                deleteOrder: "Не удалось удалить заказ!",
                exportExcel: "Не удалось экспортировать заказ в Excel!",
                getOrder: "Не удалось получить информацию о заказе!",
                noItems: "В заказе должна быть хотя бы одна позиция",
                noItemsInGroup: "Нет доступных товаров",
                noCustomer: "Выберите поставщика",
                getNomenclatureGroups: "Не удалось получить группы товаров!",
                updateOrder: "Не удалось обновить заказ!",
                createOrder: "Не удалось создать заказ!",
                searchNomenclature: "Не удалось выполнить поиск по номенклатуре",
                getCustomers: "Не удалось загрузить список поставщиков",
                loadNomenclatureGroups: "Не удалось загрузить группы номенклатуры",
                loadNomenclatureGroupItems: "Не удалось загрузить элементы группы",
            },
            success: {
                updateOrder: "Заказ успешно обновлен",
                createOrder: "Заказ успешно создан",
                deleteOrder: "Заказ успешно удален",
            },
            order: {
                noItems: "Нет товаров в заказе",
            },
            deleteConfirm: {
                title: "Удалить заказ",
                text: "Вы уверены, что хотите удалить заказ?",
                okText: "Да, удалить",
            },
            ingredient: {
                title: "Каталог ингредиентов",
                primary: "Основной",
                amountRange: "Фасовка",
                allIngredients: "Все ингредиенты",
                noResults: "По запросу ничего не найдено",
                noIngredients: "Нет доступных ингредиентов",
                searchPlaceholder: "Поиск ингредиентов...",
                emptyMessage: "Нет доступных ингредиентов в этой категории",
                categoryTypes: {
                    withoutCategory: "Без категории",
                    semiFinished: "Полуфабрикаты",
                    products: "Продукты",
                    packaging: "Упаковка",
                    householdExpenses: "Хозяйственные расходы",
                },
            },
        },
        personal: {
            title: "Мои заказы с фабрики кухни",
            showTitle: "Просмотр заказа",
            officeTradePointName: "Офис УК",
            tradePointFilter: "Место поставки",
        },
        tradePoints: {
            title: "Заказы поставщикам",
            showTitle: "Просмотр заказа",
            officeTradePointName: "Офис УК",
            tradePointFilter: "Место поставки",
            employee: "работник",
        },
        sendToIikoModal: {
            title: "Отправка заказа в Iiko",
            itemsTitle: "Товары к отправке",
            noRecordsText: "Нет товаров",
            total: "Итого",
            cnt: "шт",
            pack: "уп",
            kg: "кг",
            files: "Прикрепленные файлы",
            fields: {
                isCash: "Наличные",
                customer: "Поставщик",
                customerInn: "ИНН поставщика",
                orderNumber: "Номер заказа",
                acceptanceDate: "Дата получения товара",
                invoiceDate: "Дата счет-фактуры",
                invoiceNumber: "Счет-фактура",
                store: "Склад",
                comment: "Комментарий",
                incomingDocumentNumber: "Вход. документ №",
                employeeId: "Зачесть сотруднику",
                conception: "Концепция",
                dueDate: "Срок оплаты",
                documentNumber: "Номер документа",
                ingredients: "Ингредиенты",
            },
            itemFields: {
                name: "Наименование",
                quantity: "Кол-во в ед.",
                units: "Единицы измерения: портал ➜ iiko",
                price: "Цена за ед. с НДС",
                sum: "Сумма с НДС",
                vatPercent: "НДС %",
                customsDeclarationNumber: "Номер ГТД",
                actualQuantity: "Фактич. кол-во",
                priceWithoutVat: "Цена без НДС",
                vatSum: "Сумма НДС",
            },
            buttons: {
                send: "Отправить в Iiko",
                addProduct: "Добавить товар",
                cancel: "Отмена",
            },
            addProductTitle: "Добавить товар",
            searchPlaceholder: "Поиск товара",
            noResults: "Нет результатов",
            errors: {
                invalidData: "Пожалуйста, проверьте введенные данные.",
                invalidPrice: "Некорректная цена",
                invalidQuantity: "Некорректное количество",
                missingIikoId: "У товара отсутствует Iiko ID",
                missingGuid: "У товара отсутствует GUID для отправки в Iiko",
                noItems: "Не выбраны товары для отправки.",
                sendFailed: "Не удалось отправить заказ в Iiko.",
                loadStoresFailed: "Не удалось загрузить список складов.",
                invalidStructure: "Ошибка структуры товара. Обратитесь к администратору.",
                cashSupplierNotFound: "Поставщик для наличных не найден",
                invalidVatPercent: "Некорректный НДС для",
                noProducers: "У ингредиента нет производителей",
                userWithoutIikoUserId:
                    "У пользователя отсутствует iikoUserId. Это означает, что пользователь отсутствует в iiko, либо его данные не были обновлены.",
            },
            success: {
                sent: "Заказ успешно отправлен в Iiko.",
            },
            noItem: "Нет товаров",
            alreadySendWarning: "Накладная уже была отправлена",
        },
    },
    equipment: {
        title: "Реестр оборудования",
        generalRegister: "Общий реестр",
        departmentRegister: "Оборудование подразделения",
        personalRegister: "Личное оборудование",
        showArchived: "Показывать архивные",
        status: {
            active: "Активное",
            inactive: "Неактивное",
            underMaintenance: "На обслуживании",
            retired: "Списано",
            lost: "Утеряно",
        },
        fields: {
            name: "Название",
            description: "Описание",
            additionalInfo: "Дополнительная информация",
            serialNumber: "Серийный номер",
            inventoryNumber: "Инвентарный номер",
            purchaseDate: "Дата покупки",
            serviceEndDate: "Дата окончания службы",
            purchaseCost: "Стоимость покупки",
            estimatedValue: "Остаточная стоимость",
            isMovable: "Перемещаемое",
            isReplacement: "Подменное",
            responsibleUser: "МОЛ",
            department: "Подразделение",
            status: "Статус",
            isArchived: "Архивное",
            image: "Фото оборудования",
            files: "Прикрепленные файлы",
            equipmentType: "Тип оборудования",
            equipmentModel: "Модель оборудования",
            date: "Дата",
            fromDepartment: "Откуда",
            fromUser: "От кого",
            to: "Куда",
            reason: "Причина",
            type: "Тип",
            cost: "Стоимость",
            performedBy: "Исполнитель",
            spareParts: "Запчасти",
            actions: "Действия",
            toDepartment: "Куда",
            toUser: "Кому",
        },
        tabs: {
            generalRegister: "Основная информация",
            history: "История",
            maintenance: "Обслуживание",
            movements: "Перемещения",
        },
        actions: {
            add: "Добавить оборудование",
            edit: "Редактировать",
            cancel: "Отменить",
            delete: "Удалить",
            move: "Переместить",
            back: "Назад",
            addMaintenance: "Добавить обслуживание",
            export: "Экспорт в Excel",
            view: "Просмотр",
            archive: "Архивировать",
            unarchive: "Восстановить",
            save: "Сохранить",
            saving: "Сохранение...",
            print: "Печать",
        },
        messages: {
            deleteEquipment: "Вы уверены, что хотите удалить оборудование",
            noMovements: "История перемещений оборудования будет отображаться здесь.",
            saved: "Оборудование сохранено",
            deleted: "Оборудование удалено",
            moved: "Оборудование перемещено",
            maintenanceAdded: "Запись об обслуживании добавлена",
            noMaintenance: "История обслуживания оборудования будет отображаться здесь.",
            errorLoadingEquipment: "Ошибка при загрузке оборудования",
            errorSavingEquipment: "Ошибка при сохранении оборудования",
            errorExportingEquipment: "Ошибка при экспорте оборудования",
            errorDeletingEquipment: "Ошибка при удалении оборудования",
            errorArchivingEquipment: "Ошибка при архивировании оборудования",
            errorMovingEquipment: "Ошибка при перемещении оборудования",
            errorAddingMaintenance: "Ошибка при добавлении записи об обслуживании",
            equipmentMoved: "Оборудование успешно перемещено",
            loading: "Загрузка...",
            noHistory: "Записи отсутствуют",
        },
    },
    hr: {
        mailingTelegram: {
            title: "Рассылка в Telegram",
            fields: {
                role: "По роли",
                ownerType: "По типу управления",
                tradePoint: "По кофейне",
                messageText: "Текст сообщения",
                welcomeMessageText: "Текст приветственного сообщения",
                exitSurveyMessageText: "Текст сообщения при увольнении",
                templateTitle: "Название шаблона",
                files: "Файлы",
            },
            forms: {
                mailing: {
                    title: "Рассылка по ролям",
                    description:
                        "Создайте шаблон сообщения для рассылки пользователям определенной роли",
                },
                template: {
                    title: "Шаблоны рассылок",
                    description: "Создайте и управляйте шаблонами сообщений для рассылок",
                },
                welcome: {
                    title: "Приветственное сообщение",
                    description:
                        "Создайте шаблон приветственного сообщения для новых пользователей в Telegram",
                },
                exitSurvey: {
                    title: "Сообщение при увольнении",
                    description: "Создайте шаблон сообщения при увольнении для сотрудников",
                },
            },
            tabs: {
                mailing: "Рассылки",
                welcome: "Приветственные сообщения",
                exitSurvey: "Сообщение при увольнении",
            },
            buttons: {
                reset: "Сбросить",
                createTemplate: "Создать шаблон",
                updateTemplate: "Обновить шаблон",
                createMailingTemplate: "Создать шаблон рассылки",
                createWelcomeTemplate: "Создать приветственный шаблон",
                createExitSurveyTemplate: "Создать шаблон сообщения при увольнении",
                sendMailing: "Отправить рассылку",
                sendWelcome: "Отправить приветственное сообщение",
                updateMailingTemplate: "Обновить шаблон рассылки",
                updateWelcomeTemplate: "Обновить приветственный шаблон",
            },
            messages: {
                templateCreated: "Шаблон успешно создан",
                templateUpdated: "Шаблон успешно обновлен",
                mailingTemplateCreated: "Шаблон рассылки успешно создан",
                welcomeTemplateCreated: "Приветственный шаблон успешно создан",
                errorCreatingTemplate: "Ошибка при создании шаблона",
                errorUpdatingTemplate: "Ошибка при обновлении шаблона",
                errorCreatingMailingTemplate: "Ошибка при создании шаблона рассылки",
                errorCreatingWelcomeTemplate: "Ошибка при создании приветственного шаблона",
            },
            errors: {
                errorLoadingWelcomeTemplate: "Ошибка при загрузке приветственного шаблона",
                errorLoadingTemplates: "Ошибка при загрузке шаблонов",
                errorSendingMailing: "Ошибка при отправке рассылки",
                errorUpdatingWelcomeTemplate: "Ошибка при обновлении приветственного шаблона",
                errorUpdatingTemplate: "Ошибка при обновлении шаблона",
                errorCreatingTemplate: "Ошибка при создании шаблона",
            },
            success: {
                mailingSent: "Рассылка успешно отправлена",
                welcomeTemplateUpdated: "Приветственный шаблон успешно обновлен",
                templateCreated: "Шаблон успешно создан",
                templateUpdated: "Шаблон успешно обновлен",
            },
        },
        staffLevel: {
            title: "Укомплектованность персонала",
            tabs: {
                staffData: "Данные персонала",
                analytics: "Аналитика",
            },
            fields: {
                coffeeShop: "Кофейня",
                staffPlan: "План сотрудников",
                summerStaffPlan: "План сотрудников в летний сезон",
                officiallyEmployed: "Официально трудоустроенные",
                unofficially: "Неофициально",
                intern: "Стажер",
                slatedForDismissal: "Намечены к увольнению",
                manager: "Менеджер",
                baristaDay: "Бариста день",
                baristaNight: "Бариста ночь",
                cashier: "Кассир",
                cookDay: "Повар день",
                cookNight: "Повар ночь",
                universalDay: "Универсал день",
                universalNight: "Универсал ночь",
                relatedWorker: "Смежник",
                waiter: "Официант",
            },
            forms: {
                staffData: {
                    title: "Данные о персонале",
                    description: "Заполните данные о количестве сотрудников по категориям",
                },
            },
            groups: {
                staffData: "Заполняет ТД",
            },
            buttons: {
                save: "Сохранить",
                reset: "Сбросить",
                createPlan: "Создать план",
                updatePlan: "Обновить план",
                saving: "Сохранение...",
                savingPlan: "Сохранение плана...",
            },
            errors: {
                saveError: "Ошибка при сохранении данных",
                createPlanFirst: "Сначала создайте/обновите план сотрудников",
                insertTradePoint: "Не выбрана кофейня",
                loadData: "Ошибка при загрузке данных",
            },
            success: {
                dataSaved: "Данные успешно сохранены",
            },
        },
        staffAnalytics: {
            period: {
                current: "Текущая неделя",
                weekAgoSuffix: "неделя назад",
            },
            loading: "Загрузка данных...",
            cards: {
                actualEmployees: "Факт сотрудников",
                openVacancies: "Открытые вакансии",
                scheduledForDismissal: "Намечено к увольнению",
                interns: "Стажёры",
            },
            filters: {
                period: "Период",
                cities: "Города",
                all: "Все",
                allCities: "Все города",
                tradePoint: "Кофейня",
            },
            charts: {
                expectedCompletion: "Ожидаемая укомплектованность",
                actualCompletion: "Укомплектованность, факт",
                employmentStatus: "Статус трудоустройства",
                completionByCity: "% Укомплектованности",
                staffByCity: "Штат",
                vacanciesCount: "Кол-во открытых вакансий",
                applicationsByPositions: "Заявка по должностям",
                employedOfficially: "Официально устроено",
                employedUnofficially: "Неофициально устроено",
                factUk: "Факт УК",
                expectedUk: "Ожидаемая УК",
                staffPlan: "План сотрудников",
                staffFact: "Факт сотрудников",
            },
        },
        vacancies: {
            title: "Вакансии",
            addVacancies: "Добавить вакансию",
            scheduleType: "График",
            huntflowVacancyId: "ID вакансии в Huntflow",
            rate: "Размер ставки",
            errors: {
                errorLoadingScheduleTypes: "Ошибка при загрузке типов графика",
                errorLoadingTitleTypes: "Ошибка при загрузке типов вакансий",
            },
        },
        vacancyTitleTypes: {
            title: "Названия вакансий (справочник)",
            fields: {
                title: "Название",
                sortOrder: "Порядок",
            },
        },
        tradePointPlans: {
            title: "Планы найма по кофейням",
            analysisTitle: "Аналитика",
            analysisGroupTitle: "Аналитика по регионам",
            users: {
                title: "Сотрудники",
                toConfig: "К списку сотрудников",
                isOfficial: "Официально",
                isNotOfficial: "Неофициально",
                statuses: {
                    active: "Сотрудник",
                    probationer: "Стажер",
                    toDismiss: "Намечен на увольнение",
                },
            },
            addTitle: "Добавить план найма",
            planned: "План сотрудников (В ШЕ)",
            plannedOfficial: "План трудоустроенных",

            analytics: {
                title: "Аналитика",
                staffingLevel: "Укомплектованность",
                expectedStaffingLevel: "Ожидаемая укомплектованность",
                planned: "План в ШЕ",
                actualFte: "Факт ШЕ",
                plannedDismissalsFte: "Намечены на увольнение (ШЕ)",
                requiredVacanciesFte: "Вакансий необходимо (в ШЕ)",
                actualVacanciesFte: "Вакансии факт ШЕ",
                actualVacanciesHeadcount: "Вакансии Факт чел",
                officiallyEmployedCount: "Кол-во официально устроенных",
                medicalBooksCount: "Медкнижки",
                traineesCount: "Кол-во стажеров",
                actualEmployeesCount: "Факт сотрудников (чел)",
                plannedOfficial: "Норма трудоустроенных (линейка)",
                understaffingPercent: "% неукомплекта",
                addVacancies: {
                    title: "Добавить вакансию",
                    tooltip: "Добавить вакансию",
                    success: "Вакансия успешно добавлена",
                    error: "Ошибка при добавлении вакансии",
                },
            },
            deleteConfirm: {
                title: "Удалить план найма",
                text: 'Вы уверены, что хотите удалить план найма для кофейни "%s"?',
                okText: "Да, удалить",
            },
            success: {
                remove: 'План найма для кофейни "%s" успешно удален',
                add: "Кофейня успешно добавлена",
                update: "План найма успешно обновлен",
            },
            errors: {
                remove: 'Ошибка при удалении плана найма для кофейни "%s"!',
                add: "Ошибка при добавлении плана найма для кофейни!",
                update: "Ошибка при обновлении плана найма для кофейни!",
            },
        },
    },
    Wazzup: {
        title: "Рассылка сообщений в Wazzup",
        placeholder: {
            numbers: "Номера телефонов",
            message: "Сообщение",
        },
        errors: {
            phonesLength: "Нет валидных номеров",
            sendMessages: "Ошибка при отправке сообщений",
        },
        success: {
            sent: "Сообщения отправлены",
        },
        button: {
            send: "Отправить",
            reset: "Сбросить",
        },
    },
    WazzupContacts: {
        title: "Контакты Wazzup",
        fields: {
            id: "ID контакта",
            responsibleUserId: "ID ответственного",
            name: "Имя",
            uri: "Ссылка CRM",
            contactData: "Каналы",
            chatType: "Тип канала",
            chatId: "Идентификатор",
            username: "Логин",
            phone: "Телефон",
        },
        modal: {
            addTitle: "Новый контакт",
            editTitle: "Редактирование контакта",
            contactDataTitle: "Каналы связи",
            addChannel: "Добавить канал",
        },
        chatTypes: {
            whatsapp: "WhatsApp",
            whatsgroup: "Группа WhatsApp",
            viber: "Viber",
            instagram: "Instagram",
            telegram: "Telegram",
            telegroup: "Группа Telegram",
            vk: "ВКонтакте",
            avito: "Авито",
        },
        errors: {
            limitNotice: "Отображены только первые %s контактов. Уточните фильтр.",
            load: "Не удалось получить список контактов.",
            required: "Поле обязательно к заполнению",
            invalidUrl: "Укажите корректную ссылку",
            contactDataEmpty: "Добавьте хотя бы один канал связи",
            invalidPhone: "Укажите номер телефона только цифрами",
            loadRecord: "Не удалось получить данные контакта.",
            notFound: "Контакт не найден.",
            save: "Не удалось сохранить контакт.",
            delete: "Не удалось удалить контакт.",
            sync: "Не удалось синхронизировать контакты.",
        },
        success: {
            saved: "Контакт сохранён",
            deleted: "Контакт удалён",
            deletedMany: "Удалено %s контактов",
            synced: "Синхронизировано %s контактов",
        },
        notifications: {
            bulkDeletePartial: "Не найдены контакты: %s",
        },
        empty: {
            list: "Контакты не найдены",
            contactData: "Нет каналов",
        },
        buttons: {
            openChat: "Открыть чат",
            sync: "Синхронизировать",
        },
        search: {
            placeholder: "Поиск (ID, имя, канал)",
        },
    },
    knowledge: {
        title: "База знаний",
        header: {
            allAnswers: "Все ответы",
            inKnowledgeBase: "- в базе знаний",
        },
        search: {
            placeholder: "Поиск даже по одному слову :)",
            notFound: "Мы старались, но ничего не нашли. Попробуйте поискать по-другому.",
        },
        article: {
            title: "Статья",
            notFound: "Статья не найдена",
            changeDate: "Изменение",
            owner: "Владелец",
            articleType: "Вид статьи",
            standard: "стандарт",
            status: "Статус",
            mandatory: "Обязательно к ознакомлению",
            read: "Ознакомлен",
            purpose: "Цель статьи",
            purposeText: "Контроль качества через установление стандарта.",
            forWhom: "Для кого",
            files: "Файлы для скачивания",
            confirmReading: "Ознакомление подтверждаю",
            errorConfirmReading: "Ошибка при подтверждении прочтения",
            downloadReport: "Скачать отчет по ознакомлению",
        },
        editor: {
            createType: "Создать тип",
            typeRequired: "Обязательно выберите тип статьи",
            createCategory: "Создать категорию",
            title: "Редактор статьи",
            titleField: "Заголовок",
            category: "Категория",
            features: "Доступ",
            groupField: "Группа",
            selectGroup: "Выберите...",
            content: "Контент",
            save: "Сохранить",
            saved: "Сохранено!",
            createGroup: "Создать группу",
            create: "Создать статью",
            image: "Изображение",
            edit: "Редактировать",
            hasIntroduction: "Ознакомление с статьей обязательно",
            author: "Автор",
            categoryRequired: "Обязательно выберите категорию",
            noDataText: "— выберите категорию —",
            featuresRequired: "Обязательно выберите доступ",
            noDataTextFeatures: "— выберите доступ —",
        },
        categories: {
            commonStandards: "Общие стандарты",
            retailStandards: "Стандарты розничной сети",
            managementStandards: "Стандарты управления",
            ukStandards: "Стандарты УК",
        },
        group: {
            ungrouped: "Без группы",
        },
        errors: {
            loadFailed: "Не удалось загрузить статьи",
            searchFailed: "Не удалось выполнить поиск",
        },
    },
};

export default ruPages;
